import { h, Fragment } from 'preact';
import LetterIconsGenerated from './letter-icons-generated';
import { getBrandColor } from '../../../utils/helpers';
import { cn } from '../../../utils/helpers';

const IconsUnsorted = {
  twitter: ({ classname = '', fill = 'white', stroke = 'none', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill}
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_2652_2742)">
        <path
          d="M19.248 1H22.9823L14.783 10.3358L24.3624 23H16.845L10.9594 15.3041L4.2214 23H0.487085L9.17343 13.0148L0 1H7.70406L13.0214 8.03026L19.248 1ZM17.941 20.8081H20.0111L6.61624 3.1107H4.39188L17.941 20.8081Z"
          stroke={stroke}
        />
      </g>
      <defs>
        <clipPath id="clip0_2652_2742">
          <rect width="24" height="24" fill={fill} />
        </clipPath>
      </defs>
    </svg>
  ),

  twitterReverse: ({ classname = '', fill = 'none', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={fill}
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_5452_51)">
        <path
          d="M17.2481 -1H20.9824L12.7831 8.33579L22.3625 21H14.8451L8.95953 13.3041L2.22152 21H-1.51279L7.17355 11.0148L-1.99988 -1H5.70418L11.0215 6.03026L17.2481 -1ZM15.9411 18.8081H18.0112L4.61636 1.1107H2.392L15.9411 18.8081Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_5452_51">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  facebook: ({ classname = '', fill = 'white', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill}
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_2652_2745)">
        <path
          d="M24 1.32321V22.6714C24 23.4054 23.4054 23.9946 22.6768 23.9946H16.5589V14.7054H19.6768L20.1429 11.0839H16.5536V8.76964C16.5536 7.71964 16.8429 7.00714 18.3482 7.00714H20.2661V3.76607C19.9339 3.72321 18.7982 3.62143 17.4696 3.62143C14.7054 3.62143 12.8089 5.30893 12.8089 8.41071V11.0839H9.68036V14.7054H12.8089V24H1.32321C0.594643 24 0 23.4054 0 22.6768V1.32321C0 0.594643 0.594643 0 1.32321 0H22.6714C23.4054 0 24 0.594643 24 1.32321Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2652_2745">
          <rect width="24" height="24" fill={fill} />
        </clipPath>
      </defs>
    </svg>
  ),

  facebookReverse: ({ classname = '', fill = 'none', ...props }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_5452_49)">
        <path
          d="M20 1.10268V18.8929C20 19.5045 19.5045 19.9955 18.8973 19.9955H13.7991V12.2545H16.3973L16.7857 9.23661H13.7946V7.30804C13.7946 6.43304 14.0357 5.83929 15.2902 5.83929H16.8884V3.13839C16.6116 3.10268 15.6652 3.01786 14.558 3.01786C12.2545 3.01786 10.6741 4.42411 10.6741 7.00893V9.23661H8.06696V12.2545H10.6741V20H1.10268C0.495536 20 0 19.5045 0 18.8973V1.10268C0 0.495536 0.495536 0 1.10268 0H18.8929C19.5045 0 20 0.495536 20 1.10268Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_5452_49">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  instagram: ({ classname = '', fill = 'white', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="28"
      viewBox="0 0 24 28"
      fill={fill}
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_2652_2747)">
        <path
          d="M12.0055 7.83938C8.59833 7.83938 5.85011 10.5876 5.85011 13.9947C5.85011 17.4019 8.59833 20.1501 12.0055 20.1501C15.4126 20.1501 18.1608 17.4019 18.1608 13.9947C18.1608 10.5876 15.4126 7.83938 12.0055 7.83938ZM12.0055 17.9965C9.80368 17.9965 8.00368 16.2019 8.00368 13.9947C8.00368 11.7876 9.79833 9.99296 12.0055 9.99296C14.2126 9.99296 16.0073 11.7876 16.0073 13.9947C16.0073 16.2019 14.2073 17.9965 12.0055 17.9965ZM19.8483 7.5876C19.8483 8.38581 19.2055 9.02331 18.4126 9.02331C17.6144 9.02331 16.9769 8.38046 16.9769 7.5876C16.9769 6.79474 17.6198 6.15188 18.4126 6.15188C19.2055 6.15188 19.8483 6.79474 19.8483 7.5876ZM23.9251 9.04474C23.834 7.12153 23.3948 5.41795 21.9858 4.01438C20.5823 2.61081 18.8787 2.17153 16.9555 2.0751C14.9733 1.9626 9.03226 1.9626 7.05011 2.0751C5.13225 2.16617 3.42868 2.60545 2.01975 4.00903C0.610826 5.4126 0.176897 7.11617 0.0804687 9.03938C-0.0320312 11.0215 -0.0320312 16.9626 0.0804687 18.9447C0.17154 20.868 0.610826 22.5715 2.01975 23.9751C3.42868 25.3787 5.1269 25.818 7.05011 25.9144C9.03226 26.0269 14.9733 26.0269 16.9555 25.9144C18.8787 25.8233 20.5823 25.384 21.9858 23.9751C23.3894 22.5715 23.8287 20.868 23.9251 18.9447C24.0376 16.9626 24.0376 11.0269 23.9251 9.04474ZM21.3644 21.0715C20.9465 22.1215 20.1376 22.9305 19.0823 23.3537C17.5019 23.9805 13.7519 23.8358 12.0055 23.8358C10.259 23.8358 6.50368 23.9751 4.92868 23.3537C3.87868 22.9358 3.06975 22.1269 2.64654 21.0715C2.01975 19.4912 2.1644 15.7412 2.1644 13.9947C2.1644 12.2483 2.02511 8.49295 2.64654 6.91795C3.0644 5.86795 3.87333 5.05903 4.92868 4.63581C6.50904 4.00903 10.259 4.15367 12.0055 4.15367C13.7519 4.15367 17.5073 4.01438 19.0823 4.63581C20.1323 5.05367 20.9412 5.8626 21.3644 6.91795C21.9912 8.49831 21.8465 12.2483 21.8465 13.9947C21.8465 15.7412 21.9912 19.4965 21.3644 21.0715Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2652_2747">
          <rect
            width="24"
            height="27.4286"
            fill={fill}
            transform="translate(0 0.285767)"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  linkedinReverse: ({ classname = '', fill = 'none', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={fill}
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_5452_54)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.7778 20H2.22222C0.994923 20 0 19.0051 0 17.7778V2.22222C0 0.994923 0.994923 0 2.22222 0H17.7778C19.0051 0 20 0.994923 20 2.22222V17.7778C20 19.0051 19.0051 20 17.7778 20ZM14.2543 17.2222H17.2222V11.1253C17.2222 8.54569 15.7599 7.29839 13.7174 7.29839C11.6739 7.29839 10.8139 8.8897 10.8139 8.8897V7.59259H7.9537V17.2222H10.8139V12.1673C10.8139 10.8128 11.4374 10.0068 12.6308 10.0068C13.7277 10.0068 14.2543 10.7813 14.2543 12.1673V17.2222ZM2.77778 4.55472C2.77778 5.53602 3.56724 6.33167 4.54149 6.33167C5.51573 6.33167 6.30472 5.53602 6.30472 4.55472C6.30472 3.57343 5.51573 2.77778 4.54149 2.77778C3.56724 2.77778 2.77778 3.57343 2.77778 4.55472ZM6.04706 17.2222H3.0646V7.59259H6.04706V17.2222Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_5452_54">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  whatsappReverse: ({ classname = '', fill = 'none', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={fill}
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_5452_58)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.35402 9.74953C0.35402 4.37359 4.76079 -6.10352e-05 10.1774 -6.10352e-05C15.5936 -6.10352e-05 20 4.37359 20 9.74953C20 15.1249 15.5936 19.4981 10.1775 19.498C8.55308 19.498 6.94801 19.0975 5.52787 18.3387L0.338241 19.9878C0.312397 19.9961 0.285903 20 0.259604 20C0.190968 20 0.123759 19.9728 0.0742138 19.9222C0.00557716 19.8523 -0.0177996 19.7497 0.0136291 19.6569L1.70084 14.6799C0.819347 13.1903 0.35402 11.4883 0.35402 9.74953ZM5.89586 16.1907C7.16847 17.0258 8.64893 17.4672 10.1774 17.4672C14.4674 17.4672 17.9575 14.0051 17.9574 9.74953C17.9574 5.49347 14.4673 2.03086 10.1774 2.03086C5.88697 2.03086 2.39643 5.49347 2.39643 9.74953C2.39643 11.3854 2.90871 12.9499 3.8778 14.274C3.9278 14.3423 3.94137 14.4307 3.91423 14.5108L3.07501 16.9868L5.67469 16.1604C5.70047 16.1522 5.72697 16.1482 5.75339 16.1482C5.80339 16.1482 5.85307 16.1626 5.89586 16.1907ZM14.75 11.4684C14.778 11.4821 14.7951 11.4904 14.7989 11.4923L14.799 11.4923C14.9899 11.584 15.1407 11.6564 15.2282 11.8002C15.356 12.0119 15.3054 12.595 15.1133 13.1287C14.8695 13.8063 13.7975 14.3617 13.3097 14.405L13.2382 14.4118C13.1254 14.4229 12.9975 14.4355 12.8378 14.4355H12.8377C12.4576 14.4355 11.7889 14.3703 10.3769 13.8062C8.91021 13.2203 7.46339 11.9642 6.3028 10.2693C6.29943 10.2643 6.29623 10.2597 6.29322 10.2552C6.27826 10.2333 6.26764 10.2178 6.26137 10.2094C5.95831 9.80998 5.25247 8.75978 5.25247 7.6475C5.25247 6.41165 5.84403 5.70892 6.19371 5.48846C6.52345 5.28061 7.26923 5.18242 7.40618 5.17664C7.4874 5.17322 7.49598 5.17227 7.50458 5.17201C7.50788 5.1719 7.5112 5.1719 7.51865 5.1719C7.80767 5.1719 8.01566 5.34729 8.17306 5.72398C8.18877 5.76145 8.23617 5.87549 8.29961 6.02816C8.50054 6.51164 8.86245 7.38249 8.88865 7.4349C8.93067 7.5173 9.06067 7.7725 8.90846 8.0749L8.87579 8.14055L8.87561 8.14092C8.81335 8.26713 8.75957 8.37615 8.63891 8.51653C8.60014 8.56133 8.56066 8.60887 8.52125 8.65633L8.52102 8.6566C8.43785 8.75671 8.35189 8.86017 8.27255 8.93867C8.2454 8.96588 8.19281 9.01861 8.18709 9.03958C8.18711 9.03958 8.18714 9.03975 8.18719 9.04009C8.18768 9.04325 8.1905 9.06139 8.21151 9.09718C8.3743 9.3727 9.56151 11.0065 11.1256 11.686C11.1939 11.7156 11.4196 11.8086 11.4326 11.8086C11.4472 11.8086 11.4715 11.7843 11.4892 11.7639C11.6255 11.61 12.0664 11.0946 12.212 10.8781C12.3409 10.6854 12.5063 10.5873 12.7031 10.5873C12.8237 10.5873 12.937 10.6243 13.0428 10.6623C13.2768 10.7465 14.4888 11.3404 14.75 11.4684Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_5452_58">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  mail: ({ classname = '', fill = 'none', stroke = 'black', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={fill}
      className={classname}
      {...props}
    >
      <path
        d="M18.3333 4.99998C18.3333 4.08331 17.5833 3.33331 16.6666 3.33331H3.33329C2.41663 3.33331 1.66663 4.08331 1.66663 4.99998M18.3333 4.99998V15C18.3333 15.9166 17.5833 16.6666 16.6666 16.6666H3.33329C2.41663 16.6666 1.66663 15.9166 1.66663 15V4.99998M18.3333 4.99998L9.99996 10.8333L1.66663 4.99998"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  plus: ({
    classname = '',
    fill = 'none',
    stroke = 'currentColor',
    ...props
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={fill}
      className={classname}
      {...props}
    >
      <path
        d="M8.00016 3.33325V12.6666M3.3335 7.99992H12.6668"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  minus: ({
    classname = '',
    fill = 'none',
    stroke = 'curentColor',
    ...props
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={fill}
      className={classname}
      {...props}
    >
      <path
        d="M3.3335 8H12.6668"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  footerArrow: ({ classname = '', fill = 'none', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill={fill}
      className={classname}
      {...props}
    >
      <path
        d="M8.00016 12.6667V3.33337M8.00016 3.33337L3.3335 8.00004M8.00016 3.33337L12.6668 8.00004"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  arrowLeft: ({ classname = '', fill = 'none', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={fill}
      className={classname}
      {...props}
    >
      <path
        d="M12.6668 8.00004H3.3335M3.3335 8.00004L8.00016 12.6667M3.3335 8.00004L8.00016 3.33337"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  chevronLeft: ({ classname = '', fill = 'none', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill={fill}
      className={classname}
      {...props}
    >
      <path
        d="M10 12L6 8L10 4"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  chevronRight: ({
    classname = '',
    fill = 'none',
    stroke = 'currentColor',
    ...props
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill={fill}
      className={classname}
      {...props}
    >
      <path
        d="M6 12L10 8L6 4"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  chevronRightThick: ({ classname = '', fill = 'none', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      fill={fill}
      className={classname}
      {...props}
    >
      <path
        d="M4.5 9L7.5 6L4.5 3"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  chevronUp: ({ classname = '', fill = 'none', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={fill}
      className={classname}
      {...props}
    >
      <path
        d="M12 10L8 6L4 10"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  package: ({ classname = '', fill = 'none', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M16.5 9.40002L7.5 4.21002M3.27 6.96002L12 12.01L20.73 6.96002M12 22.08V12M21 16V8.00002C20.9996 7.6493 20.9071 7.30483 20.7315 7.00119C20.556 6.69754 20.3037 6.44539 20 6.27002L13 2.27002C12.696 2.09449 12.3511 2.00208 12 2.00208C11.6489 2.00208 11.304 2.09449 11 2.27002L4 6.27002C3.69626 6.44539 3.44398 6.69754 3.26846 7.00119C3.09294 7.30483 3.00036 7.6493 3 8.00002V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9989C3.44398 17.3025 3.69626 17.5547 4 17.73L11 21.73C11.304 21.9056 11.6489 21.998 12 21.998C12.3511 21.998 12.696 21.9056 13 21.73L20 17.73C20.3037 17.5547 20.556 17.3025 20.7315 16.9989C20.9071 16.6952 20.9996 16.3507 21 16Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  x: ({ classname = '', fill = 'none', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      fill={fill}
      className={classname}
      {...props}
    >
      <path
        d="M9 3L3 9M3 3L9 9"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  xSquare: ({ classname = '', fill = 'none', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M6 6L10 10M10 6L6 10M3.33333 2H12.6667C13.403 2 14 2.59695 14 3.33333V12.6667C14 13.403 13.403 14 12.6667 14H3.33333C2.59695 14 2 13.403 2 12.6667V3.33333C2 2.59695 2.59695 2 3.33333 2Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  plusSquareNote: ({ classname = '', ...props }) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M6 3.5V8.5M3.5 6H8.5M2.5 1.5H9.5C10.0523 1.5 10.5 1.94772 10.5 2.5V9.5C10.5 10.0523 10.0523 10.5 9.5 10.5H2.5C1.94772 10.5 1.5 10.0523 1.5 9.5V2.5C1.5 1.94772 1.94772 1.5 2.5 1.5Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  search: ({
    classname = '',
    stroke = 'currentColor',
    fill = 'none',
    ...props
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill={fill}
      className={classname}
      {...props}
    >
      <path
        d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  search2: ({
    classname = '',
    stroke = 'currentColor',
    fill = 'none',
    ...props
  }) => (
    <svg
      width="117"
      height="120"
      viewBox="0 0 117 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <rect
        x="81.0859"
        y="82.1348"
        width="46.907"
        height="8.96323"
        rx="4.48162"
        transform="rotate(41.6398 81.0859 82.1348)"
        fill="currentColor"
      />
      <path
        d="M50.5312 0C78.4386 0.00014019 101.062 22.6238 101.062 50.5312C101.061 78.4386 78.4386 101.062 50.5312 101.062C22.6238 101.062 0.000111342 78.4387 0 50.5312C0 22.6237 22.6238 0 50.5312 0ZM50.4746 7.72852C26.6781 7.72852 7.38672 27.0199 7.38672 50.8164C7.38697 74.6127 26.6782 93.9033 50.4746 93.9033C74.2709 93.9033 93.5613 74.6127 93.5615 50.8164C93.5615 27.0199 74.2711 7.72858 50.4746 7.72852Z"
        fill="currentColor"
      />
      <path
        d="M93.5616 50.816C93.5616 74.6125 74.2707 93.9034 50.4741 93.9034C26.6776 93.9034 7.38672 74.6125 7.38672 50.816C7.38672 27.0194 26.6776 7.72852 50.4741 7.72852C74.2707 7.72852 93.5616 27.0194 93.5616 50.816Z"
        fill="transparent"
      />
    </svg>
  ),

  searchList: ({
    classname = '',
    stroke = 'currentColor',
    fill = 'none',
    ...props
  }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M14 13L11.825 10.825M13 8C13 10.2091 11.2091 12 9 12C6.79086 12 5 10.2091 5 8C5 5.79086 6.79086 4 9 4C11.2091 4 13 5.79086 13 8Z"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33398 4H3.33398M1.33398 8H2.33398M1.33398 12H3.33398"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  menu: ({ classname = '', stroke = '#000', fill = 'none', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill={fill}
      className={classname}
      {...props}
    >
      <path
        d="M2.5 15H17.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 10H17.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 5H17.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  user: ({ classname = '', stroke = '#000', fill = 'none', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 16"
      fill={fill}
      className={classname}
      {...props}
    >
      <path
        d="M13.8332 14V12.6667C13.8332 11.9594 13.5522 11.2811 13.0521 10.781C12.552 10.281 11.8737 10 11.1665 10H5.83317C5.12593 10 4.44765 10.281 3.94755 10.781C3.44746 11.2811 3.1665 11.9594 3.1665 12.6667V14M11.1665 4.66667C11.1665 6.13943 9.9726 7.33333 8.49984 7.33333C7.02708 7.33333 5.83317 6.13943 5.83317 4.66667C5.83317 3.19391 7.02708 2 8.49984 2C9.9726 2 11.1665 3.19391 11.1665 4.66667Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  userX: ({ classname = '', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_11588_434)">
        <path
          d="M10.666 14V12.6667C10.666 11.9594 10.3851 11.2811 9.88497 10.781C9.38487 10.281 8.70659 10 7.99935 10H3.33268C2.62544 10 1.94716 10.281 1.44706 10.781C0.946967 11.2811 0.666016 11.9594 0.666016 12.6667V14M11.9993 5.33333L15.3327 8.66667M15.3327 5.33333L11.9993 8.66667M8.33268 4.66667C8.33268 6.13943 7.13878 7.33333 5.66602 7.33333C4.19326 7.33333 2.99935 6.13943 2.99935 4.66667C2.99935 3.19391 4.19326 2 5.66602 2C7.13878 2 8.33268 3.19391 8.33268 4.66667Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11588_434">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  graphicsSearch: ({
    classname = '',
    stroke = '#000',
    fill = 'none',
    ...props
  }) => (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_4329_53693)">
        <mask id="path-1-inside-1_4329_53693" fill="white">
          <path d="M0.769531 7.05882C0.769531 3.16034 3.92987 0 7.82835 0H82.9415C86.8399 0 90.0003 3.16034 90.0003 7.05882V82.9412C90.0003 86.8397 86.8399 90 82.9415 90H7.82836C3.92988 90 0.769531 86.8397 0.769531 82.9412V7.05882Z" />
        </mask>
        <path
          d="M0.769531 4.90909C0.769531 2.19787 2.96741 0 5.67862 0H85.0912C87.8024 0 90.0003 2.19787 90.0003 4.90909V85.0909C90.0003 87.8021 87.8024 90 85.0912 90H5.67862C2.96741 90 0.769531 87.8021 0.769531 85.0909V4.90909Z"
          fill="white"
        />
        <mask id="path-4-inside-2_4329_53693" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.6429 73.2832C57.8139 73.2832 74.1657 56.9697 74.1657 36.846C74.1657 16.7222 57.8139 0.408691 37.6429 0.408691C17.4719 0.408691 1.12012 16.7222 1.12012 36.846C1.12012 56.9697 17.4719 73.2832 37.6429 73.2832ZM37.6427 63.1928C52.2279 63.1928 64.0515 51.3969 64.0515 36.8459C64.0515 22.2949 52.2279 10.4989 37.6427 10.4989C23.0576 10.4989 11.2339 22.2949 11.2339 36.8459C11.2339 51.3969 23.0576 63.1928 37.6427 63.1928Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.6429 73.2832C57.8139 73.2832 74.1657 56.9697 74.1657 36.846C74.1657 16.7222 57.8139 0.408691 37.6429 0.408691C17.4719 0.408691 1.12012 16.7222 1.12012 36.846C1.12012 56.9697 17.4719 73.2832 37.6429 73.2832ZM37.6427 63.1928C52.2279 63.1928 64.0515 51.3969 64.0515 36.8459C64.0515 22.2949 52.2279 10.4989 37.6427 10.4989C23.0576 10.4989 11.2339 22.2949 11.2339 36.8459C11.2339 51.3969 23.0576 63.1928 37.6427 63.1928Z"
          fill={getBrandColor()}
        />
        <path
          d="M72.9385 36.846C72.9385 56.2892 57.1388 72.0559 37.6429 72.0559V74.5105C58.489 74.5105 75.393 57.6502 75.393 36.846H72.9385ZM37.6429 1.63596C57.1388 1.63596 72.9385 17.4027 72.9385 36.846H75.393C75.393 16.0417 58.489 -0.818581 37.6429 -0.818581V1.63596ZM2.34739 36.846C2.34739 17.4027 18.147 1.63596 37.6429 1.63596V-0.818581C16.7968 -0.818581 -0.107156 16.0417 -0.107156 36.846H2.34739ZM37.6429 72.0559C18.147 72.0559 2.34739 56.2892 2.34739 36.846H-0.107156C-0.107156 57.6502 16.7968 74.5105 37.6429 74.5105V72.0559ZM62.8243 36.8459C62.8243 50.7164 51.5528 61.9655 37.6427 61.9655V64.4201C52.903 64.4201 65.2788 52.0774 65.2788 36.8459H62.8243ZM37.6427 11.7262C51.5528 11.7262 62.8243 22.9754 62.8243 36.8459H65.2788C65.2788 21.6143 52.903 9.27166 37.6427 9.27166V11.7262ZM12.4612 36.8459C12.4612 22.9754 23.7326 11.7262 37.6427 11.7262V9.27166C22.3825 9.27166 10.0067 21.6143 10.0067 36.8459H12.4612ZM37.6427 61.9655C23.7326 61.9655 12.4612 50.7164 12.4612 36.8459H10.0067C10.0067 52.0774 22.3825 64.4201 37.6427 64.4201V61.9655Z"
          fill="black"
          mask="url(#path-4-inside-2_4329_53693)"
        />
        <path
          d="M59.5566 65.9961L82.5941 89.5402"
          stroke="black"
          strokeWidth="1.22727"
        />
        <path
          d="M66.1533 59.1699L89.7527 82.714"
          stroke="black"
          strokeWidth="1.22727"
        />
      </g>
      <path
        d="M7.82835 1.5H82.9415V-1.5H7.82835V1.5ZM88.5003 7.05882V82.9412H91.5003V7.05882H88.5003ZM82.9415 88.5H7.82836V91.5H82.9415V88.5ZM2.26953 82.9412V7.05882H-0.730469V82.9412H2.26953ZM7.82836 88.5C4.7583 88.5 2.26953 86.0112 2.26953 82.9412H-0.730469C-0.730469 87.6681 3.10145 91.5 7.82836 91.5V88.5ZM88.5003 82.9412C88.5003 86.0112 86.0115 88.5 82.9415 88.5V91.5C87.6684 91.5 91.5003 87.6681 91.5003 82.9412H88.5003ZM82.9415 1.5C86.0115 1.5 88.5003 3.98877 88.5003 7.05882H91.5003C91.5003 2.33192 87.6684 -1.5 82.9415 -1.5V1.5ZM7.82835 -1.5C3.10145 -1.5 -0.730469 2.33192 -0.730469 7.05882H2.26953C2.26953 3.98877 4.7583 1.5 7.82835 1.5V-1.5Z"
        fill="black"
        mask="url(#path-1-inside-1_4329_53693)"
      />
      <defs>
        <clipPath id="clip0_4329_53693">
          <path
            d="M0.769531 7.05882C0.769531 3.16034 3.92987 0 7.82835 0H82.9415C86.8399 0 90.0003 3.16034 90.0003 7.05882V82.9412C90.0003 86.8397 86.8399 90 82.9415 90H7.82836C3.92988 90 0.769531 86.8397 0.769531 82.9412V7.05882Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  vegetarian: ({
    classname = '',
    stroke = '#000',
    fill = 'none',
    ...props
  }) => (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z"
        fill="black"
      />
      <path
        d="M11.7128 9.5L13.9558 16.584H14.0442L16.283 9.5H18L14.9616 18.5H13.0342L10 9.5H11.7128Z"
        fill="white"
      />
    </svg>
  ),
  benefitsFresh: ({ classname = '', useCurrentColor, ...props }) => (
    <svg
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_4040_20666)">
        <mask id="path-2-inside-1_4040_20666" fill="white">
          <path d="M0.255859 -0.459183H89.7344V9.90361C89.7344 34.6124 69.7039 54.6429 44.9951 54.6429V54.6429C20.2863 54.6429 0.255859 34.6124 0.255859 9.90361V-0.459183Z" />
        </mask>
        <path
          d="M0.255859 -0.459183H89.7344V9.90361C89.7344 34.6124 69.7039 54.6429 44.9951 54.6429V54.6429C20.2863 54.6429 0.255859 34.6124 0.255859 9.90361V-0.459183Z"
          fill={useCurrentColor ? 'currentColor' : getBrandColor()}
        />
        <path
          d="M0.255859 -0.459183V-1.95918H-1.24414V-0.459183H0.255859ZM89.7344 -0.459183H91.2344V-1.95918H89.7344V-0.459183ZM0.255859 1.04082H89.7344V-1.95918H0.255859V1.04082ZM88.2344 -0.459183V9.90361H91.2344V-0.459183H88.2344ZM1.75586 9.90361V-0.459183H-1.24414V9.90361H1.75586ZM44.9951 53.1429C21.1147 53.1429 1.75586 33.784 1.75586 9.90361H-1.24414C-1.24414 35.4408 19.4579 56.1429 44.9951 56.1429V53.1429ZM88.2344 9.90361C88.2344 33.784 68.8755 53.1429 44.9951 53.1429V56.1429C70.5323 56.1429 91.2344 35.4408 91.2344 9.90361H88.2344Z"
          fill="black"
          mask="url(#path-2-inside-1_4040_20666)"
        />
        <path
          d="M1.17871 98.7245L45.3202 54.6429L89.7347 98.7245L1.17871 98.7245Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <mask id="path-5-inside-2_4040_20666" fill="white">
          <path d="M0.435547 8C0.435547 3.58172 4.01727 0 8.43555 0H81.6663C86.0846 0 89.6663 3.58172 89.6663 8V81.8112C89.6663 86.2295 86.0846 89.8112 81.6663 89.8112H8.43555C4.01727 89.8112 0.435547 86.2295 0.435547 81.8112V8Z" />
        </mask>
        <path
          d="M8.43555 1.5H81.6663V-1.5H8.43555V1.5ZM88.1663 8V81.8112H91.1663V8H88.1663ZM81.6663 88.3112H8.43555V91.3112H81.6663V88.3112ZM1.93555 81.8112V8H-1.06445V81.8112H1.93555ZM8.43555 88.3112C4.8457 88.3112 1.93555 85.4011 1.93555 81.8112H-1.06445C-1.06445 87.0579 3.18885 91.3112 8.43555 91.3112V88.3112ZM88.1663 81.8112C88.1663 85.4011 85.2562 88.3112 81.6663 88.3112V91.3112C86.913 91.3112 91.1663 87.0579 91.1663 81.8112H88.1663ZM81.6663 1.5C85.2562 1.5 88.1663 4.41015 88.1663 8H91.1663C91.1663 2.75329 86.913 -1.5 81.6663 -1.5V1.5ZM8.43555 -1.5C3.18884 -1.5 -1.06445 2.75329 -1.06445 8H1.93555C1.93555 4.41015 4.8457 1.5 8.43555 1.5V-1.5Z"
          fill="black"
          mask="url(#path-5-inside-2_4040_20666)"
        />
      </g>
      <defs>
        <clipPath id="clip0_4040_20666">
          <path
            d="M0.435547 8.62745C0.435547 3.86264 4.29819 0 9.063 0H81.0389C85.8037 0 89.6663 3.86264 89.6663 8.62745V81.3726C89.6663 86.1374 85.8037 90 81.0389 90H9.063C4.29819 90 0.435547 86.1374 0.435547 81.3726V8.62745Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  benefitsGreatValue: ({ classname = '', useCurrentColor, ...props }) => (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_4040_4426)">
        <mask id="path-1-inside-1_4040_4426" fill="white">
          <path d="M0.768555 8.62745C0.768555 3.86264 4.6312 0 9.39601 0H81.3719C86.1367 0 89.9993 3.86264 89.9993 8.62745V81.3726C89.9993 86.1374 86.1367 90 81.3719 90H9.39601C4.6312 90 0.768555 86.1374 0.768555 81.3726V8.62745Z" />
        </mask>
        <path
          d="M78.3238 90.75H79.0738V90V70.5372V69.7872H78.3238H43.2433C44.6384 67.5178 45.2599 64.7318 45.1467 61.4749L45.1466 61.4723L44.8913 54.7786H62.1434H62.8934V54.0286V35.956V35.206H62.1434H44.1448L43.755 24.9861C43.7277 23.6545 43.8685 22.575 44.1517 21.7267C44.4267 20.9025 44.8584 20.324 45.4275 19.9375C45.9909 19.5548 46.7859 19.3285 47.8768 19.3285C49.1714 19.3285 50.3031 19.5074 51.2821 19.851C52.1759 20.1647 52.9162 20.7682 53.5034 21.7118C54.0764 22.6324 54.4684 24.0689 54.6099 26.1029L54.6607 26.8338L55.3926 26.8L78.0103 25.7574L78.7788 25.722L78.7239 24.9547C78.429 20.8308 77.5721 17.1666 76.139 13.9743C74.7323 10.7472 72.7229 8.01936 70.1121 5.80088C67.4996 3.55191 64.3156 1.87004 60.5774 0.743871C56.8661 -0.382932 52.571 -0.939178 47.7028 -0.939178C41.6172 -0.939178 36.3007 0.0885154 31.7744 2.1705L31.7727 2.1713C27.2738 4.25438 23.7932 7.24397 21.3605 11.1437L21.3583 11.1472C18.9474 15.0602 17.8647 19.7021 18.0722 25.0363C18.0722 25.0367 18.0722 25.037 18.0722 25.0374L18.4424 35.206H9.60059H8.85059V35.956V54.0286V54.7786H9.60059H19.155L19.4638 63.2601C19.4919 64.6179 19.4198 65.7187 19.2589 66.5758L19.2572 66.5852L19.2556 66.5946C19.1281 67.3842 18.8545 68.01 18.4565 68.501L18.4538 68.5044C18.1043 68.9407 17.5464 69.3751 16.7324 69.7872H9.77457H9.02457V70.5372V90V90.75H9.77457H78.3238Z"
          fill={useCurrentColor ? 'currentColor' : getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <path
        d="M9.39601 1.5H81.3719V-1.5H9.39601V1.5ZM88.4993 8.62745V81.3726H91.4993V8.62745H88.4993ZM81.3719 88.5H9.39601V91.5H81.3719V88.5ZM2.26855 81.3726V8.62745H-0.731445V81.3726H2.26855ZM9.39601 88.5C5.45962 88.5 2.26855 85.3089 2.26855 81.3726H-0.731445C-0.731445 86.9658 3.80277 91.5 9.39601 91.5V88.5ZM88.4993 81.3726C88.4993 85.3089 85.3082 88.5 81.3719 88.5V91.5C86.9651 91.5 91.4993 86.9658 91.4993 81.3726H88.4993ZM81.3719 1.5C85.3082 1.5 88.4993 4.69107 88.4993 8.62745H91.4993C91.4993 3.03421 86.9651 -1.5 81.3719 -1.5V1.5ZM9.39601 -1.5C3.80277 -1.5 -0.731445 3.03421 -0.731445 8.62745H2.26855C2.26855 4.69107 5.45962 1.5 9.39601 1.5V-1.5Z"
        fill="black"
        mask="url(#path-1-inside-1_4040_4426)"
      />
      <defs>
        <clipPath id="clip0_4040_4426">
          <path
            d="M0.768555 8.62745C0.768555 3.86264 4.6312 0 9.39601 0H81.3719C86.1367 0 89.9993 3.86264 89.9993 8.62745V81.3726C89.9993 86.1374 86.1367 90 81.3719 90H9.39601C4.6312 90 0.768555 86.1374 0.768555 81.3726V8.62745Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  benefitsEasyAccess: ({ classname = '', ...props }) => (
    <svg
      viewBox="0 0 110 111"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_3409_35822)">
        <mask id="path-1-inside-1_3409_35822" fill="white">
          <path d="M0.606445 8.6001C0.606445 4.18182 4.18817 0.600098 8.60645 0.600098H101.666C106.085 0.600098 109.666 4.18182 109.666 8.6001V102.6C109.666 107.018 106.085 110.6 101.666 110.6H8.60645C4.18817 110.6 0.606445 107.018 0.606445 102.6V8.6001Z" />
        </mask>
        <path
          d="M99.425 45.3358C99.425 79.8725 54.8907 109.475 54.8907 109.475C54.8907 109.475 10.3564 79.8725 10.3564 45.3358C10.3564 33.559 15.0484 22.2646 23.4002 13.9371C31.752 5.6097 43.0795 0.931396 54.8907 0.931396C66.7019 0.931396 78.0294 5.6097 86.3812 13.9371C94.733 22.2646 99.425 33.559 99.425 45.3358Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M89.655 43.9552C89.655 62.9523 74.2182 78.3555 55.1722 78.3555C36.1263 78.3555 20.6895 62.9523 20.6895 43.9552C20.6895 24.9581 36.1263 9.55493 55.1722 9.55493C74.2182 9.55493 89.655 24.9581 89.655 43.9552Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <path
        d="M8.60645 2.1001H101.666V-0.899902H8.60645V2.1001ZM108.166 8.6001V102.6H111.166V8.6001H108.166ZM101.666 109.1H8.60645V112.1H101.666V109.1ZM2.10645 102.6V8.6001H-0.893555V102.6H2.10645ZM8.60645 109.1C5.01659 109.1 2.10645 106.19 2.10645 102.6H-0.893555C-0.893555 107.847 3.35974 112.1 8.60645 112.1V109.1ZM108.166 102.6C108.166 106.19 105.256 109.1 101.666 109.1V112.1C106.913 112.1 111.166 107.847 111.166 102.6H108.166ZM101.666 2.1001C105.256 2.1001 108.166 5.01025 108.166 8.6001H111.166C111.166 3.35339 106.913 -0.899902 101.666 -0.899902V2.1001ZM8.60645 -0.899902C3.35974 -0.899902 -0.893555 3.35339 -0.893555 8.6001H2.10645C2.10645 5.01025 5.01659 2.1001 8.60645 2.1001V-0.899902Z"
        fill="black"
        mask="url(#path-1-inside-1_3409_35822)"
      />
      <defs>
        <clipPath id="clip0_3409_35822">
          <path
            d="M0.606445 8.6001C0.606445 4.18182 4.18817 0.600098 8.60645 0.600098H101.666C106.085 0.600098 109.666 4.18182 109.666 8.6001V102.6C109.666 107.018 106.085 110.6 101.666 110.6H8.60645C4.18817 110.6 0.606445 107.018 0.606445 102.6V8.6001Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  benefitsSuperiorQuality: ({ classname = '', ...props }) => (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_3616_99490)">
        <mask id="path-2-inside-1_3616_99490" fill="white">
          <path d="M0.102539 5.99999C0.102539 2.68629 2.78883 0 6.10254 0H83.3333C86.647 0 89.3333 2.68629 89.3333 6V83.8112C89.3333 87.1249 86.647 89.8112 83.3333 89.8112H6.10254C2.78883 89.8112 0.102539 87.1249 0.102539 83.8112V5.99999Z" />
        </mask>
        <path
          d="M6.10254 1.5H83.3333V-1.5H6.10254V1.5ZM87.8333 6V83.8112H90.8333V6H87.8333ZM83.3333 88.3112H6.10254V91.3112H83.3333V88.3112ZM1.60254 83.8112V5.99999H-1.39746V83.8112H1.60254ZM6.10254 88.3112C3.61726 88.3112 1.60254 86.2965 1.60254 83.8112H-1.39746C-1.39746 87.9534 1.96041 91.3112 6.10254 91.3112V88.3112ZM87.8333 83.8112C87.8333 86.2965 85.8186 88.3112 83.3333 88.3112V91.3112C87.4754 91.3112 90.8333 87.9534 90.8333 83.8112H87.8333ZM83.3333 1.5C85.8186 1.5 87.8333 3.51472 87.8333 6H90.8333C90.8333 1.85786 87.4754 -1.5 83.3333 -1.5V1.5ZM6.10254 -1.5C1.96041 -1.5 -1.39746 1.85786 -1.39746 5.99999H1.60254C1.60254 3.51471 3.61726 1.5 6.10254 1.5V-1.5Z"
          fill="black"
          mask="url(#path-2-inside-1_3616_99490)"
        />
        <path
          d="M74.0717 5.28062C74.0717 43.7909 42.7129 75.0153 4.02295 75.0153C-34.667 75.0153 -66.0258 43.7909 -66.0258 5.28062C-66.0258 -33.2296 -34.667 -64.4541 4.02295 -64.4541C42.7129 -64.4541 74.0717 -33.2296 74.0717 5.28062Z"
          stroke={getBrandColor()}
          strokeWidth="1.5"
        />
        <path
          d="M39.0183 14.6939C39.0183 16.5589 37.4988 18.0765 35.6173 18.0765C33.7357 18.0765 32.2162 16.5589 32.2162 14.6939C32.2162 12.8288 33.7357 11.3112 35.6173 11.3112C37.4988 11.3112 39.0183 12.8288 39.0183 14.6939Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M38.557 38.1122C38.557 39.9773 37.0375 41.4949 35.1559 41.4949C33.2744 41.4949 31.7549 39.9773 31.7549 38.1122C31.7549 36.2472 33.2744 34.7296 35.1559 34.7296C37.0375 34.7296 38.557 36.2472 38.557 38.1122Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M53.7776 26.1735C53.7776 28.0385 52.258 29.5561 50.3765 29.5561C48.495 29.5561 46.9755 28.0385 46.9755 26.1735C46.9755 24.3084 48.495 22.7908 50.3765 22.7908C52.258 22.7908 53.7776 24.3084 53.7776 26.1735Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M21.4915 46.8367C21.4915 48.6642 19.9075 50.2194 17.8598 50.2194C15.8122 50.2194 14.2281 48.6642 14.2281 46.8367C14.2281 45.0093 15.8122 43.4541 17.8598 43.4541C19.9075 43.4541 21.4915 45.0093 21.4915 46.8367Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M21.0303 25.7143C21.0303 27.5793 19.5107 29.0969 17.6292 29.0969C15.7477 29.0969 14.2281 27.5793 14.2281 25.7143C14.2281 23.8492 15.7477 22.3316 17.6292 22.3316C19.5107 22.3316 21.0303 23.8492 21.0303 25.7143Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M88.3698 4.82144C88.3698 51.1933 50.6096 88.7908 4.02296 88.7908C-42.5636 88.7908 -80.3239 51.1933 -80.3239 4.82144C-80.3239 -41.5504 -42.5636 -79.1479 4.02296 -79.1479C50.6096 -79.1479 88.3698 -41.5504 88.3698 4.82144Z"
          stroke={getBrandColor()}
          strokeWidth="1.5"
        />
        <mask id="path-11-inside-2_3616_99490" fill="white">
          <path d="M0.102539 8C0.102539 3.58172 3.68426 0 8.10254 0H81.3333C85.7516 0 89.3333 3.58172 89.3333 8V81.8112C89.3333 86.2295 85.7516 89.8112 81.3333 89.8112H8.10254C3.68426 89.8112 0.102539 86.2295 0.102539 81.8112V8Z" />
        </mask>
        <path
          d="M8.10254 1.5H81.3333V-1.5H8.10254V1.5ZM87.8333 8V81.8112H90.8333V8H87.8333ZM81.3333 88.3112H8.10254V91.3112H81.3333V88.3112ZM1.60254 81.8112V8H-1.39746V81.8112H1.60254ZM8.10254 88.3112C4.51269 88.3112 1.60254 85.4011 1.60254 81.8112H-1.39746C-1.39746 87.0579 2.85584 91.3112 8.10254 91.3112V88.3112ZM87.8333 81.8112C87.8333 85.4011 84.9231 88.3112 81.3333 88.3112V91.3112C86.58 91.3112 90.8333 87.0579 90.8333 81.8112H87.8333ZM81.3333 1.5C84.9231 1.5 87.8333 4.41015 87.8333 8H90.8333C90.8333 2.75329 86.58 -1.5 81.3333 -1.5V1.5ZM8.10254 -1.5C2.85584 -1.5 -1.39746 2.75329 -1.39746 8H1.60254C1.60254 4.41015 4.51269 1.5 8.10254 1.5V-1.5Z"
          fill="black"
          mask="url(#path-11-inside-2_3616_99490)"
        />
      </g>
      <defs>
        <clipPath id="clip0_3616_99490">
          <path
            d="M0.102539 8.62745C0.102539 3.86264 3.96518 0 8.72999 0H80.7058C85.4707 0 89.3333 3.86264 89.3333 8.62745V81.3726C89.3333 86.1374 85.4707 90 80.7058 90H8.72999C3.96518 90 0.102539 86.1374 0.102539 81.3726V8.62745Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  benefitsLocation: ({ classname = '', ...props }) => (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_4040_18741)">
        <mask id="path-1-inside-1_4040_18741" fill="white">
          <path d="M0.435547 7.05882C0.435547 3.16034 3.59589 0 7.49437 0H82.6075C86.506 0 89.6663 3.16034 89.6663 7.05882V82.9412C89.6663 86.8397 86.506 90 82.6075 90H7.49437C3.59589 90 0.435547 86.8397 0.435547 82.9412V7.05882Z" />
        </mask>
        <path
          d="M81.2873 36.6019C81.2873 64.8592 44.8502 89.0798 44.8502 89.0798C44.8502 89.0798 8.41309 64.8592 8.41309 36.6019C8.41309 26.9664 12.252 17.7255 19.0853 10.9121C25.9186 4.09876 35.1865 0.271057 44.8502 0.271057C54.5139 0.271057 63.7819 4.09876 70.6151 10.9121C77.4484 17.7255 81.2873 26.9664 81.2873 36.6019Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M73.1576 35.4723C73.1576 50.9398 60.5888 63.4817 45.0807 63.4817C29.5727 63.4817 17.0039 50.9398 17.0039 35.4723C17.0039 20.0049 29.5727 7.46304 45.0807 7.46304C60.5888 7.46304 73.1576 20.0049 73.1576 35.4723Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <path
        d="M7.49437 1.5H82.6075V-1.5H7.49437V1.5ZM88.1663 7.05882V82.9412H91.1663V7.05882H88.1663ZM82.6075 88.5H7.49437V91.5H82.6075V88.5ZM1.93555 82.9412V7.05882H-1.06445V82.9412H1.93555ZM7.49437 88.5C4.42432 88.5 1.93555 86.0112 1.93555 82.9412H-1.06445C-1.06445 87.6681 2.76746 91.5 7.49437 91.5V88.5ZM88.1663 82.9412C88.1663 86.0112 85.6775 88.5 82.6075 88.5V91.5C87.3344 91.5 91.1663 87.6681 91.1663 82.9412H88.1663ZM82.6075 1.5C85.6775 1.5 88.1663 3.98877 88.1663 7.05882H91.1663C91.1663 2.33192 87.3344 -1.5 82.6075 -1.5V1.5ZM7.49437 -1.5C2.76746 -1.5 -1.06445 2.33192 -1.06445 7.05882H1.93555C1.93555 3.98877 4.42432 1.5 7.49437 1.5V-1.5Z"
        fill="black"
        mask="url(#path-1-inside-1_4040_18741)"
      />
      <defs>
        <clipPath id="clip0_4040_18741">
          <path
            d="M0.435547 7.05882C0.435547 3.16034 3.59589 0 7.49437 0H82.6075C86.506 0 89.6663 3.16034 89.6663 7.05882V82.9412C89.6663 86.8397 86.506 90 82.6075 90H7.49437C3.59589 90 0.435547 86.8397 0.435547 82.9412V7.05882Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  benefitsFast: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 90 90"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_3817_20025)">
        <mask id="path-1-inside-1_3817_20025" fill="white">
          <path d="M0.768555 8.62745C0.768555 3.86264 4.6312 0 9.39601 0H81.3719C86.1367 0 89.9993 3.86264 89.9993 8.62745V81.3726C89.9993 86.1374 86.1367 90 81.3719 90H9.39601C4.6312 90 0.768555 86.1374 0.768555 81.3726V8.62745Z" />
        </mask>
        <path
          d="M1.97266 44.9072H45.3282V88.6196L1.97266 44.9072Z"
          fill={getBrandColor()}
        />
        <path
          d="M1.97266 1.65141L45.3282 44.9072M88.6838 88.6196L45.3282 44.9072M45.3282 44.9072H1.97266L45.3282 88.6196V44.9072Z"
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <path
        d="M9.39601 1.5H81.3719V-1.5H9.39601V1.5ZM88.4993 8.62745V81.3726H91.4993V8.62745H88.4993ZM81.3719 88.5H9.39601V91.5H81.3719V88.5ZM2.26855 81.3726V8.62745H-0.731445V81.3726H2.26855ZM9.39601 88.5C5.45962 88.5 2.26855 85.3089 2.26855 81.3726H-0.731445C-0.731445 86.9658 3.80277 91.5 9.39601 91.5V88.5ZM88.4993 81.3726C88.4993 85.3089 85.3082 88.5 81.3719 88.5V91.5C86.9651 91.5 91.4993 86.9658 91.4993 81.3726H88.4993ZM81.3719 1.5C85.3082 1.5 88.4993 4.69107 88.4993 8.62745H91.4993C91.4993 3.03421 86.9651 -1.5 81.3719 -1.5V1.5ZM9.39601 -1.5C3.80277 -1.5 -0.731445 3.03421 -0.731445 8.62745H2.26855C2.26855 4.69107 5.45962 1.5 9.39601 1.5V-1.5Z"
        fill="black"
        mask="url(#path-1-inside-1_3817_20025)"
      />
      <defs>
        <clipPath id="clip0_3817_20025">
          <path
            d="M0.768555 8.62745C0.768555 3.86264 4.6312 0 9.39601 0H81.3719C86.1367 0 89.9993 3.86264 89.9993 8.62745V81.3726C89.9993 86.1374 86.1367 90 81.3719 90H9.39601C4.6312 90 0.768555 86.1374 0.768555 81.3726V8.62745Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  benefitsCollect: ({ classname = '', ...props }) => (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_3616_99522)">
        <ellipse
          cx="81.578"
          cy="81.0459"
          rx="81.407"
          ry="81.0459"
          stroke="black"
          strokeWidth="1.5"
        />
        <ellipse
          cx="81.578"
          cy="81.0459"
          rx="64.8027"
          ry="64.5153"
          stroke="black"
          strokeWidth="1.5"
        />
        <rect
          x="76.5626"
          y="37.9439"
          width="16.9492"
          height="79.3163"
          rx="8.47459"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <mask id="path-5-inside-1_3616_99522" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M72.7377 37.8061H49.9838V51.5312C49.9838 56.4078 53.052 60.5679 57.3634 62.1861V105.137C57.3634 107.175 59.0154 108.827 61.0533 108.827C63.0911 108.827 64.7431 107.175 64.7431 105.137V62.3969C69.3747 60.9567 72.7377 56.6367 72.7377 51.5312V37.8061Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.7377 37.8061H49.9838V51.5312C49.9838 56.4078 53.052 60.5679 57.3634 62.1861V105.137C57.3634 107.175 59.0154 108.827 61.0533 108.827C63.0911 108.827 64.7431 107.175 64.7431 105.137V62.3969C69.3747 60.9567 72.7377 56.6367 72.7377 51.5312V37.8061Z"
          fill={getBrandColor()}
        />
        <path
          d="M49.9838 37.8061V36.3061H48.4838V37.8061H49.9838ZM72.7377 37.8061H74.2377V36.3061H72.7377V37.8061ZM57.3634 62.1861H58.8634V61.1469L57.8905 60.7818L57.3634 62.1861ZM64.7431 62.3969L64.2977 60.9646L63.2431 61.2925V62.3969H64.7431ZM49.9838 39.3061H72.7377V36.3061H49.9838V39.3061ZM51.4838 51.5312V37.8061H48.4838V51.5312H51.4838ZM57.8905 60.7818C54.1452 59.376 51.4838 55.7625 51.4838 51.5312H48.4838C48.4838 57.0532 51.9589 61.7598 56.8363 63.5904L57.8905 60.7818ZM58.8634 105.137V62.1861H55.8634V105.137H58.8634ZM61.0533 107.327C59.8439 107.327 58.8634 106.346 58.8634 105.137H55.8634C55.8634 108.003 58.187 110.327 61.0533 110.327V107.327ZM63.2431 105.137C63.2431 106.346 62.2627 107.327 61.0533 107.327V110.327C63.9195 110.327 66.2431 108.003 66.2431 105.137H63.2431ZM63.2431 62.3969V105.137H66.2431V62.3969H63.2431ZM71.2377 51.5312C71.2377 55.9613 68.32 59.7139 64.2977 60.9646L65.1885 63.8293C70.4295 62.1996 74.2377 57.3121 74.2377 51.5312H71.2377ZM71.2377 37.8061V51.5312H74.2377V37.8061H71.2377Z"
          fill="black"
          mask="url(#path-5-inside-1_3616_99522)"
        />
        <mask id="path-7-inside-2_3616_99522" fill="white">
          <path d="M0.102539 8C0.102539 3.58172 3.68426 0 8.10254 0H81.3333C85.7516 0 89.3333 3.58172 89.3333 8V81.8112C89.3333 86.2295 85.7516 89.8112 81.3333 89.8112H8.10254C3.68426 89.8112 0.102539 86.2295 0.102539 81.8112V8Z" />
        </mask>
        <path
          d="M8.10254 1.5H81.3333V-1.5H8.10254V1.5ZM87.8333 8V81.8112H90.8333V8H87.8333ZM81.3333 88.3112H8.10254V91.3112H81.3333V88.3112ZM1.60254 81.8112V8H-1.39746V81.8112H1.60254ZM8.10254 88.3112C4.51269 88.3112 1.60254 85.4011 1.60254 81.8112H-1.39746C-1.39746 87.0579 2.85584 91.3112 8.10254 91.3112V88.3112ZM87.8333 81.8112C87.8333 85.4011 84.9231 88.3112 81.3333 88.3112V91.3112C86.58 91.3112 90.8333 87.0579 90.8333 81.8112H87.8333ZM81.3333 1.5C84.9231 1.5 87.8333 4.41015 87.8333 8H90.8333C90.8333 2.75329 86.58 -1.5 81.3333 -1.5V1.5ZM8.10254 -1.5C2.85584 -1.5 -1.39746 2.75329 -1.39746 8H1.60254C1.60254 4.41015 4.51269 1.5 8.10254 1.5V-1.5Z"
          fill="black"
          mask="url(#path-7-inside-2_3616_99522)"
        />
      </g>
      <defs>
        <clipPath id="clip0_3616_99522">
          <path
            d="M0.102539 8.62745C0.102539 3.86264 3.96518 0 8.72999 0H80.7058C85.4707 0 89.3333 3.86264 89.3333 8.62745V81.3726C89.3333 86.1374 85.4707 90 80.7058 90H8.72999C3.96518 90 0.102539 86.1374 0.102539 81.3726V8.62745Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  benefitsDeliver: ({ classname = '', ...props }) => (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_3616_99533)">
        <mask id="path-1-inside-1_3616_99533" fill="white">
          <path d="M0.769165 8.62745C0.769165 3.86264 4.63181 0 9.39662 0H81.3725C86.1373 0 89.9999 3.86264 89.9999 8.62745V81.3726C89.9999 86.1374 86.1373 90 81.3725 90H9.39662C4.63181 90 0.769165 86.1374 0.769165 81.3726V8.62745Z" />
        </mask>
        <path
          d="M1.97357 44.9072H45.3291V88.6196L1.97357 44.9072Z"
          fill={getBrandColor()}
        />
        <path
          d="M1.97357 1.65143L45.3291 44.9072M88.6847 88.6196L45.3291 44.9072M45.3291 44.9072H1.97357L45.3291 88.6196V44.9072Z"
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <path
        d="M9.39662 1.5H81.3725V-1.5H9.39662V1.5ZM88.4999 8.62745V81.3726H91.4999V8.62745H88.4999ZM81.3725 88.5H9.39662V91.5H81.3725V88.5ZM2.26917 81.3726V8.62745H-0.730835V81.3726H2.26917ZM9.39662 88.5C5.46023 88.5 2.26917 85.3089 2.26917 81.3726H-0.730835C-0.730835 86.9658 3.80338 91.5 9.39662 91.5V88.5ZM88.4999 81.3726C88.4999 85.3089 85.3089 88.5 81.3725 88.5V91.5C86.9657 91.5 91.4999 86.9658 91.4999 81.3726H88.4999ZM81.3725 1.5C85.3089 1.5 88.4999 4.69107 88.4999 8.62745H91.4999C91.4999 3.03421 86.9657 -1.5 81.3725 -1.5V1.5ZM9.39662 -1.5C3.80338 -1.5 -0.730835 3.03421 -0.730835 8.62745H2.26917C2.26917 4.69107 5.46023 1.5 9.39662 1.5V-1.5Z"
        fill="black"
        mask="url(#path-1-inside-1_3616_99533)"
      />
      <defs>
        <clipPath id="clip0_3616_99533">
          <path
            d="M0.769165 8.62745C0.769165 3.86264 4.63181 0 9.39662 0H81.3725C86.1373 0 89.9999 3.86264 89.9999 8.62745V81.3726C89.9999 86.1374 86.1373 90 81.3725 90H9.39662C4.63181 90 0.769165 86.1374 0.769165 81.3726V8.62745Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  tag: ({ classname = '', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M4.66665 4.66634H4.67331M13.7266 8.93967L8.94665 13.7197C8.82282 13.8436 8.67576 13.942 8.5139 14.0091C8.35204 14.0762 8.17853 14.1107 8.00331 14.1107C7.82809 14.1107 7.65459 14.0762 7.49273 14.0091C7.33086 13.942 7.18381 13.8436 7.05998 13.7197L1.33331 7.99967V1.33301H7.99998L13.7266 7.05967C13.975 7.30949 14.1144 7.64743 14.1144 7.99967C14.1144 8.35192 13.975 8.68986 13.7266 8.93967Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  tagReverse: ({ classname = '', ...props }) => (
    <svg
      width="121"
      height="121"
      viewBox="0 0 121 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.981 0.11578L60.5874 0.260199C57.3885 0.269949 54.3258 1.55657 52.0797 3.83432L3.75938 52.8342C-0.894069 57.5531 -0.841009 65.1509 3.87789 69.8044L51.5273 116.793C56.2462 121.446 63.844 121.393 68.4974 116.674L116.842 67.6495C119.074 65.3865 120.317 62.3306 120.298 59.1524L120.018 12.0444C119.978 5.43066 114.595 0.0956271 107.981 0.11578ZM92.3325 37.0005C97.8554 37.0005 102.333 32.5233 102.333 27.0005C102.333 21.4776 97.8554 17.0005 92.3325 17.0005C86.8097 17.0005 82.3325 21.4776 82.3325 27.0005C82.3325 32.5233 86.8097 37.0005 92.3325 37.0005Z"
        fill="currentColor"
      />
    </svg>
  ),

  cart: ({ classname = '', uniqueId = '', ...props }) => {
    const clipId = uniqueId
      ? `clip0_4502_21544_${uniqueId}`
      : 'clip0_4502_21544';
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        className={classname}
        {...props}
      >
        <g clipPath={`url(#${clipId})`}>
          <path
            d="M1.1665 0.666748H3.83317L5.61984 9.59342C5.6808 9.90035 5.84778 10.1761 6.09153 10.3723C6.33529 10.5685 6.6403 10.6727 6.95317 10.6667H13.4332C13.746 10.6727 14.051 10.5685 14.2948 10.3723C14.5386 10.1761 14.7055 9.90035 14.7665 9.59342L15.8332 4.00008H4.49984M7.1665 14.0001C7.1665 14.3683 6.86803 14.6667 6.49984 14.6667C6.13165 14.6667 5.83317 14.3683 5.83317 14.0001C5.83317 13.6319 6.13165 13.3334 6.49984 13.3334C6.86803 13.3334 7.1665 13.6319 7.1665 14.0001ZM14.4998 14.0001C14.4998 14.3683 14.2014 14.6667 13.8332 14.6667C13.465 14.6667 13.1665 14.3683 13.1665 14.0001C13.1665 13.6319 13.465 13.3334 13.8332 13.3334C14.2014 13.3334 14.4998 13.6319 14.4998 14.0001Z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id={clipId}>
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  },

  checkCircle: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M29.3332 14.7735V16.0001C29.3315 18.8754 28.4005 21.673 26.679 23.9759C24.9574 26.2788 22.5376 27.9635 19.7803 28.7787C17.0231 29.5939 14.0762 29.496 11.3791 28.4996C8.68208 27.5032 6.37938 25.6616 4.81445 23.2496C3.24953 20.8375 2.50623 17.9842 2.69541 15.1152C2.88459 12.2462 3.99611 9.51525 5.86421 7.32958C7.73231 5.1439 10.2569 3.62065 13.0614 2.98701C15.866 2.35336 18.8002 2.64326 21.4265 3.81348M29.3332 5.33348L15.9998 18.6801L11.9998 14.6801"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  checkCircle2: ({ classname = '', ...props }) => (
    <svg
      width="88"
      height="89"
      viewBox="0 0 88 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M80.6664 41.0265V44.3998C80.6618 52.3067 78.1015 60.0003 73.3672 66.3332C68.633 72.666 61.9784 77.2989 54.396 79.5408C46.8136 81.7827 38.7096 81.5134 31.2927 78.7733C23.8758 76.0331 17.5434 70.9688 13.2399 64.3357C8.93632 57.7026 6.89224 49.856 7.41249 41.9663C7.93274 34.0765 10.9894 26.5663 16.1267 20.5557C21.264 14.5451 28.2066 10.3562 35.919 8.61368C43.6315 6.87115 51.7007 7.66838 58.923 10.8865M80.6664 15.0665L43.9997 51.7698L32.9997 40.7698"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  alertCircle: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 74 74"
      className={classname}
      fill="none"
      {...props}
    >
      <path
        d="M36.9998 24.6667V37.0001M36.9998 49.3334H37.0307M67.8332 37.0001C67.8332 54.0289 54.0286 67.8334 36.9998 67.8334C19.9711 67.8334 6.1665 54.0289 6.1665 37.0001C6.1665 19.9713 19.9711 6.16675 36.9998 6.16675C54.0286 6.16675 67.8332 19.9713 67.8332 37.0001Z"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  edit: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_4560_272)">
        <path
          d="M7.3335 2.66665H2.66683C2.31321 2.66665 1.97407 2.80713 1.72402 3.05718C1.47397 3.30723 1.3335 3.64637 1.3335 3.99999V13.3333C1.3335 13.6869 1.47397 14.0261 1.72402 14.2761C1.97407 14.5262 2.31321 14.6667 2.66683 14.6667H12.0002C12.3538 14.6667 12.6929 14.5262 12.943 14.2761C13.193 14.0261 13.3335 13.6869 13.3335 13.3333V8.66665M12.3335 1.66665C12.5987 1.40144 12.9584 1.25244 13.3335 1.25244C13.7086 1.25244 14.0683 1.40144 14.3335 1.66665C14.5987 1.93187 14.7477 2.29158 14.7477 2.66665C14.7477 3.04173 14.5987 3.40144 14.3335 3.66665L8.00016 9.99999L5.3335 10.6667L6.00016 7.99999L12.3335 1.66665Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4560_272">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  info: ({
    stroke = 'currentColor',
    fill = 'none',
    classname = '',
    width = '16',
    height = '16',
    ...props
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      style={{ transform: `scale(${width / 16})` }}
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_4560_2203)">
        <path
          d="M8.00016 10.6666V7.99992M8.00016 5.33325H8.00683M14.6668 7.99992C14.6668 11.6818 11.6821 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.6821 1.33325 14.6668 4.31802 14.6668 7.99992Z"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4560_2203">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  talkToTeam: ({ classname = '', ...props }) => (
    <svg
      width="145"
      height="146"
      viewBox="0 0 145 146"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_4040_36685)">
        <path
          d="M47.245 59.2194C47.245 63.5362 43.7455 67.0357 39.4286 67.0357C35.1118 67.0357 31.6123 63.5362 31.6123 59.2194C31.6123 54.9026 35.1118 51.4031 39.4286 51.4031C43.7455 51.4031 47.245 54.9026 47.245 59.2194Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M80.7655 59.2194C80.7655 63.5362 77.266 67.0357 72.9491 67.0357C68.6323 67.0357 65.1328 63.5362 65.1328 59.2194C65.1328 54.9026 68.6323 51.4031 72.9491 51.4031C77.266 51.4031 80.7655 54.9026 80.7655 59.2194Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M114.286 59.2194C114.286 63.5065 110.65 67.0357 106.097 67.0357C101.544 67.0357 97.9082 63.5065 97.9082 59.2194C97.9082 54.9323 101.544 51.4031 106.097 51.4031C110.65 51.4031 114.286 54.9323 114.286 59.2194Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M9.06641 0.75H136.832C140.836 0.75 144.082 3.99594 144.082 8V104.5C144.082 108.505 140.836 111.75 136.832 111.75H105.374H67.4287C66.2719 111.75 65.1549 112.173 64.2872 112.938L28.6737 144.339V116.5C28.6737 113.877 26.547 111.75 23.9237 111.75H9.06641C5.06235 111.75 1.81641 108.505 1.81641 104.5V8C1.81641 3.99593 5.06234 0.75 9.06641 0.75Z"
          stroke="black"
          strokeWidth="1.5"
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <defs>
        <clipPath id="clip0_4040_36685">
          <path
            d="M0.556641 8C0.556641 3.58173 4.13836 0 8.55664 0H136.667C141.085 0 144.667 3.58172 144.667 8V138C144.667 142.418 141.085 146 136.667 146H8.55663C4.13835 146 0.556641 142.418 0.556641 138V8Z"
            fill="white"
            vectorEffect="non-scaling-stroke"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  viewFaq: ({ classname = '', ...props }) => (
    <svg
      width="145"
      height="146"
      viewBox="0 0 145 146"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M0.893217 8C0.893217 3.95166 4.17505 0.669829 8.22339 0.669829H136.334C140.382 0.669829 143.664 3.95166 143.664 8V138C143.664 142.048 140.382 145.33 136.333 145.33H8.22338C4.17504 145.33 0.893217 142.048 0.893217 138V8Z"
        stroke="black"
        strokeWidth="1.5"
      />
      <mask id="path-2-inside-1_4040_36830" fill="white">
        <path d="M0.223389 8C0.223389 3.58173 3.80511 0 8.22339 0H136.334C140.752 0 144.333 3.58172 144.333 8V138C144.333 142.418 140.752 146 136.333 146H8.22338C3.8051 146 0.223389 142.418 0.223389 138V8Z" />
      </mask>
      <path
        d="M8.22339 1.5H136.334V-1.5H8.22339V1.5ZM142.833 8V138H145.833V8H142.833ZM136.333 144.5H8.22338V147.5H136.333V144.5ZM1.72339 138V8H-1.27661V138H1.72339ZM8.22338 144.5C4.63353 144.5 1.72339 141.59 1.72339 138H-1.27661C-1.27661 143.247 2.97667 147.5 8.22338 147.5V144.5ZM142.833 138C142.833 141.59 139.923 144.5 136.333 144.5V147.5C141.58 147.5 145.833 143.247 145.833 138H142.833ZM136.334 1.5C139.923 1.5 142.833 4.41015 142.833 8H145.833C145.833 2.7533 141.58 -1.5 136.334 -1.5V1.5ZM8.22339 -1.5C2.97668 -1.5 -1.27661 2.7533 -1.27661 8H1.72339C1.72339 4.41015 4.63354 1.5 8.22339 1.5V-1.5Z"
        fill="black"
        mask="url(#path-2-inside-1_4040_36830)"
      />
      <path
        d="M120.404 71.8126C120.404 88.7516 106.702 102.481 89.8019 102.481C72.9023 102.481 59.1997 88.7516 59.1997 71.8126C59.1997 54.8736 72.9023 41.1445 89.8019 41.1445C106.702 41.1445 120.404 54.8736 120.404 71.8126Z"
        fill={getBrandColor()}
        stroke="black"
        strokeWidth="1.5"
      />
      <path
        d="M86.065 71.8126C86.065 88.7516 72.3624 102.481 55.4628 102.481C38.5631 102.481 24.8606 88.7516 24.8606 71.8126C24.8606 54.8736 38.5631 41.1445 55.4628 41.1445C72.3624 41.1445 86.065 54.8736 86.065 71.8126Z"
        stroke="black"
        strokeWidth="1.5"
      />
      <mask id="path-6-inside-2_4040_36830" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.6328 98.1052C81.1743 92.4926 86.8156 82.8128 86.8156 71.8127C86.8156 60.8126 81.1743 51.1329 72.6328 45.5203C64.0912 51.1329 58.45 60.8126 58.45 71.8127C58.45 82.8128 64.0912 92.4926 72.6328 98.1052Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.6328 98.1052C81.1743 92.4926 86.8156 82.8128 86.8156 71.8127C86.8156 60.8126 81.1743 51.1329 72.6328 45.5203C64.0912 51.1329 58.45 60.8126 58.45 71.8127C58.45 82.8128 64.0912 92.4926 72.6328 98.1052Z"
        fill="#F8FAEF"
      />
      <path
        d="M72.6328 98.1052L71.8091 99.3588L72.6328 99.9L73.4565 99.3588L72.6328 98.1052ZM72.6328 45.5203L73.4565 44.2667L72.6328 43.7254L71.8091 44.2667L72.6328 45.5203ZM85.3156 71.8127C85.3156 82.2876 79.9457 91.5051 71.8091 96.8516L73.4565 99.3588C82.403 93.4801 88.3156 83.3381 88.3156 71.8127H85.3156ZM71.8091 46.7738C79.9457 52.1204 85.3156 61.3379 85.3156 71.8127H88.3156C88.3156 60.2874 82.403 50.1454 73.4565 44.2667L71.8091 46.7738ZM59.95 71.8127C59.95 61.3379 65.3199 52.1204 73.4565 46.7738L71.8091 44.2667C62.8626 50.1454 56.95 60.2874 56.95 71.8127H59.95ZM73.4565 96.8516C65.3199 91.5051 59.95 82.2876 59.95 71.8127H56.95C56.95 83.3381 62.8626 93.4801 71.8091 99.3588L73.4565 96.8516Z"
        fill="black"
        mask="url(#path-6-inside-2_4040_36830)"
      />
    </svg>
  ),

  joinBooker: ({ classname = '', ...props }) => (
    <svg
      width="145"
      height="147"
      viewBox="0 0 145 147"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <mask id="path-1-inside-1_4040_36761" fill="white">
        <path d="M0.586914 8C0.586914 3.58173 4.16864 0 8.58691 0H137C141.418 0 145 3.58172 145 8V138C145 142.418 141.418 146 137 146H8.58691C4.16863 146 0.586914 142.418 0.586914 138V8Z" />
      </mask>
      <path
        d="M0.586914 8C0.586914 3.58173 4.16864 0 8.58691 0H137C141.418 0 145 3.58172 145 8V138C145 142.418 141.418 146 137 146H8.58691C4.16863 146 0.586914 142.418 0.586914 138V8Z"
        fill="#FAF9F5"
      />
      <path
        d="M8.58691 1.5H137V-1.5H8.58691V1.5ZM143.5 8V138H146.5V8H143.5ZM137 144.5H8.58691V147.5H137V144.5ZM2.08691 138V8H-0.913086V138H2.08691ZM8.58691 144.5C4.99706 144.5 2.08691 141.59 2.08691 138H-0.913086C-0.913086 143.247 3.3402 147.5 8.58691 147.5V144.5ZM143.5 138C143.5 141.59 140.59 144.5 137 144.5V147.5C142.247 147.5 146.5 143.247 146.5 138H143.5ZM137 1.5C140.59 1.5 143.5 4.41015 143.5 8H146.5C146.5 2.7533 142.247 -1.5 137 -1.5V1.5ZM8.58691 -1.5C3.34021 -1.5 -0.913086 2.7533 -0.913086 8H2.08691C2.08691 4.41015 4.99706 1.5 8.58691 1.5V-1.5Z"
        fill="black"
        mask="url(#path-1-inside-1_4040_36761)"
      />
      <path
        d="M2.05225 72.9668H72.7797V144.441L2.05225 72.9668Z"
        fill={getBrandColor()}
      />
      <path
        d="M2.05225 2.23938L72.7797 72.9668M143.507 144.441L72.7797 72.9668M72.7797 72.9668H2.05225L72.7797 144.441V72.9668Z"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  ),

  heart: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M13.8933 3.07357C13.5528 2.73291 13.1485 2.46267 12.7036 2.2783C12.2586 2.09392 11.7817 1.99902 11.3 1.99902C10.8183 1.99902 10.3414 2.09392 9.89643 2.2783C9.45146 2.46267 9.04717 2.73291 8.70667 3.07357L8 3.78024L7.29333 3.07357C6.60554 2.38578 5.67269 1.99938 4.7 1.99938C3.72731 1.99938 2.79446 2.38578 2.10666 3.07357C1.41887 3.76137 1.03247 4.69422 1.03247 5.66691C1.03247 6.6396 1.41887 7.57245 2.10666 8.26024L8 14.1536L13.8933 8.26024C14.234 7.91974 14.5042 7.51545 14.6886 7.07048C14.873 6.6255 14.9679 6.14857 14.9679 5.66691C14.9679 5.18525 14.873 4.70831 14.6886 4.26334C14.5042 3.81836 14.234 3.41408 13.8933 3.07357Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  addNote: ({ classname = '', ...props }) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_4245_1307)">
        <path
          d="M5.5 2.00011H2C1.73478 2.00011 1.48043 2.10547 1.29289 2.29301C1.10536 2.48054 1 2.7349 1 3.00011V10.0001C1 10.2653 1.10536 10.5197 1.29289 10.7072C1.48043 10.8948 1.73478 11.0001 2 11.0001H9C9.26522 11.0001 9.51957 10.8948 9.70711 10.7072C9.89464 10.5197 10 10.2653 10 10.0001V6.50011M9.25 1.25011C9.44891 1.0512 9.7187 0.939453 10 0.939453C10.2813 0.939453 10.5511 1.0512 10.75 1.25011C10.9489 1.44903 11.0607 1.71881 11.0607 2.00011C11.0607 2.28142 10.9489 2.5512 10.75 2.75011L6 7.50011L4 8.00011L4.5 6.00011L9.25 1.25011Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4245_1307">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  checkMark: ({ classname = '', ...props }) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_4245_3254)">
        <path
          d="M4.5 5.5L6 7L11 2M10.5 6V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H8"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4245_3254">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  rotateCCW: ({ classname = '', ...props }) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_4299_119)">
        <path
          d="M0.5 2.00022V5.00022M0.5 5.00022H3.5M0.5 5.00022L2.82 2.82022C3.51046 2.13093 4.40623 1.6847 5.37234 1.54878C6.33845 1.41285 7.32257 1.59459 8.17642 2.0666C9.03026 2.53862 9.70758 3.27534 10.1063 4.16577C10.505 5.0562 10.6036 6.05209 10.3871 7.0034C10.1706 7.95471 9.65084 8.80989 8.90606 9.4401C8.16129 10.0703 7.23187 10.4414 6.25786 10.4975C5.28384 10.5535 4.31799 10.2915 3.50583 9.75091C2.69367 9.21031 2.0792 8.42041 1.755 7.50022"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4299_119">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  truck: ({ stroke = 'currentColor', classname = '', ...props }) => (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M10.6667 9.66667V1H0.666748V9.66667H10.6667ZM10.6667 9.66667H15.3334V6.33333L13.3334 4.33333H10.6667L10.6667 9.66667ZM5.33341 11.3333C5.33341 12.2538 4.58722 13 3.66675 13C2.74627 13 2.00008 12.2538 2.00008 11.3333C2.00008 10.4129 2.74627 9.66667 3.66675 9.66667C4.58722 9.66667 5.33341 10.4129 5.33341 11.3333ZM14.0001 11.3333C14.0001 12.2538 13.2539 13 12.3334 13C11.4129 13 10.6667 12.2538 10.6667 11.3333C10.6667 10.4129 11.4129 9.66667 12.3334 9.66667C13.2539 9.66667 14.0001 10.4129 14.0001 11.3333Z"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  dietaryVegetarian: ({ classname = '', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M5.71278 3.5L7.95581 10.584H8.04419L10.283 3.5H12L8.9616 12.5H7.03419L4 3.5H5.71278Z"
        fill="currentColor"
      />
    </svg>
  ),

  dietaryKosher: ({ classname = '', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M6.1123 6.2959L10.3828 3.5H13.3721L9.13477 6.24609L14.3242 12.5H9.72559L6.1123 8.13086V12.5H2.49902V3.5H6.1123V6.2959Z"
        fill="currentColor"
      />
    </svg>
  ),

  dietaryDairyFree: ({ classname = '', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M15.6548 3.71739C14.368 3.19953 12.987 3.08968 11.7944 3.85862C11.559 4.01555 11.4178 3.96847 11.2608 3.73308C10.6802 2.86998 9.92695 2.27366 8.89124 2.06965C8.27922 2.08535 7.65152 2.00688 7.0395 2.16381C6.28625 2.38351 5.68993 2.8386 5.28192 3.4663C4.95238 3.95278 4.66991 4.01555 4.19913 3.70169C3.21049 3.02691 2.14339 3.19953 1.09198 3.51338C0.527042 3.686 0.370116 4.03124 0.605506 4.56479C0.825203 5.05126 1.13906 5.47496 1.45291 5.91436C1.95508 6.63622 2.56709 7.02854 3.52434 6.93438C4.56006 6.82453 4.56006 6.8873 4.70129 7.92302C4.9053 9.39813 5.06222 10.8732 5.09361 12.364C5.1093 13.1801 5.45454 13.6665 6.16071 13.8235C6.63149 13.8705 6.99242 13.8392 7.27489 13.745C7.72998 14.0902 8.59307 14.0745 9.09524 13.7607C9.40909 13.8078 9.89557 13.8235 10.2094 13.7764C10.539 13.7136 11.559 13.3841 11.4491 12.6936L11.4021 11.344C11.4334 10.0101 11.6531 8.69196 11.8101 7.35808C11.8415 7.04423 11.7944 6.29098 12.0768 6.35375C13.6147 6.66761 14.6348 5.91436 14.9643 5.63189C15.3723 5.28665 15.8117 3.78016 15.6548 3.71739ZM5.62716 7.93871C5.62716 7.71902 5.81547 7.5307 6.03517 7.5307C6.25487 7.5307 6.44318 7.71902 6.44318 7.93871C6.44318 8.15841 6.25487 8.34672 6.03517 8.34672C5.81547 8.36242 5.62716 8.1741 5.62716 7.93871ZM10.6645 12.7093C10.539 12.929 10.3193 13.0231 10.0839 13.1016C9.98972 13.133 9.91126 13.0859 9.92695 12.9761C10.0054 12.2699 9.50325 12.3797 9.09524 12.364C8.98539 12.364 8.62446 12.3797 8.546 12.3797L8.26353 12.3954C7.93398 12.3954 7.44751 12.3797 7.11796 12.3797C6.86688 12.3797 6.67223 12.6705 6.70361 13C6.75069 13.4394 6.44318 13.133 6.1764 13.0545C5.65855 12.6151 5.65855 12.521 6.12933 11.8933C6.30195 11.752 6.55303 11.6893 6.60011 11.4539C6.74134 10.8262 7.36905 9.02151 7.51028 8.78612C7.54167 8.67627 7.55736 8.55073 7.57305 8.44088C7.60444 8.1898 7.63582 7.93871 7.65152 7.68763C7.65152 7.27962 7.63582 6.87161 7.63582 6.52637C7.52597 5.85159 7.19643 5.25527 6.41179 4.80018C5.22638 4.20747 7.78463 3.63124 9.20361 4C9.98972 4.20429 10.3977 4.5 9.69156 4.9728C9.1894 5.22388 9.01678 5.58481 8.90693 6.05559C8.78139 6.57345 8.71862 7.09131 8.71862 7.60917C8.71862 7.73471 8.71862 7.86025 8.73431 8.00148C8.73431 8.06426 8.75 8.12703 8.75 8.1898C8.78139 8.50365 8.84416 8.8332 8.92262 9.14705C9.26786 9.75906 9.37771 10.4652 9.64448 11.1086C9.73864 11.3283 9.8171 11.5323 10.0525 11.6579C10.2565 11.7677 10.4448 11.9403 10.5704 12.1444C10.6645 12.317 10.7744 12.4896 10.6645 12.7093ZM10.3977 8.36242C10.178 8.36242 9.98972 8.1741 9.98972 7.95441C9.98972 7.73471 10.178 7.5464 10.3977 7.5464C10.6174 7.5464 10.8057 7.73471 10.8057 7.95441C10.8057 8.1741 10.6331 8.36242 10.3977 8.36242Z"
        fill="currentColor"
      />
    </svg>
  ),

  dietaryGlutenFree: ({ classname = '', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M9.91943 11.8802V3.11975H15.5103V4.45007H11.5004V6.8284H15.1268V8.15872H11.5004V11.8802H9.91943Z"
        fill="currentColor"
      />
      <path
        d="M6.70734 5.9173C6.63632 5.68631 6.53831 5.47956 6.41331 5.29705C6.29115 5.11169 6.14342 4.95342 5.97013 4.82224C5.79967 4.69106 5.60365 4.59268 5.38206 4.52709C5.16047 4.45865 4.91899 4.42443 4.65763 4.42443C4.18888 4.42443 3.77126 4.54278 3.40479 4.77947C3.03831 5.01616 2.74996 5.36407 2.53973 5.82319C2.33234 6.27947 2.22865 6.83555 2.22865 7.49145C2.22865 8.15304 2.33234 8.7134 2.53973 9.17253C2.74711 9.63165 3.03547 9.98099 3.40479 10.2205C3.7741 10.4572 4.20308 10.5756 4.69172 10.5756C5.1349 10.5756 5.51842 10.49 5.84229 10.3189C6.16899 10.1478 6.42041 9.90542 6.59655 9.59173C6.77268 9.27519 6.86075 8.90447 6.86075 8.47956L7.21871 8.53517H4.84939V7.29468H8.39058V8.34696C8.39058 9.09696 8.23149 9.74572 7.91331 10.2933C7.59513 10.8408 7.15763 11.2628 6.60081 11.5594C6.04399 11.8531 5.40479 12 4.68319 12C3.87922 12 3.17325 11.8189 2.5653 11.4567C1.96018 11.0917 1.48717 10.5741 1.14626 9.90399C0.808194 9.23099 0.63916 8.43251 0.63916 7.50855C0.63916 6.80133 0.738592 6.16968 0.937456 5.61359C1.13916 5.05751 1.42041 4.58555 1.78121 4.19772C2.142 3.80703 2.5653 3.51046 3.05109 3.30798C3.53689 3.10266 4.0653 3 4.63632 3C5.11927 3 5.56956 3.07129 5.98717 3.21388C6.40479 3.35361 6.77552 3.55323 7.09939 3.81274C7.42609 4.07224 7.69456 4.38023 7.90479 4.73669C8.11501 5.09316 8.2528 5.48669 8.31814 5.9173H6.70734Z"
        fill="currentColor"
      />
    </svg>
  ),

  checkMark: ({ classname = '', stroke = 'currentColor', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M13.3332 4L5.99984 11.3333L2.6665 8"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  checkMarkNote: ({ classname = '', ...props }) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_4342_1796)">
        <path
          d="M4.5 5.5L6 7L11 2M10.5 6V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H8"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4342_1796">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  frozen: ({ classname = '', props }) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M0.75 5.74875H4.0825M10.7475 5.74875H7.415M5.74875 5.74875V7.415M5.74875 5.74875H7.415M5.74875 5.74875V4.0825M5.74875 5.74875H4.0825M5.74875 0.75V4.0825M5.74875 10.7475V7.415M5.74875 7.415L3.24937 9.91437M5.74875 7.415L8.24812 9.91437M7.415 5.74875L9.91437 8.24812M7.415 5.74875L9.91437 3.24937M5.74875 4.0825L8.24812 1.58312M5.74875 4.0825L3.24937 1.58312M4.0825 5.74875L1.58312 3.24937M4.0825 5.74875L1.58312 8.24812"
        stroke="black"
        strokeLinecap="round"
      />
    </svg>
  ),

  chilled: ({ classname = 'tw:w-4 tw:h-4', props }) => (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
        fill="#1F1E19"
      />
      <path
        d="M11.2892 7.27344H9.73384C9.70543 7.07221 9.64743 6.89347 9.55984 6.73722C9.47224 6.5786 9.35979 6.44366 9.22248 6.33239C9.08517 6.22112 8.92655 6.13589 8.74663 6.0767C8.56907 6.01752 8.37612 5.98793 8.16779 5.98793C7.79137 5.98793 7.46348 6.08144 7.18413 6.26847C6.90477 6.45312 6.68815 6.72301 6.53427 7.07812C6.38039 7.43087 6.30344 7.85937 6.30344 8.36364C6.30344 8.8821 6.38039 9.31771 6.53427 9.67045C6.69052 10.0232 6.90832 10.2895 7.18768 10.4695C7.46703 10.6494 7.79019 10.7393 8.15714 10.7393C8.3631 10.7393 8.55368 10.7121 8.72887 10.6577C8.90643 10.6032 9.06386 10.5239 9.20117 10.4197C9.33848 10.3132 9.45212 10.1842 9.54208 10.0327C9.63441 9.88116 9.69833 9.70833 9.73384 9.5142L11.2892 9.52131C11.249 9.85511 11.1484 10.1771 10.9874 10.4872C10.8288 10.795 10.6145 11.0708 10.3446 11.3146C10.0771 11.5561 9.75752 11.7479 9.38583 11.8899C9.01651 12.0296 8.59866 12.0994 8.13228 12.0994C7.48361 12.0994 6.90359 11.9527 6.39222 11.6591C5.88323 11.3655 5.48076 10.9406 5.18484 10.3842C4.89128 9.82789 4.7445 9.15436 4.7445 8.36364C4.7445 7.57055 4.89364 6.89583 5.19194 6.33949C5.49023 5.78314 5.89506 5.35937 6.40643 5.06818C6.91779 4.77462 7.49308 4.62784 8.13228 4.62784C8.55368 4.62784 8.94431 4.68703 9.30415 4.8054C9.66637 4.92377 9.98716 5.09659 10.2665 5.32386C10.5459 5.54877 10.7731 5.82457 10.9483 6.15128C11.1259 6.47798 11.2395 6.85204 11.2892 7.27344Z"
        fill="white"
      />
    </svg>
  ),

  ambient: ({ classname = 'tw:w-4 tw:h-4', props }) => (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
        fill="#1F1E19"
      />
      <path
        d="M6.14542 12H4.49769L7.00835 4.72727H8.98988L11.497 12H9.84925L8.02752 6.3892H7.9707L6.14542 12ZM6.04244 9.14134H9.93448V10.3416H6.04244V9.14134Z"
        fill="white"
      />
    </svg>
  ),

  dietaryVegan: ({ classname = '', props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M12.1238 13C11.4676 13 10.9008 12.8614 10.4235 12.5842C9.94909 12.3042 9.58403 11.9086 9.32835 11.3975C9.07266 10.8836 8.94482 10.2787 8.94482 9.58279C8.94482 8.89848 9.07266 8.29791 9.32835 7.78106C9.58687 7.26133 9.94766 6.8571 10.4107 6.56836C10.8738 6.27673 11.4178 6.13092 12.0428 6.13092C12.4462 6.13092 12.8269 6.19733 13.1849 6.33015C13.5457 6.46008 13.8639 6.6622 14.1394 6.9365C14.4178 7.2108 14.6366 7.56018 14.7957 7.98462C14.9548 8.40618 15.0343 8.90859 15.0343 9.49184V9.97259H9.66926V8.91581H13.5556C13.5528 8.61552 13.4889 8.34844 13.3639 8.11456C13.2389 7.87779 13.0641 7.69155 12.8397 7.55585C12.6181 7.42014 12.3596 7.35229 12.0641 7.35229C11.7488 7.35229 11.4718 7.43025 11.2332 7.58616C10.9945 7.7392 10.8085 7.94131 10.6749 8.19252C10.5443 8.44083 10.4775 8.71369 10.4747 9.01109V9.93361C10.4747 10.3205 10.5443 10.6526 10.6835 10.9298C10.8227 11.2041 11.0173 11.4148 11.2673 11.5621C11.5173 11.7065 11.8099 11.7787 12.1451 11.7787C12.3695 11.7787 12.5727 11.7469 12.7545 11.6834C12.9363 11.617 13.094 11.5202 13.2275 11.3932C13.361 11.2661 13.4619 11.1088 13.5301 10.9211L14.9704 11.0857C14.8795 11.4726 14.7062 11.8104 14.4505 12.0992C14.1977 12.385 13.8738 12.6073 13.4789 12.7661C13.084 12.9221 12.6323 13 12.1238 13Z"
        fill="currentColor"
      />
      <path
        d="M2.48145 4L4.75275 10.9817H4.84224L7.10929 4H8.84792L5.77122 12.8701H3.81951L0.74707 4H2.48145Z"
        fill="currentColor"
      />
    </svg>
  ),

  dietaryHalal: ({ classname = '', props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M3.74691 3.53302C3.87824 4.07918 4.1567 4.47831 4.43539 4.87872C4.38257 5.07559 4.32805 5.27463 4.27523 5.4715C4.14564 6.14242 4.16482 7.1445 4.27523 7.82501C4.37932 8.46874 4.56891 9.5164 4.40414 10.1795C4.18472 11.0604 3.61755 11.7063 2.85043 12.0379C0.739442 12.9492 -0.474651 11.4244 0.175622 9.3631C0.278084 9.0397 0.374008 8.57545 0.591637 8.35431C0.545172 9.16785 0.40591 10.0472 0.831872 10.5965C1.00005 10.8127 1.23424 10.875 1.53695 10.9647C2.49791 11.2497 3.20917 10.7357 3.49105 10.0838C4.0516 8.78486 3.67204 6.78425 3.3309 5.53497C3.12752 4.78868 3.0648 3.95908 3.66683 3.53302H3.74691ZM8.37582 3.78888C8.68814 3.83373 9.01361 3.97185 9.40121 4.01349C9.40601 4.02465 9.41204 4.03454 9.41683 4.04572C9.09338 5.19404 9.23089 7.53678 9.46468 8.65802C9.58959 9.25534 9.64922 9.79508 10.0575 10.0994C10.5508 10.4678 11.5421 10.3637 12.1395 10.1795C12.4919 10.0706 12.9531 9.94249 13.1805 9.69904C12.5751 9.50513 11.8732 8.88767 11.034 9.23517C10.7267 9.36355 10.4429 9.78876 10.2332 9.85919V9.79572C10.3885 9.26095 10.4961 8.8107 10.7938 8.43439C11.0853 8.06604 11.7711 7.81109 12.3797 8.04962C13.5233 8.49969 14.4927 9.20255 15.9998 9.29865V9.3631C15.6427 9.63218 15.4501 9.99448 15.2147 10.3885C14.9264 10.4045 14.5981 10.4025 14.3338 10.4842C13.0189 10.8878 10.1619 12.3419 9.12875 10.5965C8.86607 10.1512 8.83246 9.54712 8.72836 8.93048C8.72355 8.53491 8.71656 8.1405 8.71175 7.74493H8.69613C8.576 9.28413 8.1963 10.9586 7.2225 11.6697C6.92153 11.889 6.59322 11.9817 6.16586 12.0858C5.80397 12.1738 5.17593 12.2092 4.7723 12.118C4.37203 12.0331 3.9714 11.947 3.57113 11.8621C6.71175 11.4857 7.72256 9.73935 8.24789 6.76837C8.36798 6.09258 8.26538 5.36232 8.37582 4.63849V3.78888ZM4.74007 5.32697C5.14676 5.35899 5.56808 5.59904 5.86117 5.77521C7.07358 6.50554 7.65244 7.35298 7.3514 9.25079C7.34027 9.24602 7.33028 9.23996 7.31918 9.23517C7.22468 7.72801 5.99398 7.33413 4.62777 7.07306C4.5429 6.59424 4.41673 5.66985 4.74007 5.32697Z"
        fill="currentColor"
      />
    </svg>
  ),

  dietaryFreeRange: ({ classname = '', props }) => (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path d="M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z" />
      <g clipPath="url(#clip0_4215_1264)">
        <path
          d="M21.1547 9.71739C19.8679 9.19953 18.4869 9.08968 17.2943 9.85862C17.0589 10.0155 16.9176 9.96847 16.7607 9.73308C16.1801 8.86998 15.4268 8.27366 14.3911 8.06965C13.7791 8.08535 13.1514 8.00688 12.5394 8.16381C11.7861 8.38351 11.1898 8.8386 10.7818 9.4663C10.4523 9.95278 10.1698 10.0155 9.699 9.70169C8.71037 9.02691 7.64327 9.19953 6.59186 9.51338C6.02692 9.686 5.86999 10.0312 6.10538 10.5648C6.32508 11.0513 6.63893 11.475 6.95279 11.9144C7.45495 12.6362 8.06697 13.0285 9.02422 12.9344C10.0599 12.8245 10.0599 12.8873 10.2012 13.923C10.4052 15.3981 10.5621 16.8732 10.5935 18.364C10.6092 19.1801 10.9544 19.6665 11.6606 19.8235C12.1314 19.8705 12.4923 19.8392 12.7748 19.745C13.2299 20.0902 14.093 20.0745 14.5951 19.7607C14.909 19.8078 15.3954 19.8235 15.7093 19.7764C16.0388 19.7136 17.0589 19.3841 16.949 18.6936L16.9019 17.344C16.9333 16.0101 17.153 14.692 17.31 13.3581C17.3413 13.0442 17.2943 12.291 17.5767 12.3538C19.1146 12.6676 20.1346 11.9144 20.4642 11.6319C20.8722 11.2867 21.3116 9.78016 21.1547 9.71739ZM11.127 13.9387C11.127 13.719 11.3154 13.5307 11.535 13.5307C11.7547 13.5307 11.9431 13.719 11.9431 13.9387C11.9431 14.1584 11.7547 14.3467 11.535 14.3467C11.3154 14.3624 11.127 14.1741 11.127 13.9387ZM16.1644 18.7093C16.0388 18.929 15.8191 19.0231 15.5838 19.1016C15.4896 19.133 15.4111 19.0859 15.4268 18.9761C15.5053 18.2699 15.0031 18.3797 14.5951 18.364C14.4853 18.364 14.1243 18.3797 14.0459 18.3797L13.7634 18.3954C13.4339 18.3954 12.9474 18.3797 12.6178 18.3797C12.3668 18.3797 12.1721 18.6705 12.2035 19C12.2506 19.4394 11.9431 19.133 11.6763 19.0545C11.1584 18.6151 11.1584 18.521 11.6292 17.8933C11.8018 17.752 12.0529 17.6893 12.1 17.4539C12.2412 16.8262 12.8689 15.0215 13.0102 14.7861C13.0415 14.6763 13.0572 14.5507 13.0729 14.4409C13.1043 14.1898 13.1357 13.9387 13.1514 13.6876C13.1514 13.2796 13.1357 12.8716 13.1357 12.5264C13.0259 11.8516 12.6963 11.2553 11.9117 10.8002C10.7263 10.2075 13.2845 9.63124 14.7035 10C15.4896 10.2043 15.8976 10.5 15.1914 10.9728C14.6893 11.2239 14.5167 11.5848 14.4068 12.0556C14.2813 12.5735 14.2185 13.0913 14.2185 13.6092C14.2185 13.7347 14.2185 13.8603 14.2342 14.0015C14.2342 14.0643 14.2499 14.127 14.2499 14.1898C14.2813 14.5036 14.344 14.8332 14.4225 15.147C14.7677 15.7591 14.8776 16.4652 15.1444 17.1086C15.2385 17.3283 15.317 17.5323 15.5524 17.6579C15.7564 17.7677 15.9447 17.9403 16.0702 18.1444C16.1644 18.317 16.2742 18.4896 16.1644 18.7093ZM15.8976 14.3624C15.6779 14.3624 15.4896 14.1741 15.4896 13.9544C15.4896 13.7347 15.6779 13.5464 15.8976 13.5464C16.1173 13.5464 16.3056 13.7347 16.3056 13.9544C16.3056 14.1741 16.133 14.3624 15.8976 14.3624Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_4215_1264">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  quoteLarge: ({ classname = '', ...props }) => (
    <svg
      width="61"
      height="64"
      viewBox="0 0 61 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_2340_14664)">
        <mask id="path-1-inside-1_2340_14664" fill="white">
          <path d="M0 8C0 3.58172 3.58172 0 8 0H53C57.4183 0 61 3.58172 61 8V56C61 60.4183 57.4183 64 53 64H8C3.58172 64 0 60.4183 0 56V8Z" />
        </mask>
        <path
          d="M27.9982 47.3119H13.4941V33.078C13.4941 23.9159 18.539 17.5352 27.9982 17.5352V23.4251C21.3768 23.7523 19.485 26.6972 19.485 32.5871H27.9982V47.3119Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M48.0197 47.3119H33.5156V33.078C33.5156 23.9159 38.5605 17.5352 48.0197 17.5352V23.4251C41.3983 23.7523 39.5064 26.6972 39.5064 32.5871H48.0197V47.3119Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <path
        d="M8 1.5H53V-1.5H8V1.5ZM59.5 8V56H62.5V8H59.5ZM53 62.5H8V65.5H53V62.5ZM1.5 56V8H-1.5V56H1.5ZM8 62.5C4.41015 62.5 1.5 59.5899 1.5 56H-1.5C-1.5 61.2467 2.7533 65.5 8 65.5V62.5ZM59.5 56C59.5 59.5899 56.5899 62.5 53 62.5V65.5C58.2467 65.5 62.5 61.2467 62.5 56H59.5ZM53 1.5C56.5899 1.5 59.5 4.41015 59.5 8H62.5C62.5 2.75329 58.2467 -1.5 53 -1.5V1.5ZM8 -1.5C2.75329 -1.5 -1.5 2.7533 -1.5 8H1.5C1.5 4.41015 4.41015 1.5 8 1.5V-1.5Z"
        fill="black"
        mask="url(#path-1-inside-1_2340_14664)"
      />
      <defs>
        <clipPath id="clip0_2340_14664">
          <path
            d="M0 8C0 3.58172 3.58172 0 8 0H53C57.4183 0 61 3.58172 61 8V56C61 60.4183 57.4183 64 53 64H8C3.58172 64 0 60.4183 0 56V8Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  percentage: ({ classname = '', ...props }) => (
    <svg
      width="64"
      height="65"
      viewBox="0 0 64 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_2435_15242)">
        <mask id="path-2-inside-1_2435_15242" fill="white">
          <path d="M0 8C0 3.58172 3.58172 0 8 0H56C60.4183 0 64 3.58172 64 8V56.8637C64 61.2819 60.4183 64.8637 56 64.8637H8C3.58172 64.8637 0 61.2819 0 56.8637V8Z" />
        </mask>
        <path
          d="M8 1.5H56V-1.5H8V1.5ZM62.5 8V56.8637H65.5V8H62.5ZM56 63.3637H8V66.3637H56V63.3637ZM1.5 56.8637V8H-1.5V56.8637H1.5ZM8 63.3637C4.41015 63.3637 1.5 60.4535 1.5 56.8637H-1.5C-1.5 62.1104 2.7533 66.3637 8 66.3637V63.3637ZM62.5 56.8637C62.5 60.4535 59.5899 63.3637 56 63.3637V66.3637C61.2467 66.3637 65.5 62.1104 65.5 56.8637H62.5ZM56 1.5C59.5899 1.5 62.5 4.41015 62.5 8H65.5C65.5 2.75329 61.2467 -1.5 56 -1.5V1.5ZM8 -1.5C2.7533 -1.5 -1.5 2.75329 -1.5 8H1.5C1.5 4.41015 4.41015 1.5 8 1.5V-1.5Z"
          fill="black"
          mask="url(#path-2-inside-1_2435_15242)"
        />
        <path
          d="M28.6923 14.7577C28.6923 22.4956 22.4355 28.7653 14.7212 28.7653C7.00685 28.7653 0.75 22.4956 0.75 14.7577C0.75 7.01969 7.00685 0.75 14.7212 0.75C22.4355 0.75 28.6923 7.01969 28.6923 14.7577Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M63.0966 50.2423C63.0966 57.9802 56.8398 64.2499 49.1255 64.2499C41.4112 64.2499 35.1543 57.9802 35.1543 50.2423C35.1543 42.5043 41.4112 36.2346 49.1255 36.2346C56.8398 36.2346 63.0966 42.5043 63.0966 50.2423Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M43.3367 0L0.331055 60.3571"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M63.8465 4.64282L20.8408 64.6683"
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_2435_15242">
          <path
            d="M0 8C0 3.58172 3.58172 0 8 0H56C60.4183 0 64 3.58172 64 8V57C64 61.4183 60.4183 65 56 65H8C3.58172 65 0 61.4183 0 57V8Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  venn: ({ width = 52, height = 53, classname = '', ...props }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 52 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M0.669829 8.19995C0.669829 4.15161 3.95166 0.86978 8 0.86978H44C48.0483 0.86978 51.3302 4.15161 51.3302 8.19995V44.7999C51.3302 48.8483 48.0483 52.1301 44 52.1301H8C3.95166 52.1301 0.669829 48.8483 0.669829 44.7999V8.19995Z"
        stroke="black"
        strokeWidth="1.33966"
      />
      <mask id="path-2-inside-1_5270_59715" fill="white">
        <path d="M0 8.19995C0 3.78168 3.58172 0.199951 8 0.199951H44C48.4183 0.199951 52 3.78167 52 8.19995V44.7999C52 49.2182 48.4183 52.7999 44 52.7999H8C3.58172 52.7999 0 49.2182 0 44.8V8.19995Z" />
      </mask>
      <path
        d="M8 1.69995H44V-1.30005H8V1.69995ZM50.5 8.19995V44.7999H53.5V8.19995H50.5ZM44 51.2999H8V54.2999H44V51.2999ZM1.5 44.8V8.19995H-1.5V44.8H1.5ZM8 51.2999C4.41015 51.2999 1.5 48.3898 1.5 44.8H-1.5C-1.5 50.0467 2.75329 54.2999 8 54.2999V51.2999ZM50.5 44.7999C50.5 48.3898 47.5898 51.2999 44 51.2999V54.2999C49.2467 54.2999 53.5 50.0467 53.5 44.7999H50.5ZM44 1.69995C47.5899 1.69995 50.5 4.6101 50.5 8.19995H53.5C53.5 2.95325 49.2467 -1.30005 44 -1.30005V1.69995ZM8 -1.30005C2.75329 -1.30005 -1.5 2.95325 -1.5 8.19995H1.5C1.5 4.6101 4.41015 1.69995 8 1.69995V-1.30005Z"
        fill="black"
        mask="url(#path-2-inside-1_5270_59715)"
      />
      <path
        d="M42.8857 26.0722C42.8857 31.9097 38.1561 36.6413 32.3227 36.6413C26.4894 36.6413 21.7598 31.9097 21.7598 26.0722C21.7598 20.2346 26.4894 15.5031 32.3227 15.5031C38.1561 15.5031 42.8857 20.2346 42.8857 26.0722Z"
        fill={getBrandColor()}
        stroke="black"
        strokeWidth="1.5"
      />
      <path
        d="M30.4951 26.0722C30.4951 31.9097 25.7655 36.6413 19.9321 36.6413C14.0987 36.6413 9.36914 31.9097 9.36914 26.0722C9.36914 20.2346 14.0987 15.5031 19.9321 15.5031C25.7655 15.5031 30.4951 20.2346 30.4951 26.0722Z"
        stroke="black"
        strokeWidth="1.5"
      />
      <mask id="path-6-inside-2_5270_59715" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.1274 35.5447C29.2095 33.5226 31.2451 30.0353 31.2451 26.0722C31.2451 22.1092 29.2095 18.6218 26.1274 16.5997C23.0453 18.6218 21.0098 22.1092 21.0098 26.0722C21.0098 30.0353 23.0453 33.5226 26.1274 35.5447Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.1274 35.5447C29.2095 33.5226 31.2451 30.0353 31.2451 26.0722C31.2451 22.1092 29.2095 18.6218 26.1274 16.5997C23.0453 18.6218 21.0098 22.1092 21.0098 26.0722C21.0098 30.0353 23.0453 33.5226 26.1274 35.5447Z"
        fill="#FAF9F5"
      />
      <path
        d="M26.1274 35.5447L25.3046 36.7989L26.1274 37.3387L26.9503 36.7989L26.1274 35.5447ZM26.1274 16.5997L26.9503 15.3456L26.1274 14.8057L25.3046 15.3456L26.1274 16.5997ZM29.7451 26.0722C29.7451 29.509 27.9818 32.5341 25.3046 34.2905L26.9503 36.7989C30.4372 34.5112 32.7451 30.5616 32.7451 26.0722H29.7451ZM25.3046 17.8539C27.9818 19.6104 29.7451 22.6355 29.7451 26.0722H32.7451C32.7451 21.5829 30.4372 17.6333 26.9503 15.3456L25.3046 17.8539ZM22.5098 26.0722C22.5098 22.6355 24.273 19.6104 26.9503 17.8539L25.3046 15.3456C21.8176 17.6333 19.5098 21.5829 19.5098 26.0722H22.5098ZM26.9503 34.2905C24.273 32.5341 22.5098 29.509 22.5098 26.0722H19.5098C19.5098 30.5616 21.8176 34.5112 25.3046 36.7989L26.9503 34.2905Z"
        fill="black"
        mask="url(#path-6-inside-2_5270_59715)"
      />
    </svg>
  ),

  news: ({ width = 52, height = 53, classname = '', ...props }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 52 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_5270_59734)">
        <mask id="path-2-inside-1_5270_59734" fill="white">
          <path d="M0 8.19996C0 3.78168 3.58172 0.199951 8 0.199951H44C48.4183 0.199951 52 3.78167 52 8.19995V44.6896C52 49.1079 48.4183 52.6896 44 52.6896H8C3.58172 52.6896 0 49.1079 0 44.6896V8.19996Z" />
        </mask>
        <path
          d="M8 1.69995H44V-1.30005H8V1.69995ZM50.5 8.19995V44.6896H53.5V8.19995H50.5ZM44 51.1896H8V54.1896H44V51.1896ZM1.5 44.6896V8.19996H-1.5V44.6896H1.5ZM8 51.1896C4.41015 51.1896 1.5 48.2795 1.5 44.6896H-1.5C-1.5 49.9363 2.75329 54.1896 8 54.1896V51.1896ZM50.5 44.6896C50.5 48.2795 47.5898 51.1896 44 51.1896V54.1896C49.2467 54.1896 53.5 49.9363 53.5 44.6896H50.5ZM44 1.69995C47.5899 1.69995 50.5 4.6101 50.5 8.19995H53.5C53.5 2.95325 49.2467 -1.30005 44 -1.30005V1.69995ZM8 -1.30005C2.75329 -1.30005 -1.5 2.95326 -1.5 8.19996H1.5C1.5 4.61011 4.41015 1.69995 8 1.69995V-1.30005Z"
          fill="black"
          mask="url(#path-2-inside-1_5270_59734)"
        />
        <mask id="path-4-inside-2_5270_59734" fill="white">
          <path d="M5.66406 28.9153H24.479V46.0908H5.66406V28.9153Z" />
        </mask>
        <path
          d="M5.66406 28.9153H24.479V46.0908H5.66406V28.9153Z"
          fill={getBrandColor()}
        />
        <path
          d="M5.66406 28.9153V27.4153H4.16406V28.9153H5.66406ZM24.479 28.9153H25.979V27.4153H24.479V28.9153ZM24.479 46.0908V47.5908H25.979V46.0908H24.479ZM5.66406 46.0908H4.16406V47.5908H5.66406V46.0908ZM5.66406 30.4153H24.479V27.4153H5.66406V30.4153ZM22.979 28.9153V46.0908H25.979V28.9153H22.979ZM24.479 44.5908H5.66406V47.5908H24.479V44.5908ZM7.16406 46.0908V28.9153H4.16406V46.0908H7.16406Z"
          fill="black"
          mask="url(#path-4-inside-2_5270_59734)"
        />
        <mask id="path-6-inside-3_5270_59734" fill="white">
          <path d="M27.7041 28.9153H46.5191V35.3561H27.7041V28.9153Z" />
        </mask>
        <path
          d="M27.7041 28.9153V27.4153H26.2041V28.9153H27.7041ZM46.5191 28.9153H48.0191V27.4153H46.5191V28.9153ZM46.5191 35.3561V36.8561H48.0191V35.3561H46.5191ZM27.7041 35.3561H26.2041V36.8561H27.7041V35.3561ZM27.7041 30.4153H46.5191V27.4153H27.7041V30.4153ZM45.0191 28.9153V35.3561H48.0191V28.9153H45.0191ZM46.5191 33.8561H27.7041V36.8561H46.5191V33.8561ZM29.2041 35.3561V28.9153H26.2041V35.3561H29.2041Z"
          fill="black"
          mask="url(#path-6-inside-3_5270_59734)"
        />
        <mask id="path-8-inside-4_5270_59734" fill="white">
          <path d="M27.7041 39.65H46.5191V46.0908H27.7041V39.65Z" />
        </mask>
        <path
          d="M27.7041 39.65V38.15H26.2041V39.65H27.7041ZM46.5191 39.65H48.0191V38.15H46.5191V39.65ZM46.5191 46.0908V47.5908H48.0191V46.0908H46.5191ZM27.7041 46.0908H26.2041V47.5908H27.7041V46.0908ZM27.7041 41.15H46.5191V38.15H27.7041V41.15ZM45.0191 39.65V46.0908H48.0191V39.65H45.0191ZM46.5191 44.5908H27.7041V47.5908H46.5191V44.5908ZM29.2041 46.0908V39.65H26.2041V46.0908H29.2041Z"
          fill="black"
          mask="url(#path-8-inside-4_5270_59734)"
        />
        <mask id="path-10-inside-5_5270_59734" fill="white">
          <path d="M5.66406 6.37244H46.5194V24.0847H5.66406V6.37244Z" />
        </mask>
        <path
          d="M5.66406 6.37244V4.87244H4.16406V6.37244H5.66406ZM46.5194 6.37244H48.0194V4.87244H46.5194V6.37244ZM46.5194 24.0847V25.5847H48.0194V24.0847H46.5194ZM5.66406 24.0847H4.16406V25.5847H5.66406V24.0847ZM5.66406 7.87244H46.5194V4.87244H5.66406V7.87244ZM45.0194 6.37244V24.0847H48.0194V6.37244H45.0194ZM46.5194 22.5847H5.66406V25.5847H46.5194V22.5847ZM7.16406 24.0847V6.37244H4.16406V24.0847H7.16406Z"
          fill="black"
          mask="url(#path-10-inside-5_5270_59734)"
        />
      </g>
      <defs>
        <clipPath id="clip0_5270_59734">
          <path
            d="M0 8.19995C0 3.78168 3.58172 0.199951 8 0.199951H44C48.4183 0.199951 52 3.78167 52 8.19995V44.7999C52 49.2182 48.4183 52.7999 44 52.7999H8C3.58172 52.7999 0 49.2182 0 44.7999V8.19995Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  list: ({ classname = '', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M5.33333 4H14M5.33333 8H14M5.33333 12H14M2 4H2.00667M2 8H2.00667M2 12H2.00667"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  grid: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_6023_63542)">
        <path
          d="M5 1.5H1.5V5H5V1.5Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 1.5H7V5H10.5V1.5Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 7H7V10.5H10.5V7Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 7H1.5V10.5H5V7Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6023_63542">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  map: ({ classname = '', ...props }) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M4 9L0.5 11V3L4 1M4 9L8 11M4 9V1M8 11L11.5 9V1L8 3M8 11V3M8 3L4 1"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  percentage: ({ classname = '', useCurrentColor, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="53"
      viewBox="0 0 52 53"
      className={classname}
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_3121_71991)">
        <mask id="path-2-inside-1_3121_71991" fill="white">
          <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H44C48.4183 0 52 3.58172 52 8V44.4897C52 48.9079 48.4183 52.4897 44 52.4897H8C3.58172 52.4897 0 48.9079 0 44.4897V8.00001Z" />
        </mask>
        <path
          d="M8 1.5H44V-1.5H8V1.5ZM50.5 8V44.4897H53.5V8H50.5ZM44 50.9897H8V53.9897H44V50.9897ZM1.5 44.4897V8.00001H-1.5V44.4897H1.5ZM8 50.9897C4.41015 50.9897 1.5 48.0795 1.5 44.4897H-1.5C-1.5 49.7364 2.75329 53.9897 8 53.9897V50.9897ZM50.5 44.4897C50.5 48.0795 47.5898 50.9897 44 50.9897V53.9897C49.2467 53.9897 53.5 49.7364 53.5 44.4897H50.5ZM44 1.5C47.5899 1.5 50.5 4.41015 50.5 8H53.5C53.5 2.7533 49.2467 -1.5 44 -1.5V1.5ZM8 -1.5C2.75329 -1.5 -1.5 2.7533 -1.5 8.00001H1.5C1.5 4.41015 4.41015 1.5 8 1.5V-1.5Z"
          fill="black"
          mask="url(#path-2-inside-1_3121_71991)"
        />
        <path
          d="M23.1719 11.9423C23.1719 18.1226 18.1537 23.1347 11.9609 23.1347C5.76821 23.1347 0.75 18.1226 0.75 11.9423C0.75 5.76208 5.76821 0.75 11.9609 0.75C18.1537 0.75 23.1719 5.76208 23.1719 11.9423Z"
          fill={useCurrentColor ? 'currentColor' : getBrandColor()}
          stroke="black"
          strokeWidth="1"
        />
        <path
          d="M51.126 40.6577C51.126 46.8379 46.1078 51.85 39.9151 51.85C33.7223 51.85 28.7041 46.8379 28.7041 40.6577C28.7041 34.4774 33.7223 29.4653 39.9151 29.4653C46.1078 29.4653 51.126 34.4774 51.126 40.6577Z"
          fill={useCurrentColor ? 'currentColor' : getBrandColor()}
          stroke="black"
          strokeWidth="1"
        />
        <path d="M35.2107 0L0.268555 48.8429" stroke="black" strokeWidth="1" />
        <path
          d="M51.8757 3.7572L16.9336 52.3317"
          stroke="black"
          strokeWidth="1"
        />
      </g>
      <defs>
        <clipPath id="clip0_3121_71991">
          <path
            d="M0 8C0 3.58173 3.58172 0 8 0H44C48.4183 0 52 3.58172 52 8V44.6C52 49.0183 48.4183 52.6 44 52.6H8C3.58172 52.6 0 49.0183 0 44.6V8Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  playButton: ({ classname = '', ...props }) => (
    <svg
      width="49"
      height="50"
      viewBox="0 0 49 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <mask id="path-1-inside-1_4804_2800" fill="white">
        <path d="M-0.000244141 25.1887C-0.000244141 11.8185 10.8385 0.979736 24.2088 0.979736C37.579 0.979736 48.4178 11.8185 48.4178 25.1887C48.4178 38.559 37.579 49.3977 24.2088 49.3977C10.8385 49.3977 -0.000244141 38.559 -0.000244141 25.1887Z" />
      </mask>
      <path
        d="M24.2088 47.3977C11.9431 47.3977 1.99976 37.4544 1.99976 25.1887H-2.00024C-2.00024 39.6636 9.73393 51.3977 24.2088 51.3977V47.3977ZM46.4178 25.1887C46.4178 37.4544 36.4744 47.3977 24.2088 47.3977V51.3977C38.6836 51.3977 50.4178 39.6636 50.4178 25.1887H46.4178ZM24.2088 2.97974C36.4744 2.97974 46.4178 12.923 46.4178 25.1887H50.4178C50.4178 10.7139 38.6836 -1.02026 24.2088 -1.02026V2.97974ZM24.2088 -1.02026C9.73393 -1.02026 -2.00024 10.7139 -2.00024 25.1887H1.99976C1.99976 12.923 11.9431 2.97974 24.2088 2.97974V-1.02026Z"
        fill="white"
        mask="url(#path-1-inside-1_4804_2800)"
      />
      <path
        d="M19.2087 16.1887L33.2087 25.1887L19.2087 34.1887V16.1887Z"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  whitePercentage: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="53"
      viewBox="0 0 52 53"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_3121_72012)">
        <mask id="path-2-inside-1_3121_72012" fill="currentColor">
          <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H44C48.4183 0 52 3.58172 52 8V44.4897C52 48.9079 48.4183 52.4897 44 52.4897H8C3.58172 52.4897 0 48.9079 0 44.4897V8.00001Z" />
        </mask>
        <path
          d="M8 1.5H44V-1.5H8V1.5ZM50.5 8V44.4897H53.5V8H50.5ZM44 50.9897H8V53.9897H44V50.9897ZM1.5 44.4897V8.00001H-1.5V44.4897H1.5ZM8 50.9897C4.41015 50.9897 1.5 48.0795 1.5 44.4897H-1.5C-1.5 49.7364 2.75329 53.9897 8 53.9897V50.9897ZM50.5 44.4897C50.5 48.0795 47.5898 50.9897 44 50.9897V53.9897C49.2467 53.9897 53.5 49.7364 53.5 44.4897H50.5ZM44 1.5C47.5899 1.5 50.5 4.41015 50.5 8H53.5C53.5 2.7533 49.2467 -1.5 44 -1.5V1.5ZM8 -1.5C2.75329 -1.5 -1.5 2.7533 -1.5 8.00001H1.5C1.5 4.41015 4.41015 1.5 8 1.5V-1.5Z"
          fill="currentColor"
          mask="url(#path-2-inside-1_3121_72012)"
        />
        <path
          d="M23.1719 11.9423C23.1719 18.1226 18.1537 23.1347 11.9609 23.1347C5.76821 23.1347 0.75 18.1226 0.75 11.9423C0.75 5.76208 5.76821 0.75 11.9609 0.75C18.1537 0.75 23.1719 5.76208 23.1719 11.9423Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M51.126 40.6577C51.126 46.8379 46.1078 51.85 39.9151 51.85C33.7223 51.85 28.7041 46.8379 28.7041 40.6577C28.7041 34.4774 33.7223 29.4653 39.9151 29.4653C46.1078 29.4653 51.126 34.4774 51.126 40.6577Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M35.2107 0L0.268555 48.8429"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M51.8757 3.7572L16.9336 52.3317"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_3121_72012">
          <path
            d="M0 8C0 3.58173 3.58172 0 8 0H44C48.4183 0 52 3.58172 52 8V44.6C52 49.0183 48.4183 52.6 44 52.6H8C3.58172 52.6 0 49.0183 0 44.6V8Z"
            fill="currentColor"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  gfxChevron: ({ classname = '', ...props }) => (
    <svg
      width="52"
      height="52"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 75 76"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_3121_72052)">
        <mask id="path-1-inside-1_3121_72052" fill="white">
          <path d="M0.701172 8.59998C0.701172 4.1817 4.28289 0.599976 8.70117 0.599976H67.0002C71.4185 0.599976 75.0002 4.1817 75.0002 8.59998V67.6C75.0002 72.0182 71.4185 75.6 67.0002 75.6H8.70117C4.28289 75.6 0.701172 72.0182 0.701172 67.6V8.59998Z" />
        </mask>
        <path
          d="M0.786133 1.20923L38.0388 37.9076L0.786133 74.8331V1.20923Z"
          stroke={getBrandColor()}
          strokeWidth="1.5"
        />
        <path
          d="M37.6553 1.20923L74.9079 37.9076L37.6553 74.8331V1.20923Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <path
        d="M8.70117 2.09998H67.0002V-0.900024H8.70117V2.09998ZM73.5002 8.59998V67.6H76.5002V8.59998H73.5002ZM67.0002 74.1H8.70117V77.1H67.0002V74.1ZM2.20117 67.6V8.59998H-0.798828V67.6H2.20117ZM8.70117 74.1C5.11132 74.1 2.20117 71.1898 2.20117 67.6H-0.798828C-0.798828 72.8467 3.45447 77.1 8.70117 77.1V74.1ZM73.5002 67.6C73.5002 71.1898 70.5901 74.1 67.0002 74.1V77.1C72.2469 77.1 76.5002 72.8467 76.5002 67.6H73.5002ZM67.0002 2.09998C70.5901 2.09998 73.5002 5.01012 73.5002 8.59998H76.5002C76.5002 3.35327 72.2469 -0.900024 67.0002 -0.900024V2.09998ZM8.70117 -0.900024C3.45447 -0.900024 -0.798828 3.35327 -0.798828 8.59998H2.20117C2.20117 5.01013 5.11132 2.09998 8.70117 2.09998V-0.900024Z"
        fill="black"
        mask="url(#path-1-inside-1_3121_72052)"
      />
      <defs>
        <clipPath id="clip0_3121_72052">
          <path
            d="M0.701172 8.59998C0.701172 4.1817 4.28289 0.599976 8.70117 0.599976H67.0002C71.4185 0.599976 75.0002 4.1817 75.0002 8.59998V67.6C75.0002 72.0182 71.4185 75.6 67.0002 75.6H8.70117C4.28289 75.6 0.701172 72.0182 0.701172 67.6V8.59998Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  gfxChevronWhite: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="75"
      height="76"
      viewBox="0 0 75 76"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_3121_72061)">
        <mask id="path-1-inside-1_3121_72061" fill="white">
          <path d="M0.701172 8.59998C0.701172 4.1817 4.28289 0.599976 8.70117 0.599976H67.0002C71.4185 0.599976 75.0002 4.1817 75.0002 8.59998V67.6C75.0002 72.0182 71.4185 75.6 67.0002 75.6H8.70117C4.28289 75.6 0.701172 72.0182 0.701172 67.6V8.59998Z" />
        </mask>
        <path
          d="M0.786133 1.20923L38.0388 37.9076L0.786133 74.8331V1.20923Z"
          stroke="white"
          strokeWidth="1.5"
        />
        <path
          d="M37.6553 1.20923L74.9079 37.9076L37.6553 74.8331V1.20923Z"
          fill=""
          stroke="white"
          strokeWidth="1.5"
        />
      </g>
      <path
        d="M8.70117 2.09998H67.0002V-0.900024H8.70117V2.09998ZM73.5002 8.59998V67.6H76.5002V8.59998H73.5002ZM67.0002 74.1H8.70117V77.1H67.0002V74.1ZM2.20117 67.6V8.59998H-0.798828V67.6H2.20117ZM8.70117 74.1C5.11132 74.1 2.20117 71.1898 2.20117 67.6H-0.798828C-0.798828 72.8467 3.45447 77.1 8.70117 77.1V74.1ZM73.5002 67.6C73.5002 71.1898 70.5901 74.1 67.0002 74.1V77.1C72.2469 77.1 76.5002 72.8467 76.5002 67.6H73.5002ZM67.0002 2.09998C70.5901 2.09998 73.5002 5.01012 73.5002 8.59998H76.5002C76.5002 3.35327 72.2469 -0.900024 67.0002 -0.900024V2.09998ZM8.70117 -0.900024C3.45447 -0.900024 -0.798828 3.35327 -0.798828 8.59998H2.20117C2.20117 5.01013 5.11132 2.09998 8.70117 2.09998V-0.900024Z"
        fill="white"
        mask="url(#path-1-inside-1_3121_72061)"
      />
      <defs>
        <clipPath id="clip0_3121_72061">
          <path
            d="M0.701172 8.59998C0.701172 4.1817 4.28289 0.599976 8.70117 0.599976H67.0002C71.4185 0.599976 75.0002 4.1817 75.0002 8.59998V67.6C75.0002 72.0182 71.4185 75.6 67.0002 75.6H8.70117C4.28289 75.6 0.701172 72.0182 0.701172 67.6V8.59998Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  localBar: ({ classname = '', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M3 15.5V13.8333H7.16667V9.66667L0.5 2.16667V0.5H15.5V2.16667L8.83333 9.66667V13.8333H13V15.5H3ZM4.20833 3.83333H11.7917L13.2917 2.16667H2.70833L4.20833 3.83333ZM8 8.08333L10.3125 5.5H5.6875L8 8.08333Z"
        fill="white"
      />
    </svg>
  ),

  glass: ({ classname = '', ...props }) => (
    <svg
      width="127"
      height="132"
      viewBox="0 0 127 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.6984 131.536C25.6748 131.536 22.413 128.274 22.413 124.251C22.413 120.227 25.6748 116.965 29.6984 116.965H56.7435V71.3678L3.50946 17.9883C1.58226 16.0558 0.5 13.438 0.5 10.7088C0.5 5.01534 5.11544 0.399902 10.8089 0.399902H116.149C121.866 0.399902 126.5 5.03418 126.5 10.7509C126.5 13.4559 125.441 16.0536 123.55 17.9876L71.3522 71.3678V116.965H98.3973C102.421 116.965 105.683 120.227 105.683 124.251C105.683 128.274 102.421 131.536 98.3973 131.536H29.6984ZM94 23.3999C94 30.0273 88.6274 35.3999 82 35.3999C75.3726 35.3999 70 30.0273 70 23.3999C70 16.7725 75.3726 11.3999 82 11.3999C88.6274 11.3999 94 16.7725 94 23.3999ZM65 52.3999C69.4183 52.3999 73 48.8182 73 44.3999C73 39.9816 69.4183 36.3999 65 36.3999C60.5817 36.3999 57 39.9816 57 44.3999C57 48.8182 60.5817 52.3999 65 52.3999Z"
        fill="currentColor"
      />
    </svg>
  ),

  fastFood: ({ classname = '', ...props }) => (
    <svg
      width="131"
      height="132"
      viewBox="0 0 131 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M0 83.7635C0 72.9461 4.51553 64.2872 13.5466 57.7868C22.5777 51.2865 32.9485 48.0363 44.6591 48.0363C56.3697 48.0363 66.7405 51.2865 75.7716 57.7868C84.8027 64.2872 89.3182 72.9461 89.3182 83.7635H0ZM0 107.582V95.6726H89.3182V107.582H0ZM101.227 131.4V95.6726C101.227 95.6726 101.812 68.1143 89.3182 55.3999C79 44.8999 61.5 38.8999 61.5 38.8999L60.751 33.2738C60.1126 28.4784 63.8434 24.2181 68.681 24.2181H89.3182V6.35445C89.3182 3.06584 91.9841 0.399902 95.2727 0.399902C98.5613 0.399902 101.227 3.06584 101.227 6.35445V24.2181H122.163C126.895 24.2181 130.593 28.3031 130.123 33.0117L121.175 122.766C120.877 125.247 119.786 127.306 117.9 128.944C116.014 130.581 113.831 131.4 111.35 131.4H101.227ZM5.95455 131.4C4.26742 131.4 2.85322 130.829 1.71193 129.688C0.570644 128.547 0 127.132 0 125.445V119.491H89.3182V125.445C89.3182 127.132 88.7475 128.547 87.6063 129.688C86.465 130.829 85.0508 131.4 83.3636 131.4H5.95455Z"
        fill="white"
      />
    </svg>
  ),

  takeAway: ({ classname = '', ...props }) => (
    <svg
      width="130"
      height="132"
      viewBox="0 0 130 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.6461 1.65956C63.1589 -0.0199828 66.4347 -0.0199828 68.9476 1.65956C75.3416 5.71706 81.4785 10.1653 87.3418 14.9961C87.3418 14.9961 88.9506 16.077 88.9838 14.2229C88.8097 11.8116 88.9507 9.35884 89.4068 6.98087C89.8878 5.6838 91.1152 4.84403 92.4752 4.84403C92.4752 4.84403 99.6986 5.19324 104.268 5.82515C106.333 6.07459 107.934 7.75413 108.149 9.81614C108.149 9.81614 111.11 29.5466 111.773 36.6888C111.773 36.6888 112.337 40.289 117.57 46.4501C117.57 46.4501 128.177 61.383 129.405 64.2183C129.405 64.2183 131.876 69.3983 126.577 70.0967C126.577 70.0967 116.874 71.0778 115.928 71.2857C114.635 71.427 113.697 72.616 113.838 73.9463C113.838 73.9463 113.308 108.269 110.795 124.782C110.795 124.782 110.131 131.325 106.54 131.184C106.54 131.184 96.5969 130.868 94.2583 130.943C94.2583 130.943 93.2797 130.943 93.4207 129.579C93.4207 129.579 98.5127 76.0083 95.0544 48.9278C95.0544 48.9278 94.9217 45.4357 92.2679 44.6624C92.2679 44.6624 89.8214 43.6813 87.5159 46.7993C77.4646 60.934 71.9497 77.796 71.7423 95.1484C71.7423 95.1484 71.4604 103.687 72.7541 105.824C72.7541 105.824 73.5585 107.288 77.7134 107.637L82.9132 108.344C82.9132 108.344 83.8918 108.344 83.784 109.632C83.784 109.632 82.5981 125.347 82.2498 128.141C82.2498 128.773 82.1226 129.391 81.8683 129.995C81.8683 129.995 81.6858 130.519 80.0521 130.452C80.0521 130.452 57.0137 130.311 54.4345 130.452C54.4345 130.452 53.3481 130.452 53.1076 129.895C52.8588 129.296 51.4988 109.599 51.5651 106.797C51.4988 106.24 51.8471 105.683 52.3695 105.434C55.9356 103.197 58.2743 99.4554 58.7221 95.2565C59.0262 92.2467 59.0732 89.2479 58.8631 86.2602C58.8631 86.2602 59.7007 56.1365 59.9495 51.2725C59.9495 51.2725 60.0822 49.6262 57.9923 49.3519C57.4698 49.2105 56.9474 49.3186 56.4912 49.593C56.0351 49.8424 55.72 50.2914 55.579 50.8235V50.9981C55.579 51.1727 54.1194 70.8699 54.3931 78.7022C54.3931 78.7022 54.8824 83.849 51.3578 83.957C51.3578 83.957 47.9078 84.4809 47.7337 80.1739C47.7337 80.1739 47.9742 60.8592 48.8449 51.3058C48.8449 50.2249 48.0405 49.277 46.9624 49.1772C45.8096 49.0026 44.7647 49.7676 44.5574 50.8901C44.5574 50.9621 44.5574 51.0203 44.5574 51.0647C44.5574 51.0647 43.0895 69.5729 43.3632 79.3342C43.3632 79.3342 43.7861 84.0568 40.0127 83.8822C40.0127 83.8822 36.8779 84.2647 36.7038 80.0326C36.7038 80.0326 37.5414 53.584 37.7819 51.5552C37.7487 50.5076 36.9443 49.6262 35.8993 49.5265H35.692C34.5724 49.4516 33.5938 50.2249 33.4197 51.3058C33.3976 51.3778 33.3976 51.4388 33.4197 51.4887C33.4197 51.4887 32.0264 83.1505 32.2006 92.4545C32.2006 92.4545 32.0596 102.008 39.1088 105.891C39.1088 105.891 40.1537 106.481 40.1537 107.396C40.1537 107.396 40.9581 124.191 41.6879 129.579C41.6879 129.579 41.9367 130.909 40.784 130.909L23.0864 131.4C21.1707 131.358 19.5618 129.853 19.4623 127.933C17.19 110.156 16.0704 92.2134 16.2114 74.2955C16.3192 72.9319 15.4069 71.6764 14.0883 71.3605C14.0883 71.3605 5.00731 70.554 2.8428 69.9969C0.819269 69.4648 -0.366653 67.4028 0.122643 65.4073C0.216633 65.0581 0.357616 64.731 0.545594 64.4261C15.2328 38.9587 35.8662 17.4406 60.6461 1.65956Z"
        fill="currentColor"
      />
    </svg>
  ),

  quoteMarks: ({ classname = '', ...props }) => (
    <svg
      width="79"
      height="81"
      viewBox="0 0 79 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M35.8646 59.6399H17.2852V41.8475C17.2852 30.3949 23.7476 22.4189 35.8646 22.4189V29.7813C27.3827 30.1903 24.9593 33.8715 24.9593 41.2339H35.8646V59.6399Z"
        fill={getBrandColor()}
      />
      <path
        d="M61.5122 59.6399H42.9329V41.8475C42.9329 30.3949 49.3952 22.4189 61.5122 22.4189V29.7813C53.0303 30.1903 50.6069 33.8715 50.6069 41.2339H61.5122V59.6399Z"
        fill={getBrandColor()}
      />
    </svg>
  ),

  minus: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M4.1665 10H15.8332"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  userGraphic: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="101"
      viewBox="0 0 100 101"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#a)">
        <mask id="b" fill="#fff">
          <path d="M0 93a8 8 0 0 0 8 8h84a8 8 0 0 0 8-8V8.212a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8V93Z" />
        </mask>
        <path
          fill="#000"
          d="M8 101v-1.5h84v3H8V101Zm92-8h-1.5V8.212h3V93H100ZM92 .212v1.5H8v-3h84v1.5Zm-92 8h1.5V93h-3V8.212H0Zm8-8v1.5a6.5 6.5 0 0 0-6.5 6.5h-3a9.5 9.5 0 0 1 9.5-9.5v1.5Zm92 8h-1.5a6.5 6.5 0 0 0-6.5-6.5v-3a9.5 9.5 0 0 1 9.5 9.5H100ZM92 101v-1.5a6.5 6.5 0 0 0 6.5-6.5h3a9.5 9.5 0 0 1-9.5 9.5V101Zm-84 0v1.5A9.5 9.5 0 0 1-1.5 93h3A6.5 6.5 0 0 0 8 99.5v1.5Z"
          mask="url(#b)"
        />
        <mask id="c" fill="#fff">
          <path d="M-.201 101.516h100.277V89.818c0-27.691-22.447-50.14-50.138-50.14S-.202 62.128-.202 89.819v11.698Z" />
        </mask>
        <path
          fill={getBrandColor()}
          d="M-.201 101.516h100.277V89.818c0-27.691-22.447-50.14-50.138-50.14S-.202 62.128-.202 89.819v11.698Z"
        />
        <path
          fill="#000"
          d="M-.201 101.516v1.5h-1.5v-1.5h1.5Zm100.277 0h1.5v1.5h-1.5v-1.5Zm-100.277 0v-1.5h100.277v3H-.201v-1.5Zm100.277 0h-1.5V89.818h3v11.698h-1.5ZM-.202 89.818h1.5v11.698h-3V89.818h1.5Zm50.14-50.14v1.5c-26.863 0-48.64 21.777-48.64 48.64h-3c0-28.52 23.12-51.64 51.64-51.64v1.5Zm50.138 50.14h-1.5c0-26.863-21.776-48.64-48.638-48.64v-3c28.519 0 51.638 23.12 51.638 51.64h-1.5Z"
          mask="url(#c)"
        />
        <mask id="d" fill="#fff">
          <path d="M0 93a8 8 0 0 0 8 8h84a8 8 0 0 0 8-8V8.212a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8V93Z" />
        </mask>
        <path
          fill="#000"
          d="M8 101v-1.5h84v3H8V101Zm92-8h-1.5V8.212h3V93H100ZM92 .212v1.5H8v-3h84v1.5Zm-92 8h1.5V93h-3V8.212H0Zm8-8v1.5a6.5 6.5 0 0 0-6.5 6.5h-3a9.5 9.5 0 0 1 9.5-9.5v1.5Zm92 8h-1.5a6.5 6.5 0 0 0-6.5-6.5v-3a9.5 9.5 0 0 1 9.5 9.5H100ZM92 101v-1.5a6.5 6.5 0 0 0 6.5-6.5h3a9.5 9.5 0 0 1-9.5 9.5V101Zm-84 0v1.5A9.5 9.5 0 0 1-1.5 93h3A6.5 6.5 0 0 0 8 99.5v1.5Z"
          mask="url(#d)"
        />
        <path
          stroke="#000"
          strokeWidth={1.5}
          d="M74.554 25.766c0 13.528-11.002 24.5-24.578 24.5-13.576 0-24.578-10.972-24.578-24.5 0-13.53 11.002-24.5 24.578-24.5 13.576 0 24.578 10.97 24.578 24.5Z"
        />
        <mask id="e" fill="#fff">
          <path
            fillRule="evenodd"
            d="M68.066 43.225c-4.726 5.15-11.089 8.305-18.09 8.305-7 0-13.362-3.156-18.088-8.305 5.637-2.627 11.73-4.062 18.089-4.062 6.358 0 12.452 1.435 18.09 4.062Z"
            clipRule="evenodd"
          />
        </mask>
        <path
          fill="#FAF9F5"
          fillRule="evenodd"
          d="M68.066 43.225c-4.726 5.15-11.089 8.305-18.09 8.305-7 0-13.362-3.156-18.088-8.305 5.637-2.627 11.73-4.062 18.089-4.062 6.358 0 12.452 1.435 18.09 4.062Z"
          clipRule="evenodd"
        />
        <path
          fill="#000"
          d="m68.066 43.225 1.105 1.014 1.385-1.509-1.856-.865-.634 1.36Zm-18.09 8.305v1.5-1.5Zm-18.088-8.305-.634-1.36-1.856.865 1.385 1.509 1.105-1.014Zm18.089-4.062v-1.5 1.5Zm18.09 4.062L66.96 42.21c-4.479 4.88-10.456 7.82-16.984 7.82v3c7.472 0 14.22-3.372 19.194-8.791l-1.105-1.014Zm-18.09 8.305v-1.5c-6.53 0-12.505-2.94-16.984-7.82l-1.105 1.015-1.105 1.014c4.973 5.419 11.722 8.791 19.194 8.791v-1.5Zm-18.09-8.305.634 1.36c5.449-2.54 11.327-3.922 17.456-3.922v-3c-6.589 0-12.898 1.487-18.723 4.202l.634 1.36Zm18.09-4.062v1.5c6.129 0 12.007 1.382 17.456 3.921l.633-1.36.634-1.359c-5.825-2.715-12.135-4.202-18.723-4.202v1.5Z"
          mask="url(#e)"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            d="M0 93a8 8 0 0 0 8 8h84a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8v85Z"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  clock: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_6065_50887)">
        <path
          d="M6 3V6L8 7M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6065_50887">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  send: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M14.5 1.5L7.16667 8.83333"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 1.5L9.83333 14.5L7.16667 8.83333L1.5 6.16667L14.5 1.5Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  football: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M12 1.75 20.75 6.8l-1.18 9.9L12 22.25l-7.57-5.55L3.25 6.8 12 1.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="m12 1.75 3.1 4.78-3.1 2.17-3.1-2.17L12 1.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="m3.88 7.4 5 .57 1.24 4.66-3.5 3.18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m20.12 7.4-5 .57-1.24 4.66 3.5 3.18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.12 12.63h3.76"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),

  footballCircle: ({ classname = '', ...props }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_11441_65858)">
        <path
          d="M12 0C18.6274 0 24 5.37258 24 12C23.9998 18.6273 18.6273 24 12 24C5.3727 24 0.000197914 18.6273 0 12C3.45318e-05 5.37258 5.3726 1.03088e-06 12 0ZM12.9561 21.9531C14.3517 21.8207 15.6631 21.4014 16.832 20.7549L14.7217 20.333L12.9561 21.9531ZM6.55176 17.0156L7.17383 20.334C7.20005 20.4744 7.182 20.6119 7.13477 20.7363C8.27932 21.3751 9.56161 21.7957 10.9268 21.9414C10.9621 21.8071 11.0347 21.681 11.1445 21.5801L13.6309 19.2988L12.7197 16.5645L8.93164 15.3672L6.55176 17.0156ZM14.1475 16.1045L15.0703 18.873L18.1992 19.499C18.3016 19.5196 18.3946 19.5605 18.4756 19.6162C19.6073 18.6531 20.5205 17.4431 21.1338 16.0684C21.0493 15.9994 20.977 15.9131 20.9277 15.8076L19.4707 12.6826H16.7627L14.1475 16.1045ZM2.87402 16.0879C3.48476 17.4491 4.39059 18.6478 5.51074 19.6045L5.05664 17.1797L2.87402 16.0879ZM2.7793 9.7373C2.60959 9.83424 2.41797 9.85469 2.24121 9.81445C2.08438 10.5179 2 11.2493 2 12C2.00003 12.7854 2.0934 13.549 2.26465 14.2822C2.42151 14.2518 2.5893 14.2687 2.74316 14.3457L5.66406 15.8066L8.05762 14.1475V9.71582L5.68652 8.07324L2.7793 9.7373ZM9.55762 9.87207V13.9912L13.0342 15.0908L15.4482 11.9316L13.0342 8.77344L9.55762 9.87207ZM20.7705 11.9209L21.7803 14.0859C21.9231 13.413 22 12.7155 22 12C22 11.2137 21.906 10.4489 21.7344 9.71484L20.7705 11.9209ZM18.3809 4.2998C18.324 4.32773 18.2642 4.35215 18.1992 4.36523L15.0703 4.99121L14.1475 7.75879L16.7637 11.1826H19.457L20.9199 7.83691C20.946 7.77724 20.9801 7.72375 21.0186 7.6748C20.3902 6.36685 19.4859 5.21661 18.3809 4.2998ZM10.9727 2.05078C9.49946 2.20111 8.12159 2.6732 6.9082 3.39258C6.94358 3.49785 6.95901 3.61202 6.94336 3.72949L6.5293 6.83105L8.93164 8.49707L12.7197 7.29883L13.6299 4.56543L11.1445 2.28516C11.0702 2.21699 11.013 2.13676 10.9727 2.05078ZM5.31836 4.56055C4.27058 5.50226 3.42392 6.66223 2.84766 7.96875L5.03125 6.7207L5.31836 4.56055ZM14.7217 3.53125L16.6475 3.14551C15.5724 2.58003 14.3826 2.20424 13.1211 2.06348L14.7217 3.53125Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_11441_65858">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  graphicsTriangles: ({ classname = '', ...props }) => (
    <svg
      viewBox="0 0 102 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_4510_38525)">
        <mask id="path-1-inside-1_4510_38525" fill="white">
          <path d="M0.332031 8C0.332031 3.58172 3.91375 0 8.33203 0H93.332C97.7503 0 101.332 3.58172 101.332 8V95C101.332 99.4183 97.7503 103 93.332 103H8.33203C3.91375 103 0.332031 99.4183 0.332031 95V8Z" />
        </mask>
        <mask id="path-3-inside-2_4510_38525" fill="white">
          <path d="M0.332031 8C0.332031 3.58172 3.91375 0 8.33203 0H93.332C97.7503 0 101.332 3.58172 101.332 8V94.7839C101.332 99.2022 97.7503 102.784 93.332 102.784H8.33203C3.91375 102.784 0.332031 99.2022 0.332031 94.7839V8Z" />
        </mask>
        <path
          d="M8.33203 1.5H93.332V-1.5H8.33203V1.5ZM99.832 8V94.7839H102.832V8H99.832ZM93.332 101.284H8.33203V104.284H93.332V101.284ZM1.83203 94.7839V8H-1.16797V94.7839H1.83203ZM8.33203 101.284C4.74218 101.284 1.83203 98.3738 1.83203 94.7839H-1.16797C-1.16797 100.031 3.08532 104.284 8.33203 104.284V101.284ZM99.832 94.7839C99.832 98.3738 96.9219 101.284 93.332 101.284V104.284C98.5787 104.284 102.832 100.031 102.832 94.7839H99.832ZM93.332 1.5C96.9219 1.5 99.832 4.41015 99.832 8H102.832C102.832 2.7533 98.5787 -1.5 93.332 -1.5V1.5ZM8.33203 -1.5C3.08533 -1.5 -1.16797 2.7533 -1.16797 8H1.83203C1.83203 4.41015 4.74218 1.5 8.33203 1.5V-1.5Z"
          fill="black"
          mask="url(#path-3-inside-2_4510_38525)"
        />
        <rect
          y="1.06414"
          width="71.9357"
          height="71.9357"
          transform="matrix(0.704777 0.709429 -0.704777 0.709429 1.00975 0.237066)"
          stroke={getBrandColor()}
          strokeWidth="1.5"
        />
        <rect
          y="1.06414"
          width="71.9357"
          height="71.9357"
          transform="matrix(0.704777 0.709429 -0.704777 0.709429 103.478 0.237066)"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <mask id="path-7-inside-3_4510_38525" fill="white">
          <path d="M0.332031 6C0.332031 2.68629 3.01832 0 6.33203 0H95.332C98.6457 0 101.332 2.68629 101.332 6V96.7839C101.332 100.098 98.6457 102.784 95.332 102.784H6.33203C3.01832 102.784 0.332031 100.098 0.332031 96.7839V6Z" />
        </mask>
        <path
          d="M6.33203 1.5H95.332V-1.5H6.33203V1.5ZM99.832 6V96.7839H102.832V6H99.832ZM95.332 101.284H6.33203V104.284H95.332V101.284ZM1.83203 96.7839V6H-1.16797V96.7839H1.83203ZM6.33203 101.284C3.84675 101.284 1.83203 99.2692 1.83203 96.7839H-1.16797C-1.16797 100.926 2.18989 104.284 6.33203 104.284V101.284ZM99.832 96.7839C99.832 99.2692 97.8173 101.284 95.332 101.284V104.284C99.4742 104.284 102.832 100.926 102.832 96.7839H99.832ZM95.332 1.5C97.8173 1.5 99.832 3.51472 99.832 6H102.832C102.832 1.85786 99.4742 -1.5 95.332 -1.5V1.5ZM6.33203 -1.5C2.1899 -1.5 -1.16797 1.85787 -1.16797 6H1.83203C1.83203 3.51472 3.84675 1.5 6.33203 1.5V-1.5Z"
          fill="black"
          mask="url(#path-7-inside-3_4510_38525)"
        />
      </g>
      <path
        d="M8.33203 1.5H93.332V-1.5H8.33203V1.5ZM99.832 8V95H102.832V8H99.832ZM93.332 101.5H8.33203V104.5H93.332V101.5ZM1.83203 95V8H-1.16797V95H1.83203ZM8.33203 101.5C4.74218 101.5 1.83203 98.5899 1.83203 95H-1.16797C-1.16797 100.247 3.08532 104.5 8.33203 104.5V101.5ZM99.832 95C99.832 98.5899 96.9219 101.5 93.332 101.5V104.5C98.5787 104.5 102.832 100.247 102.832 95H99.832ZM93.332 1.5C96.9219 1.5 99.832 4.41015 99.832 8H102.832C102.832 2.7533 98.5787 -1.5 93.332 -1.5V1.5ZM8.33203 -1.5C3.08533 -1.5 -1.16797 2.7533 -1.16797 8H1.83203C1.83203 4.41015 4.74218 1.5 8.33203 1.5V-1.5Z"
        fill="black"
        mask="url(#path-1-inside-1_4510_38525)"
      />
      <defs>
        <clipPath id="clip0_4510_38525">
          <path
            d="M0.332031 8C0.332031 3.58172 3.91375 0 8.33203 0H93.332C97.7503 0 101.332 3.58172 101.332 8V95C101.332 99.4183 97.7503 103 93.332 103H8.33203C3.91375 103 0.332031 99.4183 0.332031 95V8Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  graphicsInfo: ({ classname = '', ...props }) => (
    <svg
      viewBox="0 0 102 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_4510_38531)">
        <mask id="path-2-inside-1_4510_38531" fill="white">
          <path d="M0 8C0 3.58172 3.58172 0 8 0H94C98.4183 0 102 3.58172 102 8V94.7839C102 99.2022 98.4183 102.784 94 102.784H8C3.58172 102.784 0 99.2022 0 94.7839V8Z" />
        </mask>
        <path
          d="M8 1.5H94V-1.5H8V1.5ZM100.5 8V94.7839H103.5V8H100.5ZM94 101.284H8V104.284H94V101.284ZM1.5 94.7839V8H-1.5V94.7839H1.5ZM8 101.284C4.41015 101.284 1.5 98.3738 1.5 94.7839H-1.5C-1.5 100.031 2.75329 104.284 8 104.284V101.284ZM100.5 94.7839C100.5 98.3738 97.5899 101.284 94 101.284V104.284C99.2467 104.284 103.5 100.031 103.5 94.7839H100.5ZM94 1.5C97.5899 1.5 100.5 4.41015 100.5 8H103.5C103.5 2.75329 99.2467 -1.5 94 -1.5V1.5ZM8 -1.5C2.7533 -1.5 -1.5 2.7533 -1.5 8H1.5C1.5 4.41015 4.41015 1.5 8 1.5V-1.5Z"
          fill="black"
          mask="url(#path-2-inside-1_4510_38531)"
        />
        <path
          d="M100.762 51.5C100.762 79.5371 78.3102 102.25 50.6338 102.25C22.9575 102.25 0.505859 79.5371 0.505859 51.5C0.505859 23.4629 22.9575 0.75 50.6338 0.75C78.3102 0.75 100.762 23.4629 100.762 51.5Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M61.2202 22.0715C61.2202 27.4596 56.8373 31.8317 51.4255 31.8317C46.0138 31.8317 41.6309 27.4596 41.6309 22.0715C41.6309 16.6834 46.0138 12.3113 51.4255 12.3113C56.8373 12.3113 61.2202 16.6834 61.2202 22.0715Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <rect
          x="40.8809"
          y="38.8877"
          width="21.0893"
          height="53.0765"
          rx="10.5447"
          fill="#FAF9F5"
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_4510_38531">
          <path
            d="M0 8C0 3.58172 3.58172 0 8 0H94C98.4183 0 102 3.58172 102 8V95C102 99.4183 98.4183 103 94 103H8C3.58172 103 0 99.4183 0 95V8Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  printer: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_5261_2297)">
        <path
          d="M3.99998 5.99992V1.33325H12V5.99992M3.99998 11.9999H2.66665C2.31302 11.9999 1.97389 11.8594 1.72384 11.6094C1.47379 11.3593 1.33331 11.0202 1.33331 10.6666V7.33325C1.33331 6.97963 1.47379 6.64049 1.72384 6.39044C1.97389 6.14039 2.31302 5.99992 2.66665 5.99992H13.3333C13.6869 5.99992 14.0261 6.14039 14.2761 6.39044C14.5262 6.64049 14.6666 6.97963 14.6666 7.33325V10.6666C14.6666 11.0202 14.5262 11.3593 14.2761 11.6094C14.0261 11.8594 13.6869 11.9999 13.3333 11.9999H12M3.99998 9.33325H12V14.6666H3.99998V9.33325Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5261_2297">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  helpCircle: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_5261_11279)">
        <path
          d="M6.05998 6.00016C6.21672 5.55461 6.52608 5.1789 6.93328 4.93958C7.34048 4.70027 7.81924 4.61279 8.28476 4.69264C8.75028 4.77249 9.17252 5.01451 9.4767 5.37585C9.78087 5.73718 9.94735 6.19451 9.94665 6.66683C9.94665 8.00016 7.94665 8.66683 7.94665 8.66683M7.99998 11.3335H8.00665M14.6666 8.00016C14.6666 11.6821 11.6819 14.6668 7.99998 14.6668C4.31808 14.6668 1.33331 11.6821 1.33331 8.00016C1.33331 4.31826 4.31808 1.3335 7.99998 1.3335C11.6819 1.3335 14.6666 4.31826 14.6666 8.00016Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5261_11279">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  cornerUpLeft: ({ classname = '', stroke = 'black', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M6.00033 9.33332L2.66699 5.99999M2.66699 5.99999L6.00033 2.66666M2.66699 5.99999H10.667C11.3742 5.99999 12.0525 6.28094 12.5526 6.78104C13.0527 7.28114 13.3337 7.95941 13.3337 8.66666V13.3333"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  settings: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M2 2.66675L6.66667 2.66675M9.33333 2.66675L14 2.66675M2 8.00008L8 8.00008M10.6667 8.00008L14 8.00008M2 13.3334L5.33333 13.3334M8 13.3334L14 13.3334M6.66667 0.666748L6.66667 4.66675M10.6667 6.00008L10.6667 10.0001M5.33333 11.3334L5.33333 15.3334"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  magnifier: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M21 21L16.65 16.65M11 8V14M8 11H14M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  file: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8M14 2L20 8M14 2L14 8H20M16 13H8M16 17H8M10 9H8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  ingredients: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M12 11.75H19M12 11.75H4.5M12 11.75C12 11.75 12 8 8.5 8C4.5 8 4.5 11.75 4.5 11.75M12 11.75C12 11.75 12 11 12 9.125C12 7.25 13.5 3.5 13.5 3.5M19 11.75V11.75C20.1943 11.75 21.0084 12.9596 20.5587 14.066L18.0455 20.25H5.95455L3.25302 13.6028C2.89329 12.7177 3.54455 11.75 4.5 11.75V11.75M19 11.75C19 11.75 19 11 19 9.125C19 7.25 17.5 3.5 17.5 3.5M17.5 3.5H13.5M17.5 3.5H19M13.5 3.5H12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),

  nutrition: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M8 21.25H3.94695C3.46332 21.25 3.10612 20.799 3.21689 20.3282L4.7279 13.9064C4.88732 13.2289 5.49194 12.75 6.18802 12.75H12M16 21.25H19.9976C20.4983 21.25 20.8584 20.7687 20.7172 20.2884L18.8167 13.8268C18.6289 13.1884 18.0431 12.75 17.3776 12.75H12M12 12.75V7.5M12 7.5H17C19.2091 7.5 21 5.70914 21 3.5V3.5C21 3.22386 20.7761 3 20.5 3H3.5C3.22386 3 3 3.22386 3 3.5V3.5C3 5.70914 4.79086 7.5 7 7.5H12ZM11.25 21.25L14.25 16.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),

  ruler: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M12 7V11.5M12 7H8M12 7H16M8 7H4.5C3.67157 7 3 7.67157 3 8.5V15.5C3 16.3284 3.67157 17 4.5 17H19.5C20.3284 17 21 16.3284 21 15.5V8.5C21 7.67157 20.3284 7 19.5 7H16M8 7V11.5M16 7V11.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),

  star: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="m5.6.6 1.545 3.13 3.455.505L8.1 6.67l.59 3.44L5.6 8.485 2.51 10.11l.59-3.44L.6 4.235l3.455-.505L5.6.6Z"
      />
    </svg>
  ),

  alertTriangle: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M11.9998 8.99996V13M11.9998 17H12.0098M10.2898 3.85996L1.81978 18C1.64514 18.3024 1.55274 18.6453 1.55177 18.9945C1.55079 19.3437 1.64127 19.6871 1.8142 19.9905C1.98714 20.2939 2.2365 20.5467 2.53748 20.7238C2.83847 20.9009 3.18058 20.9961 3.52978 21H20.4698C20.819 20.9961 21.1611 20.9009 21.4621 20.7238C21.7631 20.5467 22.0124 20.2939 22.1854 19.9905C22.3583 19.6871 22.4488 19.3437 22.4478 18.9945C22.4468 18.6453 22.3544 18.3024 22.1798 18L13.7098 3.85996C13.5315 3.56607 13.2805 3.32308 12.981 3.15444C12.6814 2.98581 12.3435 2.89722 11.9998 2.89722C11.656 2.89722 11.3181 2.98581 11.0186 3.15444C10.7191 3.32308 10.468 3.56607 10.2898 3.85996Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  gfxList: ({ classname = '', ...props }) => (
    <svg
      viewBox="0 0 52 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_5545_21017)">
        <mask id="path-2-inside-1_5545_21017" fill="white">
          <path d="M0 8.69996C0 4.28168 3.58172 0.699951 8 0.699951H44C48.4183 0.699951 52 4.28167 52 8.69995V45.1896C52 49.6079 48.4183 53.1896 44 53.1896H8C3.58172 53.1896 0 49.6079 0 45.1896V8.69996Z" />
        </mask>
        <path
          d="M8 2.19995H44V-0.800049H8V2.19995ZM50.5 8.69995V45.1896H53.5V8.69995H50.5ZM44 51.6896H8V54.6896H44V51.6896ZM1.5 45.1896V8.69996H-1.5V45.1896H1.5ZM8 51.6896C4.41015 51.6896 1.5 48.7795 1.5 45.1896H-1.5C-1.5 50.4363 2.75329 54.6896 8 54.6896V51.6896ZM50.5 45.1896C50.5 48.7795 47.5898 51.6896 44 51.6896V54.6896C49.2467 54.6896 53.5 50.4363 53.5 45.1896H50.5ZM44 2.19995C47.5899 2.19995 50.5 5.1101 50.5 8.69995H53.5C53.5 3.45325 49.2467 -0.800049 44 -0.800049V2.19995ZM8 -0.800049C2.75329 -0.800049 -1.5 3.45326 -1.5 8.69996H1.5C1.5 5.11011 4.41015 2.19995 8 2.19995V-0.800049Z"
          fill="black"
          mask="url(#path-2-inside-1_5545_21017)"
        />
        <mask id="path-4-inside-2_5545_21017" fill="white">
          <path d="M5.66406 29.4153H46.5194V35.8561H5.66406V29.4153Z" />
        </mask>
        <path
          d="M5.66406 29.4153V27.9153H4.16406V29.4153H5.66406ZM46.5194 29.4153H48.0194V27.9153H46.5194V29.4153ZM46.5194 35.8561V37.3561H48.0194V35.8561H46.5194ZM5.66406 35.8561H4.16406V37.3561H5.66406V35.8561ZM5.66406 30.9153H46.5194V27.9153H5.66406V30.9153ZM45.0194 29.4153V35.8561H48.0194V29.4153H45.0194ZM46.5194 34.3561H5.66406V37.3561H46.5194V34.3561ZM7.16406 35.8561V29.4153H4.16406V35.8561H7.16406Z"
          fill="black"
          mask="url(#path-4-inside-2_5545_21017)"
        />
        <mask id="path-6-inside-3_5545_21017" fill="white">
          <path d="M5.66406 40.15H46.5194V46.5908H5.66406V40.15Z" />
        </mask>
        <path
          d="M5.66406 40.15V38.65H4.16406V40.15H5.66406ZM46.5194 40.15H48.0194V38.65H46.5194V40.15ZM46.5194 46.5908V48.0908H48.0194V46.5908H46.5194ZM5.66406 46.5908H4.16406V48.0908H5.66406V46.5908ZM5.66406 41.65H46.5194V38.65H5.66406V41.65ZM45.0194 40.15V46.5908H48.0194V40.15H45.0194ZM46.5194 45.0908H5.66406V48.0908H46.5194V45.0908ZM7.16406 46.5908V40.15H4.16406V46.5908H7.16406Z"
          fill="black"
          mask="url(#path-6-inside-3_5545_21017)"
        />
        <mask id="path-8-inside-4_5545_21017" fill="white">
          <path d="M5.66406 6.87244H46.5194V24.5847H5.66406V6.87244Z" />
        </mask>
        <path
          d="M5.66406 6.87244H46.5194V24.5847H5.66406V6.87244Z"
          fill={getBrandColor()}
        />
        <path
          d="M5.66406 6.87244V5.37244H4.16406V6.87244H5.66406ZM46.5194 6.87244H48.0194V5.37244H46.5194V6.87244ZM46.5194 24.5847V26.0847H48.0194V24.5847H46.5194ZM5.66406 24.5847H4.16406V26.0847H5.66406V24.5847ZM5.66406 8.37244H46.5194V5.37244H5.66406V8.37244ZM45.0194 6.87244V24.5847H48.0194V6.87244H45.0194ZM46.5194 23.0847H5.66406V26.0847H46.5194V23.0847ZM7.16406 24.5847V6.87244H4.16406V24.5847H7.16406Z"
          fill="black"
          mask="url(#path-8-inside-4_5545_21017)"
        />
      </g>
      <defs>
        <clipPath id="clip0_5545_21017">
          <path
            d="M0 8.69995C0 4.28168 3.58172 0.699951 8 0.699951H44C48.4183 0.699951 52 4.28167 52 8.69995V45.2999C52 49.7182 48.4183 53.2999 44 53.2999H8C3.58172 53.2999 0 49.7182 0 45.2999V8.69995Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  listGraphic: ({ classname = '', ...props }) => (
    <svg
      width="52"
      height="54"
      viewBox="0 0 52 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_6475_10685)">
        <mask id="path-2-inside-1_6475_10685" fill="white">
          <path d="M0 8.70002C0 4.28174 3.58172 0.700012 8 0.700012H44C48.4183 0.700012 52 4.28173 52 8.70001V45.1897C52 49.6079 48.4183 53.1897 44 53.1897H8C3.58172 53.1897 0 49.608 0 45.1897V8.70002Z" />
        </mask>
        <path
          d="M8 2.20001H44V-0.799988H8V2.20001ZM50.5 8.70001V45.1897H53.5V8.70001H50.5ZM44 51.6897H8V54.6897H44V51.6897ZM1.5 45.1897V8.70002H-1.5V45.1897H1.5ZM8 51.6897C4.41015 51.6897 1.5 48.7795 1.5 45.1897H-1.5C-1.5 50.4364 2.75329 54.6897 8 54.6897V51.6897ZM50.5 45.1897C50.5 48.7795 47.5898 51.6897 44 51.6897V54.6897C49.2467 54.6897 53.5 50.4364 53.5 45.1897H50.5ZM44 2.20001C47.5899 2.20001 50.5 5.11016 50.5 8.70001H53.5C53.5 3.45331 49.2467 -0.799988 44 -0.799988V2.20001ZM8 -0.799988C2.75329 -0.799988 -1.5 3.45332 -1.5 8.70002H1.5C1.5 5.11017 4.41015 2.20001 8 2.20001V-0.799988Z"
          fill="black"
          mask="url(#path-2-inside-1_6475_10685)"
        />
        <mask id="path-4-inside-2_6475_10685" fill="white">
          <path d="M5.66455 29.4153H46.5199V35.8561H5.66455V29.4153Z" />
        </mask>
        <path
          d="M5.66455 29.4153V27.9153H4.16455V29.4153H5.66455ZM46.5199 29.4153H48.0199V27.9153H46.5199V29.4153ZM46.5199 35.8561V37.3561H48.0199V35.8561H46.5199ZM5.66455 35.8561H4.16455V37.3561H5.66455V35.8561ZM5.66455 30.9153H46.5199V27.9153H5.66455V30.9153ZM45.0199 29.4153V35.8561H48.0199V29.4153H45.0199ZM46.5199 34.3561H5.66455V37.3561H46.5199V34.3561ZM7.16455 35.8561V29.4153H4.16455V35.8561H7.16455Z"
          fill="black"
          mask="url(#path-4-inside-2_6475_10685)"
        />
        <mask id="path-6-inside-3_6475_10685" fill="white">
          <path d="M5.66455 40.15H46.5199V46.5908H5.66455V40.15Z" />
        </mask>
        <path
          d="M5.66455 40.15V38.65H4.16455V40.15H5.66455ZM46.5199 40.15H48.0199V38.65H46.5199V40.15ZM46.5199 46.5908V48.0908H48.0199V46.5908H46.5199ZM5.66455 46.5908H4.16455V48.0908H5.66455V46.5908ZM5.66455 41.65H46.5199V38.65H5.66455V41.65ZM45.0199 40.15V46.5908H48.0199V40.15H45.0199ZM46.5199 45.0908H5.66455V48.0908H46.5199V45.0908ZM7.16455 46.5908V40.15H4.16455V46.5908H7.16455Z"
          fill="black"
          mask="url(#path-6-inside-3_6475_10685)"
        />
        <mask id="path-8-inside-4_6475_10685" fill="white">
          <path d="M5.66455 6.87244H46.5199V24.5847H5.66455V6.87244Z" />
        </mask>
        <path
          d="M5.66455 6.87244H46.5199V24.5847H5.66455V6.87244Z"
          fill={getBrandColor()}
        />
        <path
          d="M5.66455 6.87244V5.37244H4.16455V6.87244H5.66455ZM46.5199 6.87244H48.0199V5.37244H46.5199V6.87244ZM46.5199 24.5847V26.0847H48.0199V24.5847H46.5199ZM5.66455 24.5847H4.16455V26.0847H5.66455V24.5847ZM5.66455 8.37244H46.5199V5.37244H5.66455V8.37244ZM45.0199 6.87244V24.5847H48.0199V6.87244H45.0199ZM46.5199 23.0847H5.66455V26.0847H46.5199V23.0847ZM7.16455 24.5847V6.87244H4.16455V24.5847H7.16455Z"
          fill="black"
          mask="url(#path-8-inside-4_6475_10685)"
        />
      </g>
      <defs>
        <clipPath id="clip0_6475_10685">
          <path
            d="M0 8.70002C0 4.28174 3.58172 0.700012 8 0.700012H44C48.4183 0.700012 52 4.28173 52 8.70001V45.3C52 49.7183 48.4183 53.3 44 53.3H8C3.58172 53.3 0 49.7183 0 45.3V8.70002Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  drag: ({ classname = '', ...props }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      aria-hidden="true"
      {...props}
    >
      <circle cx="7.5" cy="5" r="1.25" fill="currentColor" />
      <circle cx="12.5" cy="5" r="1.25" fill="currentColor" />
      <circle cx="7.5" cy="10" r="1.25" fill="currentColor" />
      <circle cx="12.5" cy="10" r="1.25" fill="currentColor" />
      <circle cx="7.5" cy="15" r="1.25" fill="currentColor" />
      <circle cx="12.5" cy="15" r="1.25" fill="currentColor" />
    </svg>
  ),

  eye: ({ classname = '', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_6644_36840)">
        <path
          d="M0.667969 8.00033C0.667969 8.00033 3.33464 2.66699 8.0013 2.66699C12.668 2.66699 15.3346 8.00033 15.3346 8.00033C15.3346 8.00033 12.668 13.3337 8.0013 13.3337C3.33464 13.3337 0.667969 8.00033 0.667969 8.00033Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.0013 10.0003C9.10587 10.0003 10.0013 9.10489 10.0013 8.00033C10.0013 6.89576 9.10587 6.00033 8.0013 6.00033C6.89673 6.00033 6.0013 6.89576 6.0013 8.00033C6.0013 9.10489 6.89673 10.0003 8.0013 10.0003Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6644_36840">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  eyeoff: ({ classname = '', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M6.58789 6.58691C6.21281 6.96199 6 7.4707 6 8.00018C6 9.10475 6.89543 10.0002 8 10.0002C8.52948 10.0002 9.03819 9.78737 9.41327 9.41229"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5268 11.5268C10.5093 12.3025 9.31158 12.7152 8.03215 12.7068C3.36548 12.7068 0.698812 8.00016 0.698812 8.00016C1.52736 6.45678 2.67623 5.10878 4.06548 4.05249"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.63281 3.42683C7.08919 3.32002 7.55644 3.26634 8.02515 3.26685C12.6918 3.26685 15.3585 8.00018 15.3585 8.00018C14.9538 8.75725 14.4712 9.47004 13.9185 10.1268"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.699219 0.666992L15.3659 15.3337"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  scanner: ({ classname = '', ...props }) => (
    <svg
      width="140"
      height="140"
      viewBox="0 0 140 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M102 17H119.333C121.632 17 123.836 18.2292 125.462 20.4171C127.087 22.605 128 25.5725 128 28.6667V110.333C128 113.428 127.087 116.395 125.462 118.583C123.836 120.771 121.632 122 119.333 122H102"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38 17H20.6667C18.3681 17 16.1637 18.2292 14.5384 20.4171C12.9131 22.605 12 25.5725 12 28.6667V110.333C12 113.428 12.9131 116.395 14.5384 118.583C16.1637 120.771 18.3681 122 20.6667 122H38"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38 47V93.999"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60 47V93.999"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M82 47V93.999"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M104 47V93.999"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  shoppingList: ({ classname = '', ...props }) => (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_7038_184407)">
        <mask id="path-2-inside-1_7038_184407" fill="white">
          <path d="M0.769531 8C0.769531 3.58172 4.35125 0 8.76953 0H82.0003C86.4186 0 90.0003 3.58172 90.0003 8V81.8112C90.0003 86.2295 86.4186 89.8112 82.0003 89.8112H8.76953C4.35126 89.8112 0.769531 86.2295 0.769531 81.8112V8Z" />
        </mask>
        <path
          d="M0.769531 8C0.769531 3.58172 4.35125 0 8.76953 0H82.0003C86.4186 0 90.0003 3.58172 90.0003 8V81.8112C90.0003 86.2295 86.4186 89.8112 82.0003 89.8112H8.76953C4.35126 89.8112 0.769531 86.2295 0.769531 81.8112V8Z"
          fill="#FAF9F5"
        />
        <path
          d="M8.76953 1.5H82.0003V-1.5H8.76953V1.5ZM88.5003 8V81.8112H91.5003V8H88.5003ZM82.0003 88.3112H8.76953V91.3112H82.0003V88.3112ZM2.26953 81.8112V8H-0.730469V81.8112H2.26953ZM8.76953 88.3112C5.17968 88.3112 2.26953 85.4011 2.26953 81.8112H-0.730469C-0.730469 87.0579 3.52283 91.3112 8.76953 91.3112V88.3112ZM88.5003 81.8112C88.5003 85.4011 85.5901 88.3112 82.0003 88.3112V91.3112C87.247 91.3112 91.5003 87.0579 91.5003 81.8112H88.5003ZM82.0003 1.5C85.5901 1.5 88.5003 4.41015 88.5003 8H91.5003C91.5003 2.75329 87.247 -1.5 82.0003 -1.5V1.5ZM8.76953 -1.5C3.52283 -1.5 -0.730469 2.75329 -0.730469 8H2.26953C2.26953 4.41015 5.17968 1.5 8.76953 1.5V-1.5Z"
          fill="black"
          mask="url(#path-2-inside-1_7038_184407)"
        />
        <mask id="path-4-inside-2_7038_184407" fill="white">
          <path d="M10.4902 49.1328H80.5971V60.1532H10.4902V49.1328Z" />
        </mask>
        <path
          d="M10.4902 49.1328V47.6328H8.99023V49.1328H10.4902ZM80.5971 49.1328H82.0971V47.6328H80.5971V49.1328ZM80.5971 60.1532V61.6532H82.0971V60.1532H80.5971ZM10.4902 60.1532H8.99023V61.6532H10.4902V60.1532ZM10.4902 50.6328H80.5971V47.6328H10.4902V50.6328ZM79.0971 49.1328V60.1532H82.0971V49.1328H79.0971ZM80.5971 58.6532H10.4902V61.6532H80.5971V58.6532ZM11.9902 60.1532V49.1328H8.99023V60.1532H11.9902Z"
          fill="black"
          mask="url(#path-4-inside-2_7038_184407)"
        />
        <mask id="path-6-inside-3_7038_184407" fill="white">
          <path d="M10.4902 67.5H80.5971V78.5204H10.4902V67.5Z" />
        </mask>
        <path
          d="M10.4902 67.5V66H8.99023V67.5H10.4902ZM80.5971 67.5H82.0971V66H80.5971V67.5ZM80.5971 78.5204V80.0204H82.0971V78.5204H80.5971ZM10.4902 78.5204H8.99023V80.0204H10.4902V78.5204ZM10.4902 69H80.5971V66H10.4902V69ZM79.0971 67.5V78.5204H82.0971V67.5H79.0971ZM80.5971 77.0204H10.4902V80.0204H80.5971V77.0204ZM11.9902 78.5204V67.5H8.99023V78.5204H11.9902Z"
          fill="black"
          mask="url(#path-6-inside-3_7038_184407)"
        />
        <mask id="path-8-inside-4_7038_184407" fill="white">
          <path d="M10.4902 10.5605H80.5971V40.8667H10.4902V10.5605Z" />
        </mask>
        <path
          d="M10.4902 10.5605H80.5971V40.8667H10.4902V10.5605Z"
          fill={getBrandColor()}
        />
        <path
          d="M10.4902 10.5605V9.06055H8.99023V10.5605H10.4902ZM80.5971 10.5605H82.0971V9.06055H80.5971V10.5605ZM80.5971 40.8667V42.3667H82.0971V40.8667H80.5971ZM10.4902 40.8667H8.99023V42.3667H10.4902V40.8667ZM10.4902 12.0605H80.5971V9.06055H10.4902V12.0605ZM79.0971 10.5605V40.8667H82.0971V10.5605H79.0971ZM80.5971 39.3667H10.4902V42.3667H80.5971V39.3667ZM11.9902 40.8667V10.5605H8.99023V40.8667H11.9902Z"
          fill="black"
          mask="url(#path-8-inside-4_7038_184407)"
        />
      </g>
      <defs>
        <clipPath id="clip0_7038_184407">
          <path
            d="M0.769531 8.62745C0.769531 3.86264 4.63217 0 9.39698 0H81.3728C86.1376 0 90.0003 3.86264 90.0003 8.62745V81.3726C90.0003 86.1374 86.1376 90 81.3728 90H9.39698C4.63217 90 0.769531 86.1374 0.769531 81.3726V8.62745Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  trash: ({ classname = '', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M2 4.00065H3.33333M3.33333 4.00065H14M3.33333 4.00065L3.33333 13.334C3.33333 13.6876 3.47381 14.0267 3.72386 14.2768C3.97391 14.5268 4.31304 14.6673 4.66667 14.6673H11.3333C11.687 14.6673 12.0261 14.5268 12.2761 14.2768C12.5262 14.0267 12.6667 13.6876 12.6667 13.334V4.00065M5.33333 4.00065V2.66732C5.33333 2.3137 5.47381 1.97456 5.72386 1.72451C5.97391 1.47446 6.31304 1.33398 6.66667 1.33398H9.33333C9.68696 1.33398 10.0261 1.47446 10.2761 1.72451C10.5262 1.97456 10.6667 2.3137 10.6667 2.66732V4.00065M6.66667 7.33398V11.334M9.33333 7.33398V11.334"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  copy: ({ classname = '', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_7038_184435)">
        <path
          d="M3.33398 10.0007H2.66732C2.3137 10.0007 1.97456 9.86018 1.72451 9.61013C1.47446 9.36008 1.33398 9.02094 1.33398 8.66732V2.66732C1.33398 2.3137 1.47446 1.97456 1.72451 1.72451C1.97456 1.47446 2.3137 1.33398 2.66732 1.33398H8.66732C9.02094 1.33398 9.36008 1.47446 9.61013 1.72451C9.86018 1.97456 10.0007 2.3137 10.0007 2.66732V3.33398M7.33398 6.00065H13.334C14.0704 6.00065 14.6673 6.5976 14.6673 7.33398V13.334C14.6673 14.0704 14.0704 14.6673 13.334 14.6673H7.33398C6.5976 14.6673 6.00065 14.0704 6.00065 13.334V7.33398C6.00065 6.5976 6.5976 6.00065 7.33398 6.00065Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7038_184435">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  pencil: ({ classname = '', ...props }) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M6 10.0001H10.5M8.25 1.75011C8.44891 1.5512 8.7187 1.43945 9 1.43945C9.13929 1.43945 9.27721 1.46689 9.4059 1.52019C9.53458 1.57349 9.65151 1.65162 9.75 1.75011C9.84849 1.8486 9.92662 1.96553 9.97992 2.09422C10.0332 2.2229 10.0607 2.36083 10.0607 2.50011C10.0607 2.6394 10.0332 2.77733 9.97992 2.90601C9.92662 3.0347 9.84849 3.15162 9.75 3.25011L3.5 9.50011L1.5 10.0001L2 8.00011L8.25 1.75011Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  pencilEdit: ({ classname = '', ...props }) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M5.09961 1.66076H1.59961C1.33439 1.66076 1.08004 1.76611 0.892503 1.95365C0.704966 2.14119 0.599609 2.39554 0.599609 2.66076V9.66076C0.599609 9.92597 0.704966 10.1803 0.892503 10.3679C1.08004 10.5554 1.33439 10.6608 1.59961 10.6608H8.59961C8.86483 10.6608 9.11918 10.5554 9.30672 10.3679C9.49425 10.1803 9.59961 9.92597 9.59961 9.66076V6.16076M8.84961 0.910758C9.04852 0.711845 9.3183 0.600098 9.59961 0.600098C9.88091 0.600098 10.1507 0.711845 10.3496 0.910758C10.5485 1.10967 10.6603 1.37945 10.6603 1.66076C10.6603 1.94206 10.5485 2.21185 10.3496 2.41076L5.59961 7.16076L3.59961 7.66076L4.09961 5.66076L8.84961 0.910758Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  house: ({ classname = '', ...props }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M7.5 18.3334V10H12.5V18.3334M2.5 7.50002L10 1.66669L17.5 7.50002V16.6667C17.5 17.1087 17.3244 17.5326 17.0118 17.8452C16.6993 18.1578 16.2754 18.3334 15.8333 18.3334H4.16667C3.72464 18.3334 3.30072 18.1578 2.98816 17.8452C2.67559 17.5326 2.5 17.1087 2.5 16.6667V7.50002Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  mastercard: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="42"
      viewBox="0 0 64 42"
      fill="none"
      className={classname}
      {...props}
    >
      <rect
        x="0.850746"
        y="0.850746"
        width="62.2985"
        height="40.2985"
        rx="7.31343"
        fill="white"
      />
      <rect
        x="0.850746"
        y="0.850746"
        width="62.2985"
        height="40.2985"
        rx="7.31343"
        stroke="#D1CFC7"
        strokeWidth="0.298507"
      />
      <path d="M36.4538 12.786H27.3252V29.214H36.4538V12.786Z" fill="#FF5F00" />
      <path
        d="M27.9049 21C27.9034 19.4179 28.2614 17.8561 28.9518 16.433C29.6422 15.0099 30.6468 13.7628 31.8896 12.786C30.3505 11.5745 28.5022 10.8211 26.5558 10.6119C24.6094 10.4027 22.6435 10.7461 20.8828 11.6029C19.1221 12.4597 17.6377 13.7953 16.5991 15.457C15.5605 17.1188 15.0098 19.0396 15.0098 21C15.0098 22.9604 15.5605 24.8812 16.5991 26.543C17.6377 28.2047 19.1221 29.5403 20.8828 30.3971C22.6435 31.2539 24.6094 31.5973 26.5558 31.3881C28.5022 31.1789 30.3505 30.4255 31.8896 29.214C30.6468 28.2372 29.6422 26.9901 28.9518 25.567C28.2615 24.1439 27.9035 22.5821 27.9049 21Z"
        fill="#EB001B"
      />
      <path
        d="M48.7688 21C48.7689 22.9604 48.2182 24.8812 47.1797 26.5429C46.1412 28.2047 44.6568 29.5403 42.8961 30.3971C41.1354 31.2539 39.1696 31.5973 37.2232 31.3881C35.2769 31.1789 33.4286 30.4255 31.8896 29.214C33.1313 28.2362 34.1351 26.9889 34.8253 25.566C35.5156 24.1431 35.8742 22.5819 35.8742 21C35.8742 19.4181 35.5156 17.8569 34.8253 16.434C34.1351 15.0111 33.1313 13.7638 31.8896 12.786C33.4286 11.5745 35.2769 10.8211 37.2232 10.6119C39.1696 10.4027 41.1354 10.7461 42.8961 11.6029C44.6568 12.4597 46.1412 13.7953 47.1797 15.4571C48.2182 17.1188 48.7689 19.0396 48.7688 21Z"
        fill="#F79E1B"
      />
      <path
        d="M47.7735 27.4741V27.1377H47.9089V27.0692H47.564V27.1377H47.6995V27.4741H47.7735ZM48.4431 27.4741V27.0685H48.3374L48.2158 27.3475L48.0941 27.0685H47.9884V27.4741H48.063V27.1682L48.177 27.4319H48.2545L48.3685 27.1675V27.4741H48.4431Z"
        fill="#F79E1B"
      />
    </svg>
  ),

  visa: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="42"
      viewBox="0 0 64 42"
      fill="none"
      className={classname}
      {...props}
    >
      <rect
        x="0.850746"
        y="0.850746"
        width="62.2985"
        height="40.2985"
        rx="7.31343"
        fill="white"
      />
      <rect
        x="0.850746"
        y="0.850746"
        width="62.2985"
        height="40.2985"
        rx="7.31343"
        stroke="#D1CFC7"
        strokeWidth="0.298507"
      />
      <path
        d="M31.6202 14.4815L28.7283 28.0192H25.2315L28.1238 14.4815H31.6202ZM46.333 23.2229L48.174 18.139L49.2334 23.2229H46.333ZM50.2346 28.0192H53.4692L50.6466 14.4815H47.661C46.9901 14.4815 46.4241 14.8723 46.1721 15.4748L40.9257 28.0192H44.598L45.3271 25.9977H49.8136L50.2346 28.0192ZM41.108 23.5991C41.1229 20.026 36.1739 19.8294 36.2081 18.2333C36.2184 17.747 36.6809 17.2311 37.6911 17.0987C38.193 17.0331 39.5728 16.983 41.1396 17.705L41.7532 14.8342C40.9116 14.5283 39.8287 14.2339 38.4818 14.2339C35.0255 14.2339 32.5927 16.0742 32.5722 18.7093C32.5504 20.658 34.3089 21.7455 35.634 22.3934C36.9963 23.0571 37.4541 23.4821 37.4481 24.0756C37.4391 24.9844 36.3613 25.3845 35.3558 25.4004C33.5973 25.4283 32.5769 24.9252 31.7636 24.5456L31.1299 27.5119C31.9467 27.8877 33.4549 28.2142 35.0195 28.2309C38.6927 28.2309 41.096 26.4133 41.108 23.5991ZM26.6233 14.4815L20.9576 28.0192H17.2605L14.4725 17.2152C14.3031 16.5498 14.1559 16.3064 13.6412 16.0258C12.8013 15.5694 11.4129 15.1405 10.1914 14.8749L10.2748 14.4815H16.2251C16.9832 14.4815 17.6656 14.9871 17.8376 15.8617L19.3103 23.6959L22.9493 14.4815H26.6233Z"
        fill="#1434CB"
      />
    </svg>
  ),

  applepay: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="42"
      viewBox="0 0 64 42"
      fill="none"
      className={classname}
      {...props}
    >
      <rect
        x="0.760903"
        y="0.850746"
        width="62.3881"
        height="40.2985"
        rx="7.31343"
        fill="white"
      />
      <rect
        x="0.760903"
        y="0.850746"
        width="62.3881"
        height="40.2985"
        rx="7.31343"
        stroke="#D1CFC7"
        strokeWidth="0.298507"
      />
      <path
        d="M20.9934 15.7606C21.4076 15.2425 21.6887 14.5468 21.6146 13.8359C21.0082 13.8661 20.2682 14.236 19.8398 14.7545C19.4552 15.1986 19.1147 15.9234 19.2035 16.6045C19.8842 16.6635 20.5642 16.2642 20.9934 15.7606Z"
        fill="#000008"
      />
      <path
        d="M21.6069 16.7375C20.6184 16.6786 19.7779 17.2985 19.3058 17.2985C18.8335 17.2985 18.1105 16.7671 17.3287 16.7815C16.311 16.7964 15.3667 17.3718 14.8503 18.287C13.7881 20.1177 14.57 22.8334 15.6029 24.3244C16.1045 25.0621 16.7091 25.8743 17.5056 25.8451C18.2582 25.8156 18.5532 25.3578 19.4681 25.3578C20.3822 25.3578 20.6479 25.8451 21.4446 25.8303C22.2708 25.8156 22.7873 25.0923 23.2889 24.3539C23.8644 23.513 24.0999 22.7011 24.1148 22.6565C24.0999 22.6417 22.5216 22.0363 22.507 20.2207C22.4921 18.7005 23.7461 17.9775 23.8052 17.9326C23.097 16.8852 21.9905 16.7671 21.6069 16.7375Z"
        fill="#000008"
      />
      <path
        d="M30.2143 14.6802C32.3628 14.6802 33.859 16.1612 33.859 18.3174C33.859 20.4814 32.332 21.9701 30.1604 21.9701H27.7815V25.7532H26.0628V14.6802L30.2143 14.6802ZM27.7815 20.5274H29.7536C31.2501 20.5274 32.1017 19.7218 32.1017 18.3251C32.1017 16.9286 31.2501 16.1305 29.7613 16.1305H27.7815V20.5274Z"
        fill="#000008"
      />
      <path
        d="M34.308 23.4588C34.308 22.0468 35.39 21.1797 37.3085 21.0723L39.5184 20.9419V20.3204C39.5184 19.4225 38.9121 18.8854 37.8994 18.8854C36.94 18.8854 36.3414 19.3457 36.1958 20.0671H34.6304C34.7224 18.609 35.9655 17.5347 37.9607 17.5347C39.9174 17.5347 41.1681 18.5707 41.1681 20.1898V25.7532H39.5797V24.4257H39.5415C39.0734 25.3235 38.0527 25.8913 36.9939 25.8913C35.4131 25.8913 34.308 24.9091 34.308 23.4588ZM39.5184 22.7299V22.093L37.5308 22.2157C36.5409 22.2848 35.9808 22.7222 35.9808 23.4128C35.9808 24.1187 36.564 24.5792 37.4542 24.5792C38.6128 24.5792 39.5184 23.7811 39.5184 22.7299Z"
        fill="#000008"
      />
      <path
        d="M42.6678 28.7229V27.38C42.7904 27.4107 43.0666 27.4107 43.2048 27.4107C43.9721 27.4107 44.3865 27.0884 44.6396 26.2597C44.6396 26.2443 44.7856 25.7686 44.7856 25.7609L41.8697 17.6805H43.6651L45.7065 24.2492H45.737L47.7784 17.6805H49.528L46.5043 26.1752C45.814 28.1321 45.0159 28.7613 43.343 28.7613C43.2048 28.7613 42.7904 28.7459 42.6678 28.7229Z"
        fill="#000008"
      />
    </svg>
  ),

  calendar: ({ classname = '', ...props }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M16 2V6M8 2V6M3 10H21M5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  shoppingBag: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M2 4.00065L4 1.33398H12L14 4.00065M2 4.00065V13.334C2 13.6876 2.14048 14.0267 2.39052 14.2768C2.64057 14.5268 2.97971 14.6673 3.33333 14.6673H12.6667C13.0203 14.6673 13.3594 14.5268 13.6095 14.2768C13.8595 14.0267 14 13.6876 14 13.334V4.00065M2 4.00065H14M10.6667 6.66732C10.6667 7.37456 10.3857 8.05284 9.88562 8.55294C9.38552 9.05303 8.70724 9.33398 8 9.33398C7.29276 9.33398 6.61448 9.05303 6.11438 8.55294C5.61428 8.05284 5.33333 7.37456 5.33333 6.66732"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  upload: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10M11.3333 5.33333L8 2M8 2L4.66667 5.33333M8 2V10"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  image: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14ZM3.33333 14L10.6667 6.66667L14 10M6.66667 5.66667C6.66667 6.21895 6.21895 6.66667 5.66667 6.66667C5.11438 6.66667 4.66667 6.21895 4.66667 5.66667C4.66667 5.11438 5.11438 4.66667 5.66667 4.66667C6.21895 4.66667 6.66667 5.11438 6.66667 5.66667Z"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  infoGrahic: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="145"
      height="147"
      viewBox="0 0 145 147"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_4176_162279)">
        <mask id="path-2-inside-1_4176_162279" fill="white">
          <path d="M0.889893 8.49999C0.889893 4.08171 4.47161 0.5 8.88989 0.5H137C141.418 0.5 145 4.08172 145 8.5V138.194C145 142.612 141.418 146.194 137 146.194H8.88988C4.4716 146.194 0.889893 142.612 0.889893 138.194V8.49999Z" />
        </mask>
        <path
          d="M8.88989 0.5V2H137V0.5V-1H8.88989V0.5ZM145 8.5H143.5V138.194H145H146.5V8.5H145ZM137 146.194V144.694H8.88988V146.194V147.694H137V146.194ZM0.889893 138.194H2.38989V8.49999H0.889893H-0.610107V138.194H0.889893ZM8.88988 146.194V144.694C5.30003 144.694 2.38989 141.784 2.38989 138.194H0.889893H-0.610107C-0.610107 143.44 3.64317 147.694 8.88988 147.694V146.194ZM145 138.194H143.5C143.5 141.784 140.59 144.694 137 144.694V146.194V147.694C142.247 147.694 146.5 143.44 146.5 138.194H145ZM137 0.5V2C140.59 2 143.5 4.91015 143.5 8.5H145H146.5C146.5 3.2533 142.247 -1 137 -1V0.5ZM8.88989 0.5V-1C3.64319 -1 -0.610107 3.25328 -0.610107 8.49999H0.889893H2.38989C2.38989 4.91014 5.30004 2 8.88989 2V0.5Z"
          fill="black"
          mask="url(#path-2-inside-1_4176_162279)"
        />
        <path
          d="M72.4279 1.25C111.702 1.25009 143.561 33.5865 143.561 73.5C143.561 113.413 111.702 145.75 72.4279 145.75C33.1533 145.75 1.2951 113.414 1.2951 73.5C1.2951 33.5865 33.1533 1.25 72.4279 1.25Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <mask id="path-5-inside-2_4176_162279" fill="white">
          <path d="M73.5452 16.8877C81.773 16.8877 88.4426 23.5582 88.4426 31.7861C88.4424 40.0138 81.7729 46.6835 73.5452 46.6836C65.3174 46.6836 58.647 40.0139 58.6467 31.7861C58.6467 23.5582 65.3173 16.8877 73.5452 16.8877Z" />
        </mask>
        <path
          d="M73.5452 16.8877C81.773 16.8877 88.4426 23.5582 88.4426 31.7861C88.4424 40.0138 81.7729 46.6835 73.5452 46.6836C65.3174 46.6836 58.647 40.0139 58.6467 31.7861C58.6467 23.5582 65.3173 16.8877 73.5452 16.8877Z"
          fill={getBrandColor()}
        />
        <path
          d="M73.5452 16.8877L73.5452 15.3877H73.5452V16.8877ZM88.4426 31.7861L89.9426 31.7862V31.7861H88.4426ZM73.5452 46.6836V48.1836H73.5452L73.5452 46.6836ZM58.6467 31.7861H57.1467V31.7862L58.6467 31.7861ZM73.5452 16.8877L73.5452 18.3877C80.9445 18.3877 86.9426 24.3866 86.9426 31.7861H88.4426H89.9426C89.9426 22.7299 82.6016 15.3877 73.5452 15.3877L73.5452 16.8877ZM88.4426 31.7861L86.9426 31.7861C86.9424 39.1854 80.9444 45.1836 73.5452 45.1836L73.5452 46.6836L73.5452 48.1836C82.6014 48.1835 89.9424 40.8422 89.9426 31.7862L88.4426 31.7861ZM73.5452 46.6836V45.1836C66.1457 45.1836 60.1469 39.1853 60.1467 31.7861L58.6467 31.7861L57.1467 31.7862C57.147 40.8424 64.4891 48.1836 73.5452 48.1836V46.6836ZM58.6467 31.7861H60.1467C60.1467 24.3866 66.1457 18.3877 73.5452 18.3877V16.8877V15.3877C64.4888 15.3877 57.1467 22.7298 57.1467 31.7861H58.6467Z"
          fill="black"
          mask="url(#path-5-inside-2_4176_162279)"
        />
        <rect
          x="58.6471"
          y="55.6224"
          width="29.7959"
          height="75.2347"
          rx="14.898"
          fill="#FAF9F5"
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_4176_162279">
          <path
            d="M0.889893 8.5C0.889893 4.08173 4.47161 0.5 8.88989 0.5H137C141.418 0.5 145 4.08172 145 8.5V138.5C145 142.918 141.418 146.5 137 146.5H8.88988C4.4716 146.5 0.889893 142.918 0.889893 138.5V8.5Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  frown: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M21.3333 21.3333C21.3333 21.3333 19.3333 18.6666 16 18.6666C12.6666 18.6666 10.6666 21.3333 10.6666 21.3333M12 12H12.0133M20 12H20.0133M29.3333 16C29.3333 23.3638 23.3638 29.3333 16 29.3333C8.63616 29.3333 2.66663 23.3638 2.66663 16C2.66663 8.63616 8.63616 2.66663 16 2.66663C23.3638 2.66663 29.3333 8.63616 29.3333 16Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  link: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_7976_42133)">
        <path
          d="M6.66668 8.66673C6.95298 9.04948 7.31825 9.36618 7.73771 9.59535C8.15717 9.82452 8.62102 9.9608 9.09778 9.99495C9.57454 10.0291 10.0531 9.9603 10.5009 9.79325C10.9487 9.62619 11.3554 9.36477 11.6933 9.02673L13.6933 7.02673C14.3005 6.39805 14.6365 5.55604 14.6289 4.68205C14.6213 3.80807 14.2708 2.97202 13.6527 2.354C13.0347 1.73597 12.1987 1.38541 11.3247 1.37781C10.4507 1.37022 9.60869 1.7062 8.98001 2.31339L7.83334 3.45339M9.33334 7.33339C9.04704 6.95064 8.68177 6.63394 8.26231 6.40477C7.84285 6.17559 7.37901 6.03931 6.90224 6.00517C6.42548 5.97102 5.94695 6.03981 5.49911 6.20687C5.05128 6.37393 4.6446 6.63534 4.30668 6.97339L2.30668 8.97339C1.69948 9.60207 1.3635 10.4441 1.3711 11.3181C1.37869 12.1921 1.72926 13.0281 2.34728 13.6461C2.96531 14.2641 3.80135 14.6147 4.67534 14.6223C5.54933 14.6299 6.39134 14.2939 7.02001 13.6867L8.16001 12.5467"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7976_42133">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  users: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M22.6667 28V25.3333C22.6667 23.9188 22.1048 22.5623 21.1046 21.5621C20.1044 20.5619 18.7479 20 17.3334 20H6.66671C5.25222 20 3.89567 20.5619 2.89547 21.5621C1.89528 22.5623 1.33337 23.9188 1.33337 25.3333V28M30.6667 28V25.3333C30.6658 24.1516 30.2725 23.0037 29.5485 22.0698C28.8245 21.1358 27.8109 20.4688 26.6667 20.1733M21.3334 4.17333C22.4806 4.46707 23.4974 5.13427 24.2236 6.06975C24.9497 7.00523 25.3438 8.15577 25.3438 9.34C25.3438 10.5242 24.9497 11.6748 24.2236 12.6103C23.4974 13.5457 22.4806 14.2129 21.3334 14.5067M17.3334 9.33333C17.3334 12.2789 14.9456 14.6667 12 14.6667C9.05452 14.6667 6.66671 12.2789 6.66671 9.33333C6.66671 6.38781 9.05452 4 12 4C14.9456 4 17.3334 6.38781 17.3334 9.33333Z"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  tv: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M22.6666 2.66663L16 9.33329L9.33329 2.66663M5.33329 9.33329H26.6666C28.1394 9.33329 29.3333 10.5272 29.3333 12V26.6666C29.3333 28.1394 28.1394 29.3333 26.6666 29.3333H5.33329C3.86053 29.3333 2.66663 28.1394 2.66663 26.6666V12C2.66663 10.5272 3.86053 9.33329 5.33329 9.33329Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  message: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M28 20C28 20.7072 27.719 21.3855 27.219 21.8856C26.7189 22.3857 26.0406 22.6667 25.3333 22.6667H9.33333L4 28V6.66667C4 5.95942 4.28095 5.28115 4.78105 4.78105C5.28115 4.28095 5.95942 4 6.66667 4H25.3333C26.0406 4 26.7189 4.28095 27.219 4.78105C27.719 5.28115 28 5.95942 28 6.66667V20Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  graphicsMedia: ({ classname = '', ...props }) => (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_8332_52658)">
        <path
          d="M0.769287 8.62745C0.769287 3.86264 4.63193 0 9.39674 0H81.3726C86.1374 0 90 3.86264 90 8.62745V81.3726C90 86.1374 86.1374 90 81.3726 90H9.39674C4.63193 90 0.769287 86.1374 0.769287 81.3726V8.62745Z"
          fill="white"
        />
        <mask id="path-2-inside-1_8332_52658" fill="white">
          <path d="M0.769287 8C0.769287 3.58172 4.35101 0 8.76929 0H82C86.4183 0 90 3.58172 90 8V81.8112C90 86.2295 86.4183 89.8112 82 89.8112H8.76929C4.35101 89.8112 0.769287 86.2295 0.769287 81.8112V8Z" />
        </mask>
        <path
          d="M8.76929 0V1.5H82V0V-1.5H8.76929V0ZM90 8H88.5V81.8112H90H91.5V8H90ZM82 89.8112V88.3112H8.76929V89.8112V91.3112H82V89.8112ZM0.769287 81.8112H2.26929V8H0.769287H-0.730713V81.8112H0.769287ZM8.76929 89.8112V88.3112C5.17944 88.3112 2.26929 85.4011 2.26929 81.8112H0.769287H-0.730713C-0.730713 87.0579 3.52259 91.3112 8.76929 91.3112V89.8112ZM90 81.8112H88.5C88.5 85.4011 85.5899 88.3112 82 88.3112V89.8112V91.3112C87.2467 91.3112 91.5 87.0579 91.5 81.8112H90ZM82 0V1.5C85.5899 1.5 88.5 4.41015 88.5 8H90H91.5C91.5 2.75329 87.2467 -1.5 82 -1.5V0ZM8.76929 0V-1.5C3.52258 -1.5 -0.730713 2.75329 -0.730713 8H0.769287H2.26929C2.26929 4.41015 5.17944 1.5 8.76929 1.5V0Z"
          fill="black"
          mask="url(#path-2-inside-1_8332_52658)"
        />
        <mask id="path-4-inside-2_8332_52658" fill="white">
          <path d="M10.4893 49.1328H42.7753V78.5206H10.4893V49.1328Z" />
        </mask>
        <path
          d="M10.4893 49.1328H42.7753V78.5206H10.4893V49.1328Z"
          fill={getBrandColor()}
        />
        <path
          d="M10.4893 49.1328V47.6328H8.98926V49.1328H10.4893ZM42.7753 49.1328H44.2753V47.6328H42.7753V49.1328ZM42.7753 78.5206V80.0206H44.2753V78.5206H42.7753ZM10.4893 78.5206H8.98926V80.0206H10.4893V78.5206ZM10.4893 49.1328V50.6328H42.7753V49.1328V47.6328H10.4893V49.1328ZM42.7753 49.1328H41.2753V78.5206H42.7753H44.2753V49.1328H42.7753ZM42.7753 78.5206V77.0206H10.4893V78.5206V80.0206H42.7753V78.5206ZM10.4893 78.5206H11.9893V49.1328H10.4893H8.98926V78.5206H10.4893Z"
          fill="black"
          mask="url(#path-4-inside-2_8332_52658)"
        />
        <mask id="path-6-inside-3_8332_52658" fill="white">
          <path d="M48.3101 49.1328H80.5961V60.1532H48.3101V49.1328Z" />
        </mask>
        <path
          d="M48.3101 49.1328V47.6328H46.8101V49.1328H48.3101ZM80.5961 49.1328H82.0961V47.6328H80.5961V49.1328ZM80.5961 60.1532V61.6532H82.0961V60.1532H80.5961ZM48.3101 60.1532H46.8101V61.6532H48.3101V60.1532ZM48.3101 49.1328V50.6328H80.5961V49.1328V47.6328H48.3101V49.1328ZM80.5961 49.1328H79.0961V60.1532H80.5961H82.0961V49.1328H80.5961ZM80.5961 60.1532V58.6532H48.3101V60.1532V61.6532H80.5961V60.1532ZM48.3101 60.1532H49.8101V49.1328H48.3101H46.8101V60.1532H48.3101Z"
          fill="black"
          mask="url(#path-6-inside-3_8332_52658)"
        />
        <mask id="path-8-inside-4_8332_52658" fill="white">
          <path d="M48.3101 67.5H80.5961V78.5204H48.3101V67.5Z" />
        </mask>
        <path
          d="M48.3101 67.5V66H46.8101V67.5H48.3101ZM80.5961 67.5H82.0961V66H80.5961V67.5ZM80.5961 78.5204V80.0204H82.0961V78.5204H80.5961ZM48.3101 78.5204H46.8101V80.0204H48.3101V78.5204ZM48.3101 67.5V69H80.5961V67.5V66H48.3101V67.5ZM80.5961 67.5H79.0961V78.5204H80.5961H82.0961V67.5H80.5961ZM80.5961 78.5204V77.0204H48.3101V78.5204V80.0204H80.5961V78.5204ZM48.3101 78.5204H49.8101V67.5H48.3101H46.8101V78.5204H48.3101Z"
          fill="black"
          mask="url(#path-8-inside-4_8332_52658)"
        />
        <mask id="path-10-inside-5_8332_52658" fill="white">
          <path d="M10.4893 10.5605H80.5961V40.8667H10.4893V10.5605Z" />
        </mask>
        <path
          d="M10.4893 10.5605V9.06055H8.98926V10.5605H10.4893ZM80.5961 10.5605H82.0961V9.06055H80.5961V10.5605ZM80.5961 40.8667V42.3667H82.0961V40.8667H80.5961ZM10.4893 40.8667H8.98926V42.3667H10.4893V40.8667ZM10.4893 10.5605V12.0605H80.5961V10.5605V9.06055H10.4893V10.5605ZM80.5961 10.5605H79.0961V40.8667H80.5961H82.0961V10.5605H80.5961ZM80.5961 40.8667V39.3667H10.4893V40.8667V42.3667H80.5961V40.8667ZM10.4893 40.8667H11.9893V10.5605H10.4893H8.98926V40.8667H10.4893Z"
          fill="black"
          mask="url(#path-10-inside-5_8332_52658)"
        />
      </g>
      <defs>
        <clipPath id="clip0_8332_52658">
          <path
            d="M0.769287 8.62745C0.769287 3.86264 4.63193 0 9.39674 0H81.3726C86.1374 0 90 3.86264 90 8.62745V81.3726C90 86.1374 86.1374 90 81.3726 90H9.39674C4.63193 90 0.769287 86.1374 0.769287 81.3726V8.62745Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  outbound: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M12 8.66667V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333M10 2H14M14 2V6M14 2L6.66667 9.33333"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  emptyBasketGraphic: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="101"
      height="101"
      viewBox="0 0 101 101"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_8772_98480)">
        <path
          d="M2.64941 1.51953L9.60039 17.8461M9.60039 17.8461L30.8878 67.8461H100.577V17.8461H9.60039Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M36.5869 74.209C43.7668 74.209 49.5674 79.9375 49.5674 86.9795C49.5673 94.0215 43.7668 99.75 36.5869 99.75C29.4071 99.7499 23.6065 94.0215 23.6064 86.9795C23.6064 79.9375 29.407 74.209 36.5869 74.209Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M99.7998 74.209C106.98 74.209 112.78 79.9375 112.78 86.9795C112.78 94.0215 106.98 99.75 99.7998 99.75C92.62 99.7499 86.8194 94.0215 86.8193 86.9795C86.8193 79.9375 92.6199 74.209 99.7998 74.209Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <mask id="path-5-inside-1_8772_98480" fill="white">
          <path d="M0.384766 92.5C0.384766 96.9183 3.96649 100.5 8.38477 100.5H92.6246C97.0429 100.5 100.625 96.9183 100.625 92.5V8.70976C100.625 4.29148 97.0429 0.709763 92.6246 0.709763H8.38477C3.96649 0.709763 0.384766 4.29148 0.384766 8.70976V92.5Z" />
        </mask>
        <path
          d="M8.38477 100.5V99H92.6246V100.5V102H8.38477V100.5ZM100.625 92.5H99.1246V8.70976H100.625H102.125V92.5H100.625ZM92.6246 0.709763V2.20976H8.38477V0.709763V-0.790237H92.6246V0.709763ZM0.384766 8.70976H1.88477V92.5H0.384766H-1.11523V8.70976H0.384766ZM8.38477 0.709763V2.20976C4.79492 2.20976 1.88477 5.11991 1.88477 8.70976H0.384766H-1.11523C-1.11523 3.46306 3.13807 -0.790237 8.38477 -0.790237V0.709763ZM100.625 8.70976H99.1246C99.1246 5.11991 96.2145 2.20976 92.6246 2.20976V0.709763V-0.790237C97.8713 -0.790237 102.125 3.46305 102.125 8.70976H100.625ZM92.6246 100.5V99C96.2144 99 99.1246 96.0898 99.1246 92.5H100.625H102.125C102.125 97.7467 97.8713 102 92.6246 102V100.5ZM8.38477 100.5V102C3.13806 102 -1.11523 97.7467 -1.11523 92.5H0.384766H1.88477C1.88477 96.0899 4.79491 99 8.38477 99V100.5Z"
          fill="black"
          mask="url(#path-5-inside-1_8772_98480)"
        />
      </g>
      <defs>
        <clipPath id="clip0_8772_98480">
          <path
            d="M0.5 92.5C0.5 96.9183 4.08172 100.5 8.5 100.5H92.5C96.9183 100.5 100.5 96.9183 100.5 92.5V8.5C100.5 4.08172 96.9183 0.5 92.5 0.5H8.5C4.08172 0.5 0.5 4.08172 0.5 8.5V92.5Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  pin: ({ classname = '', fill = 'none', stroke = 'black', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill={fill}
      className={classname}
      {...props}
    >
      <path
        d="M13 6.66669C13 11.3334 7 15.3334 7 15.3334C7 15.3334 1 11.3334 1 6.66669C1 5.07539 1.63214 3.54926 2.75736 2.42405C3.88258 1.29883 5.4087 0.666687 7 0.666687C8.5913 0.666687 10.1174 1.29883 11.2426 2.42405C12.3679 3.54926 13 5.07539 13 6.66669Z"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 8.66669C8.10457 8.66669 9 7.77126 9 6.66669C9 5.56212 8.10457 4.66669 7 4.66669C5.89543 4.66669 5 5.56212 5 6.66669C5 7.77126 5.89543 8.66669 7 8.66669Z"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  barcode: ({
    classname = '',
    fill = 'none',
    stroke = 'currentColor',
    ...props
  }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M10.4 2H13.0667C13.4203 2 13.7595 2.14048 14.0095 2.39052C14.2595 2.64057 14.4 2.97971 14.4 3.33333V12.6667C14.4 13.0203 14.2595 13.3594 14.0095 13.6095C13.7595 13.8595 13.4203 14 13.0667 14H10.4"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.59998 2H2.93331C2.57969 2 2.24055 2.14048 1.9905 2.39052C1.74045 2.64057 1.59998 2.97971 1.59998 3.33333V12.6667C1.59998 13.0203 1.74045 13.3594 1.9905 13.6095C2.24055 13.8595 2.57969 14 2.93331 14H5.59998"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 6.3999V10.3999"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 6.3999V10.3999"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 6.3999V10.3999"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  lock: ({ classname = '', fill = 'none', stroke = 'black', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M4.66667 7.33325V4.66659C4.66667 3.78253 5.01786 2.93468 5.64298 2.30956C6.2681 1.68444 7.11595 1.33325 8 1.33325C8.88406 1.33325 9.7319 1.68444 10.357 2.30956C10.9821 2.93468 11.3333 3.78253 11.3333 4.66659V7.33325M3.33333 7.33325H12.6667C13.403 7.33325 14 7.93021 14 8.66659V13.3333C14 14.0696 13.403 14.6666 12.6667 14.6666H3.33333C2.59695 14.6666 2 14.0696 2 13.3333V8.66659C2 7.93021 2.59695 7.33325 3.33333 7.33325Z"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  temp: ({ classname = '', fill = 'none', stroke = 'black', ...props }) => (
    <svg
  xmlns="http://www.w3.org/2000/svg"
  width="12"
  height="12"
  viewBox="0 0 12 12"
  fill="none"
>
  <path
    d="M7 7.38V1.75C7 1.41848 6.8683 1.10054 6.63388 0.866117C6.39946 0.631696 6.08152 0.5 5.75 0.5C5.41848 0.5 5.10054 0.631696 4.86612 0.866117C4.6317 1.10054 4.5 1.41848 4.5 1.75V7.38C4.09864 7.64817 3.79416 8.03831 3.63154 8.4928C3.46891 8.94729 3.45676 9.44203 3.59688 9.90395C3.737 10.3659 4.02196 10.7705 4.40967 11.058C4.79738 11.3456 5.26729 11.5008 5.75 11.5008C6.23271 11.5008 6.70262 11.3456 7.09033 11.058C7.47804 10.7705 7.763 10.3659 7.90312 9.90395C8.04324 9.44203 8.03109 8.94729 7.86846 8.4928C7.70584 8.03831 7.40136 7.64817 7 7.38Z"
    stroke="black"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>
  ),

  refresh: ({
    classname = '',
    fill = 'none',
    stroke = 'currentColor',
    ...props
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_10013_156332)">
        <path
          d="M15.3334 2.66668V6.66668M15.3334 6.66668H11.3334M15.3334 6.66668L12.2401 3.76001C11.5236 3.04315 10.6372 2.51948 9.66354 2.23786C8.68992 1.95624 7.66082 1.92584 6.67227 2.14952C5.68372 2.37319 4.76795 2.84363 4.01039 3.51696C3.25284 4.19028 2.67819 5.04453 2.34008 6.00001M0.666748 13.3333V9.33334M0.666748 9.33334H4.66675M0.666748 9.33334L3.76008 12.24C4.47658 12.9569 5.363 13.4805 6.33662 13.7622C7.31024 14.0438 8.33934 14.0742 9.32789 13.8505C10.3164 13.6268 11.2322 13.1564 11.9898 12.4831C12.7473 11.8097 13.322 10.9555 13.6601 10"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10013_156332">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  ratingPoor: ({ classname = '', bgcolor = 'white', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      className={cn('tw:text-primary', classname)}
      {...props}
    >
      <g clipPath="url(#clip0_10228_20416)">
        <circle cx="32" cy="32" r="31.5" fill={bgcolor} stroke="currentColor" />
        <path
          d="M32 38.1289C38.1544 38.1289 44.3089 42.1124 44.6777 50.0791C44.6889 50.415 44.3315 50.6384 44.0293 50.4932C40.2241 48.6797 36.1074 47.7734 32 47.7734C27.8926 47.7734 23.7747 48.6808 19.9707 50.4932C19.6686 50.6383 19.3111 50.415 19.3223 50.0791C19.6911 42.1124 25.8456 38.1289 32 38.1289Z"
          fill="currentColor"
        />
        <path d="M32 38.1289C38.1544 38.1289 44.3089 42.1124 44.6777 50.0791C44.6889 50.415 44.3315 50.6384 44.0293 50.4932C40.2241 48.6797 36.1074 47.7734 32 47.7734C27.8926 47.7734 23.7747 48.6808 19.9707 50.4932C19.6686 50.6383 19.3111 50.415 19.3223 50.0791C19.6911 42.1124 25.8456 38.1289 32 38.1289Z" />
        <path
          d="M21.3867 22.7129C23.9508 22.7131 26.0293 24.7923 26.0293 27.3564C26.0291 29.9204 23.9507 31.9988 21.3867 31.999C18.8225 31.999 16.7434 29.9206 16.7432 27.3564C16.7432 24.7921 18.8224 22.7129 21.3867 22.7129Z"
          fill="currentColor"
        />
        <path d="M21.3867 22.7129C23.9508 22.7131 26.0293 24.7923 26.0293 27.3564C26.0291 29.9204 23.9507 31.9988 21.3867 31.999C18.8225 31.999 16.7434 29.9206 16.7432 27.3564C16.7432 24.7921 18.8224 22.7129 21.3867 22.7129Z" />
        <path
          d="M25.9605 22.755C25.8635 22.755 25.7665 22.7471 25.6662 22.7291L16.5209 21.1163C15.6085 20.955 14.9984 20.0844 15.1596 19.172C15.3209 18.2585 16.1927 17.6506 17.1051 17.8108L26.2504 19.4235C27.1627 19.5848 27.7729 20.4554 27.6116 21.3678C27.4672 22.1821 26.759 22.755 25.9605 22.755Z"
          fill="currentColor"
        />
        <path
          d="M42.6143 22.7129C45.1784 22.7131 47.2568 24.7923 47.2568 27.3564C47.2566 29.9204 45.1782 31.9988 42.6143 31.999C40.0501 31.999 37.9709 29.9206 37.9707 27.3564C37.9707 24.7921 40.0499 22.7129 42.6143 22.7129Z"
          fill="currentColor"
        />
        <path d="M42.6143 22.7129C45.1784 22.7131 47.2568 24.7923 47.2568 27.3564C47.2566 29.9204 45.1782 31.9988 42.6143 31.999C40.0501 31.999 37.9709 29.9206 37.9707 27.3564C37.9707 24.7921 40.0499 22.7129 42.6143 22.7129Z" />
        <path
          d="M38.038 22.755C37.2395 22.755 36.5312 22.1821 36.3869 21.3678C36.2267 20.4554 36.8357 19.5848 37.7481 19.4235L46.8945 17.8108C47.8159 17.6506 48.6776 18.2585 48.84 19.172C49.0001 20.0844 48.3911 20.955 47.4787 21.1163L38.3323 22.7291C38.2331 22.746 38.1361 22.755 38.038 22.755Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10228_20416">
          <rect width="64" height="64" fill={bgcolor} />
        </clipPath>
      </defs>
    </svg>
  ),

  ratingNotGood: ({ classname = '', bgcolor = 'white', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      className={cn('tw:text-primary', classname)}
      {...props}
    >
      <g clipPath="url(#clip0_10228_20427)">
        <circle cx="32" cy="32" r="31.5" fill={bgcolor} stroke="currentColor" />
        <path
          d="M19.9541 44.918C26.5957 38.2741 37.4063 38.2764 44.0479 44.918C44.9214 45.7919 44.9215 47.2081 44.0479 48.082C43.6103 48.5185 43.0378 48.7373 42.4648 48.7373C41.892 48.7372 41.3203 48.5184 40.8828 48.082C35.9837 43.1841 28.0149 43.1853 23.1191 48.082C22.2451 48.9561 20.8281 48.9561 19.9541 48.082C19.0804 47.2081 19.0805 45.792 19.9541 44.918Z"
          fill="currentColor"
        />
        <path d="M19.9541 44.918C26.5957 38.2741 37.4063 38.2764 44.0479 44.918C44.9214 45.7919 44.9215 47.2081 44.0479 48.082C43.6103 48.5185 43.0378 48.7373 42.4648 48.7373C41.892 48.7372 41.3203 48.5184 40.8828 48.082C35.9837 43.1841 28.0149 43.1853 23.1191 48.082C22.2451 48.9561 20.8281 48.9561 19.9541 48.082C19.0804 47.2081 19.0805 45.792 19.9541 44.918Z" />
        <path
          d="M21.3867 21.0879C23.9508 21.0881 26.0293 23.1673 26.0293 25.7314C26.0291 28.2954 23.9507 30.3738 21.3867 30.374C18.8225 30.374 16.7434 28.2956 16.7432 25.7314C16.7432 23.1671 18.8224 21.0879 21.3867 21.0879Z"
          fill="currentColor"
        />
        <path d="M21.3867 21.0879C23.9508 21.0881 26.0293 23.1673 26.0293 25.7314C26.0291 28.2954 23.9507 30.3738 21.3867 30.374C18.8225 30.374 16.7434 28.2956 16.7432 25.7314C16.7432 23.1671 18.8224 21.0879 21.3867 21.0879Z" />
        <path
          d="M42.6143 21.0879C45.1784 21.0881 47.2568 23.1673 47.2568 25.7314C47.2566 28.2954 45.1782 30.3738 42.6143 30.374C40.0501 30.374 37.9709 28.2956 37.9707 25.7314C37.9707 23.1671 40.0499 21.0879 42.6143 21.0879Z"
          fill="currentColor"
        />
        <path d="M42.6143 21.0879C45.1784 21.0881 47.2568 23.1673 47.2568 25.7314C47.2566 28.2954 45.1782 30.3738 42.6143 30.374C40.0501 30.374 37.9709 28.2956 37.9707 25.7314C37.9707 23.1671 40.0499 21.0879 42.6143 21.0879Z" />
      </g>
      <defs>
        <clipPath id="clip0_10228_20427">
          <rect width="64" height="64" fill={bgcolor} />
        </clipPath>
      </defs>
    </svg>
  ),

  ratingFair: ({ classname = '', bgcolor = 'white', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      className={cn('tw:text-primary', classname)}
      {...props}
    >
      <g clipPath="url(#clip0_10228_20436)">
        <circle cx="32" cy="32" r="31.5" fill={bgcolor} stroke="currentColor" />
        <path
          d="M42.4736 42.0957C43.7096 42.0957 44.7108 43.0971 44.7109 44.333C44.7109 45.5691 43.7097 46.5703 42.4736 46.5703H21.5225C20.2865 46.5702 19.2852 45.569 19.2852 44.333C19.2853 43.0971 20.2866 42.0958 21.5225 42.0957H42.4736Z"
          fill="currentColor"
        />
        <path d="M42.4736 42.0957C43.7096 42.0957 44.7108 43.0971 44.7109 44.333C44.7109 45.5691 43.7097 46.5703 42.4736 46.5703H21.5225C20.2865 46.5702 19.2852 45.569 19.2852 44.333C19.2853 43.0971 20.2866 42.0958 21.5225 42.0957H42.4736Z" />
        <path
          d="M21.3857 21.0879C23.9499 21.0881 26.0283 23.1673 26.0283 25.7314C26.0281 28.2954 23.9497 30.3738 21.3857 30.374C18.8216 30.374 16.7424 28.2956 16.7422 25.7314C16.7422 23.1671 18.8214 21.0879 21.3857 21.0879Z"
          fill="currentColor"
        />
        <path d="M21.3857 21.0879C23.9499 21.0881 26.0283 23.1673 26.0283 25.7314C26.0281 28.2954 23.9497 30.3738 21.3857 30.374C18.8216 30.374 16.7424 28.2956 16.7422 25.7314C16.7422 23.1671 18.8214 21.0879 21.3857 21.0879Z" />
        <path
          d="M42.6123 21.0879C45.1764 21.0881 47.2549 23.1673 47.2549 25.7314C47.2546 28.2954 45.1763 30.3738 42.6123 30.374C40.0481 30.374 37.969 28.2956 37.9688 25.7314C37.9688 23.1671 40.048 21.0879 42.6123 21.0879Z"
          fill="currentColor"
        />
        <path d="M42.6123 21.0879C45.1764 21.0881 47.2549 23.1673 47.2549 25.7314C47.2546 28.2954 45.1763 30.3738 42.6123 30.374C40.0481 30.374 37.969 28.2956 37.9688 25.7314C37.9688 23.1671 40.048 21.0879 42.6123 21.0879Z" />
      </g>
      <defs>
        <clipPath id="clip0_10228_20436">
          <rect width="64" height="64" fill={bgcolor} />
        </clipPath>
      </defs>
    </svg>
  ),

  ratingGood: ({ classname = '', bgcolor = 'white', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      className={cn('tw:text-primary', classname)}
      {...props}
    >
      <g clipPath="url(#clip0_10228_20445)">
        <circle cx="32" cy="32" r="31.5" fill={bgcolor} stroke="currentColor" />
        <path
          d="M40.8818 40.583C41.7559 39.709 43.1728 39.7091 44.0469 40.583C44.9209 41.457 44.9209 42.874 44.0469 43.748C40.7267 47.0692 36.3633 48.7294 32 48.7295C27.6376 48.7295 23.2734 47.0694 19.9531 43.748C19.0791 42.874 19.0791 41.457 19.9531 40.583C20.8272 39.709 22.2441 39.709 23.1182 40.583C28.0151 45.4799 35.9837 45.4809 40.8818 40.583Z"
          fill="currentColor"
        />
        <path d="M40.8818 40.583C41.7559 39.709 43.1728 39.7091 44.0469 40.583C44.9209 41.457 44.9209 42.874 44.0469 43.748C40.7267 47.0692 36.3633 48.7294 32 48.7295C27.6376 48.7295 23.2734 47.0694 19.9531 43.748C19.0791 42.874 19.0791 41.457 19.9531 40.583C20.8272 39.709 22.2441 39.709 23.1182 40.583C28.0151 45.4799 35.9837 45.4809 40.8818 40.583Z" />
        <path
          d="M21.3857 21.0879C23.9499 21.0881 26.0283 23.1672 26.0283 25.7314C26.0281 28.2955 23.9498 30.3738 21.3857 30.374C18.8215 30.374 16.7424 28.2956 16.7422 25.7314C16.7422 23.1671 18.8214 21.0879 21.3857 21.0879Z"
          fill="currentColor"
        />
        <path d="M21.3857 21.0879C23.9499 21.0881 26.0283 23.1672 26.0283 25.7314C26.0281 28.2955 23.9498 30.3738 21.3857 30.374C18.8215 30.374 16.7424 28.2956 16.7422 25.7314C16.7422 23.1671 18.8214 21.0879 21.3857 21.0879Z" />
        <path
          d="M42.6143 21.0879C45.1785 21.0881 47.2568 23.1672 47.2568 25.7314C47.2566 28.2955 45.1783 30.3738 42.6143 30.374C40.05 30.374 37.9709 28.2956 37.9707 25.7314C37.9707 23.1671 40.0499 21.0879 42.6143 21.0879Z"
          fill="currentColor"
        />
        <path d="M42.6143 21.0879C45.1785 21.0881 47.2568 23.1672 47.2568 25.7314C47.2566 28.2955 45.1783 30.3738 42.6143 30.374C40.05 30.374 37.9709 28.2956 37.9707 25.7314C37.9707 23.1671 40.0499 21.0879 42.6143 21.0879Z" />
      </g>
      <defs>
        <clipPath id="clip0_10228_20445">
          <rect width="64" height="64" fill={bgcolor} />
        </clipPath>
      </defs>
    </svg>
  ),

  ratingExcellent: ({ classname = '', bgcolor = 'white', ...props }) => (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('tw:text-primary', classname)}
      {...props}
    >
      <g clipPath="url(#clip0_10228_20454)">
        <circle cx="32" cy="32" r="31.5" fill={bgcolor} stroke="currentColor" />
        <path
          d="M44.0283 38.1738C44.3305 38.0284 44.6879 38.2519 44.6768 38.5879C44.308 46.5546 38.1535 50.5381 31.999 50.5381C25.8446 50.538 19.6901 46.5545 19.3213 38.5879C19.3101 38.252 19.6676 38.0287 19.9697 38.1738C23.7749 39.9873 27.8916 40.8935 31.999 40.8936C36.1065 40.8936 40.2242 39.9862 44.0283 38.1738Z"
          fill="currentColor"
        />
        <path d="M44.0283 38.1738C44.3305 38.0284 44.6879 38.2519 44.6768 38.5879C44.308 46.5546 38.1535 50.5381 31.999 50.5381C25.8446 50.538 19.6901 46.5545 19.3213 38.5879C19.3101 38.252 19.6676 38.0287 19.9697 38.1738C23.7749 39.9873 27.8916 40.8935 31.999 40.8936C36.1065 40.8936 40.2242 39.9862 44.0283 38.1738Z" />
        <path
          d="M42.6133 21.7324C46.0994 21.7324 48.9346 24.5677 48.9346 28.0537C48.9346 28.9807 48.1827 29.7313 47.2568 29.7314C46.3298 29.7314 45.5781 28.9808 45.5781 28.0537C45.5781 26.4195 44.2486 25.0889 42.6133 25.0889C40.978 25.0889 39.6484 26.4184 39.6484 28.0537C39.6484 28.9808 38.8957 29.7314 37.9697 29.7314C37.044 29.7312 36.292 28.9806 36.292 28.0537C36.292 24.5677 39.1273 21.7325 42.6133 21.7324Z"
          fill="currentColor"
        />
        <path d="M42.6133 21.7324C46.0994 21.7324 48.9346 24.5677 48.9346 28.0537C48.9346 28.9807 48.1827 29.7313 47.2568 29.7314C46.3298 29.7314 45.5781 28.9808 45.5781 28.0537C45.5781 26.4195 44.2486 25.0889 42.6133 25.0889C40.978 25.0889 39.6484 26.4184 39.6484 28.0537C39.6484 28.9808 38.8957 29.7314 37.9697 29.7314C37.044 29.7312 36.292 28.9806 36.292 28.0537C36.292 24.5677 39.1273 21.7325 42.6133 21.7324Z" />
        <path
          d="M21.3857 21.7324C24.8718 21.7324 27.707 24.5677 27.707 28.0537C27.707 28.9807 26.9551 29.7313 26.0293 29.7314C25.1022 29.7314 24.3506 28.9808 24.3506 28.0537C24.3506 26.4195 23.0211 25.0889 21.3857 25.0889C19.7505 25.0889 18.4209 26.4184 18.4209 28.0537C18.4209 28.9808 17.6681 29.7314 16.7422 29.7314C15.8165 29.7312 15.0645 28.9806 15.0645 28.0537C15.0645 24.5677 17.8997 21.7325 21.3857 21.7324Z"
          fill="currentColor"
        />
        <path d="M21.3857 21.7324C24.8718 21.7324 27.707 24.5677 27.707 28.0537C27.707 28.9807 26.9551 29.7313 26.0293 29.7314C25.1022 29.7314 24.3506 28.9808 24.3506 28.0537C24.3506 26.4195 23.0211 25.0889 21.3857 25.0889C19.7505 25.0889 18.4209 26.4184 18.4209 28.0537C18.4209 28.9808 17.6681 29.7314 16.7422 29.7314C15.8165 29.7312 15.0645 28.9806 15.0645 28.0537C15.0645 24.5677 17.8997 21.7325 21.3857 21.7324Z" />
      </g>
      <defs>
        <clipPath id="clip0_10228_20454">
          <rect width="64" height="64" fill={bgcolor} />
        </clipPath>
      </defs>
    </svg>
  ),

  ratingStar: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
      className={cn('tw:text-primary', classname)}
      {...props}
    >
      <path d="M18.0979 5.8541C18.6966 4.01148 21.3034 4.01148 21.9021 5.8541L24.0413 12.4377C24.309 13.2617 25.0769 13.8197 25.9434 13.8197H32.8658C34.8032 13.8197 35.6088 16.2989 34.0413 17.4377L28.441 21.5066C27.74 22.0159 27.4467 22.9186 27.7145 23.7426L29.8536 30.3262C30.4523 32.1689 28.3433 33.7011 26.7759 32.5623L21.1756 28.4934C20.4746 27.9841 19.5254 27.9841 18.8244 28.4934L13.2241 32.5623C11.6567 33.7011 9.5477 32.1689 10.1464 30.3262L12.2855 23.7426C12.5533 22.9186 12.26 22.0159 11.559 21.5066L5.95867 17.4377C4.39124 16.2989 5.19679 13.8197 7.13424 13.8197H14.0566C14.9231 13.8197 15.691 13.2617 15.9587 12.4377L18.0979 5.8541Z" />
    </svg>
  ),

  phone: ({ classname = '', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_10677_103494)">
        <path
          d="M14.6669 11.2797V13.2797C14.6677 13.4654 14.6297 13.6492 14.5553 13.8193C14.4809 13.9894 14.3718 14.1421 14.235 14.2676C14.0982 14.3932 13.9367 14.4887 13.7608 14.5482C13.5849 14.6077 13.3985 14.6298 13.2136 14.6131C11.1622 14.3902 9.19161 13.6892 7.46028 12.5664C5.8495 11.5428 4.48384 10.1772 3.46028 8.56641C2.3336 6.82721 1.63244 4.84707 1.41361 2.78641C1.39695 2.60205 1.41886 2.41625 1.47795 2.24082C1.53703 2.0654 1.63199 1.9042 1.75679 1.76749C1.88159 1.63077 2.03348 1.52155 2.20281 1.44675C2.37213 1.37196 2.55517 1.33325 2.74028 1.33307H4.74028C5.06382 1.32989 5.37748 1.44446 5.62279 1.65543C5.8681 1.8664 6.02833 2.15937 6.07361 2.47974C6.15803 3.11978 6.31458 3.74822 6.54028 4.35307C6.62998 4.59169 6.64939 4.85102 6.59622 5.10033C6.54305 5.34964 6.41952 5.57848 6.24028 5.75974L5.39361 6.60641C6.34265 8.27544 7.72458 9.65737 9.39361 10.6064L10.2403 9.75974C10.4215 9.5805 10.6504 9.45697 10.8997 9.4038C11.149 9.35063 11.4083 9.37004 11.6469 9.45974C12.2518 9.68544 12.8802 9.84199 13.5203 9.92641C13.8441 9.97209 14.1399 10.1352 14.3513 10.3847C14.5627 10.6343 14.6751 10.9528 14.6669 11.2797Z"
          stroke="black"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10677_103494">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  graphicDelivery: ({ classname = '', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_11379_169605)">
        <path
          d="M34.8672 0.326172V19.7547H46.805L63.8827 41.6323V63.8364H0.214355V0.326172H34.8672Z"
          fill="white"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M44.9812 25.4697H34.8672V43.2656H58.9086L44.9812 25.4697Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M45.3135 49.7295C52.6935 49.7298 58.6562 55.6183 58.6562 62.8574C58.656 70.0964 52.6934 75.9841 45.3135 75.9844C37.9334 75.9844 31.9699 70.0965 31.9697 62.8574C31.9697 55.6181 37.9332 49.7295 45.3135 49.7295Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M45.3125 54.9541C49.7625 54.9541 53.3506 58.5035 53.3506 62.8574C53.3504 67.2112 49.7624 70.7598 45.3125 70.7598C40.8628 70.7595 37.2755 67.211 37.2754 62.8574C37.2754 58.5037 40.8627 54.9543 45.3125 54.9541Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          vectorEffect="non-scaling-stroke"
        />
        <mask id="path-6-inside-1_11379_169605" fill="white">
          <path
            d="M-0.0742188 56C-0.0742188 60.4183 3.5075 64 7.92578 64H56.0793C60.4976 64 64.0793 60.4183 64.0793 56V8.13425C64.0793 3.71597 60.4976 0.134247 56.0793 0.134247H7.92577C3.5075 0.134247 -0.0742188 3.71597 -0.0742188 8.13425V56Z"
            vectorEffect="non-scaling-stroke"
          />
        </mask>
        <path
          d="M7.92578 64V62.5H56.0793V64V65.5H7.92578V64ZM64.0793 56H62.5793V8.13425H64.0793H65.5793V56H64.0793ZM56.0793 0.134247V1.63425H7.92577V0.134247V-1.36575H56.0793V0.134247ZM-0.0742188 8.13425H1.42578V56H-0.0742188H-1.57422V8.13425H-0.0742188ZM7.92577 0.134247V1.63425C4.33592 1.63425 1.42578 4.5444 1.42578 8.13425H-0.0742188H-1.57422C-1.57422 2.88754 2.67907 -1.36575 7.92577 -1.36575V0.134247ZM64.0793 8.13425H62.5793C62.5793 4.5444 59.6691 1.63425 56.0793 1.63425V0.134247V-1.36575C61.326 -1.36575 65.5793 2.88755 65.5793 8.13425H64.0793ZM56.0793 64V62.5C59.6691 62.5 62.5793 59.5899 62.5793 56H64.0793H65.5793C65.5793 61.2467 61.326 65.5 56.0793 65.5V64ZM7.92578 64V65.5C2.67908 65.5 -1.57422 61.2467 -1.57422 56H-0.0742188H1.42578C1.42578 59.5898 4.33593 62.5 7.92578 62.5V64Z"
          fill="black"
          mask="url(#path-6-inside-1_11379_169605)"
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <defs>
        <clipPath id="clip0_11379_169605">
          <path
            d="M-0.000488281 56C-0.000488281 60.4183 3.58123 64 7.99951 64H55.9995C60.4178 64 63.9995 60.4183 63.9995 56V8C63.9995 3.58172 60.4178 0 55.9995 0H7.99951C3.58123 0 -0.000488281 3.58172 -0.000488281 8V56Z"
            fill="white"
            vectorEffect="non-scaling-stroke"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  groceries: ({ classname = '', ...props }) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M6 5.875H9.5M6 5.875H2.25M6 5.875C6 5.875 6 4 4.25 4C2.25 4 2.25 5.875 2.25 5.875M6 5.875C6 5.875 6 5.5 6 4.5625C6 3.625 6.75 1.75 6.75 1.75M9.5 5.875V5.875C10.0972 5.875 10.5042 6.47981 10.2794 7.03302L9.02273 10.125H2.97727L1.62651 6.80141C1.44664 6.35884 1.77228 5.875 2.25 5.875V5.875M9.5 5.875C9.5 5.875 9.5 5.5 9.5 4.5625C9.5 3.625 8.75 1.75 8.75 1.75M8.75 1.75H6.75M8.75 1.75H9.5M6.75 1.75H6"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  ),

  fresh: ({ classname = '', ...props }) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M10.126 2.82502C10.5367 2.70546 11.0585 2.71459 11.4678 3.13459C11.8409 3.51764 11.8757 3.99175 11.7832 4.38264C11.6962 4.75025 11.4912 5.09233 11.2979 5.35822C11.1732 5.52956 11.0374 5.68546 10.9141 5.82112C11.0226 5.918 11.139 6.02799 11.251 6.14729C11.455 6.36476 11.6789 6.64635 11.8125 6.96174C11.9493 7.28506 12.0199 7.7244 11.7656 8.14436C11.4454 8.67323 10.8899 8.74309 10.4785 8.69026C10.0733 8.63806 9.65143 8.45915 9.30371 8.27912C8.94518 8.09348 8.61195 7.87877 8.37207 7.71369C8.34395 7.69434 8.31767 7.67418 8.29199 7.65608C7.3216 8.17897 6.07449 8.70954 4.9375 8.70979C3.98023 8.70979 2.90721 8.50133 2.04688 8.07697C1.20486 7.66156 0.411459 6.95095 0.376953 5.89045C0.342325 4.81718 1.13145 4.04876 1.97363 3.58967C2.83974 3.11767 3.94274 2.86018 4.9375 2.86018C6.126 2.86045 7.41331 3.46171 8.39062 4.03791C8.57279 3.85118 8.81142 3.62094 9.07812 3.41096C9.36921 3.18179 9.73676 2.93839 10.126 2.82502ZM4.9375 4.0594C4.12439 4.0594 3.22181 4.27612 2.54785 4.64338C1.85027 5.02368 1.56364 5.46117 1.57617 5.85139C1.58927 6.25428 1.89315 6.6629 2.57813 7.0008C3.24495 7.32967 4.12989 7.50959 4.9375 7.50959C5.84655 7.5093 6.98848 7.02112 7.96777 6.4676C8.34983 6.25163 8.68948 6.03216 8.96094 5.85041C8.68944 5.65292 8.34736 5.41364 7.96094 5.17756C6.98473 4.58122 5.84882 4.05971 4.9375 4.0594ZM9.83008 6.71467C9.71569 6.79362 9.58217 6.87971 9.43652 6.97444C9.56913 7.05591 9.71117 7.13799 9.85547 7.21272C10.1645 7.37269 10.4369 7.47472 10.6318 7.49983C10.6769 7.50559 10.7095 7.50495 10.7314 7.50373C10.7278 7.48675 10.7208 7.46206 10.707 7.42951C10.6537 7.30357 10.539 7.14337 10.375 6.96858C10.2469 6.83204 10.1061 6.70695 9.9834 6.60432C9.93585 6.63792 9.88565 6.67631 9.83008 6.71467ZM3.76172 5.05158C4.11611 5.05178 4.40325 5.33876 4.40332 5.69319C4.40332 6.04767 4.11616 6.33557 3.76172 6.33576C3.40712 6.33576 3.11914 6.04779 3.11914 5.69319C3.11921 5.33864 3.40716 5.05158 3.76172 5.05158ZM10.4619 3.97737C10.2934 4.02645 10.0695 4.1572 9.82031 4.35334C9.67868 4.46485 9.54372 4.58742 9.42188 4.70393C9.58321 4.81687 9.72928 4.92047 9.85352 5.0135C9.88904 5.0401 9.92192 5.06707 9.9541 5.09162C10.0748 4.9641 10.2106 4.81374 10.3281 4.65217C10.4851 4.4363 10.583 4.24639 10.6162 4.10627C10.6435 3.99061 10.6158 3.9788 10.6084 3.97151C10.5956 3.95846 10.5926 3.95992 10.5908 3.95979C10.5795 3.95786 10.5399 3.95472 10.4619 3.97737Z"
        fill="black"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  ),

  freshDelivery: ({ classname = 'tw:w-4 tw:h-4', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
        fill="#1F1E19"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M5.7073 12V4.72727H10.5226V5.99503H7.24494V7.72798H10.203V8.99574H7.24494V12H5.7073Z"
        fill="white"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  ),

  groceriesDelivery: ({ classname = 'tw:w-4 tw:h-4', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
        fill="#1F1E19"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M9.65083 7.07812C9.60112 6.9053 9.53128 6.7526 9.44132 6.62003C9.35136 6.48509 9.24127 6.37145 9.11106 6.27912C8.98322 6.18442 8.83644 6.11222 8.67072 6.0625C8.50737 6.01278 8.32626 5.98793 8.1274 5.98793C7.75571 5.98793 7.42901 6.08026 7.14728 6.26491C6.86793 6.44957 6.65012 6.71828 6.49387 7.07102C6.33762 7.4214 6.2595 7.84991 6.2595 8.35653C6.2595 8.86316 6.33644 9.29403 6.49032 9.64915C6.64421 10.0043 6.86201 10.2753 7.14373 10.4624C7.42546 10.647 7.75808 10.7393 8.1416 10.7393C8.48961 10.7393 8.78672 10.6778 9.03294 10.5547C9.28152 10.4292 9.47091 10.2528 9.60112 10.0256C9.73369 9.7983 9.79998 9.52959 9.79998 9.21946L10.1125 9.26562H8.23748V8.10795H11.2808V9.02415C11.2808 9.66335 11.1459 10.2126 10.876 10.6719C10.6061 11.1288 10.2344 11.4815 9.76092 11.7301C9.28743 11.9763 8.74529 12.0994 8.1345 12.0994C7.45268 12.0994 6.85372 11.9491 6.33762 11.6484C5.82153 11.3454 5.41906 10.9157 5.13024 10.3594C4.84378 9.80066 4.70055 9.13778 4.70055 8.37074C4.70055 7.78125 4.78578 7.25568 4.95623 6.79403C5.12905 6.33002 5.37053 5.93703 5.68066 5.61506C5.9908 5.29309 6.35183 5.04806 6.76376 4.87997C7.17569 4.71188 7.62195 4.62784 8.10254 4.62784C8.51447 4.62784 8.89799 4.68821 9.25311 4.80895C9.60822 4.92732 9.92309 5.09541 10.1977 5.31321C10.4747 5.53101 10.7008 5.79025 10.876 6.09091C11.0512 6.3892 11.1636 6.71828 11.2133 7.07812H9.65083Z"
        fill="white"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  ),

  gfxPizza: ({ classname, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="194"
      height="196"
      viewBox="0 0 194 196"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_2212_19075)">
        <mask id="path-2-inside-1_2212_19075" fill="white">
          <path d="M0.462891 6C0.462891 2.68629 3.14918 0 6.46289 0H187.926C191.239 0 193.926 2.68629 193.926 6V189.589C193.926 192.903 191.239 195.589 187.926 195.589H6.4629C3.14919 195.589 0.462891 192.903 0.462891 189.589V6Z" />
        </mask>
        <path
          d="M6.46289 1.5H187.926V-1.5H6.46289V1.5ZM192.426 6V189.589H195.426V6H192.426ZM187.926 194.089H6.4629V197.089H187.926V194.089ZM1.96289 189.589V6H-1.03711V189.589H1.96289ZM6.4629 194.089C3.97761 194.089 1.96289 192.074 1.96289 189.589H-1.03711C-1.03711 193.731 2.32076 197.089 6.4629 197.089V194.089ZM192.426 189.589C192.426 192.074 190.411 194.089 187.926 194.089V197.089C192.068 197.089 195.426 193.731 195.426 189.589H192.426ZM187.926 1.5C190.411 1.5 192.426 3.51472 192.426 6H195.426C195.426 1.85786 192.068 -1.5 187.926 -1.5V1.5ZM6.46289 -1.5C2.32075 -1.5 -1.03711 1.85787 -1.03711 6H1.96289C1.96289 3.51472 3.97761 1.5 6.46289 1.5V-1.5Z"
          fill="black"
          mask="url(#path-2-inside-1_2212_19075)"
        />
        <circle
          cx="8.96289"
          cy="11.5"
          r="152.75"
          stroke={getBrandColor()}
          strokeWidth="1.5"
        />
        <circle
          cx="76.4629"
          cy="83"
          r="8.25"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <circle
          cx="109.463"
          cy="57"
          r="8.25"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M38.9629 93.75C43.8341 93.75 47.7129 97.4813 47.7129 102C47.7129 106.519 43.8341 110.25 38.9629 110.25C34.0917 110.25 30.2129 106.519 30.2129 102C30.2129 97.4813 34.0917 93.75 38.9629 93.75Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <circle
          cx="38.4629"
          cy="56"
          r="8.25"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M191.963 10.5C191.963 111.568 110.031 193.5 8.96289 193.5C-92.1052 193.5 -174.037 111.568 -174.037 10.5C-174.037 -90.5681 -92.1052 -172.5 8.96289 -172.5C110.031 -172.5 191.963 -90.5681 191.963 10.5ZM193.463 10.5C193.463 112.397 110.859 195 8.96289 195C-92.9336 195 -175.537 112.397 -175.537 10.5C-175.537 -91.3965 -92.9336 -174 8.96289 -174C110.859 -174 193.463 -91.3965 193.463 10.5ZM77.4629 41C82.4334 41 86.4629 36.9706 86.4629 32C86.4629 27.0294 82.4334 23 77.4629 23C72.4923 23 68.4629 27.0294 68.4629 32C68.4629 36.9706 72.4923 41 77.4629 41Z"
          fill={getBrandColor()}
        />
        <mask id="path-10-inside-2_2212_19075" fill="white">
          <path d="M0.462891 8C0.462891 3.58172 4.04461 0 8.46289 0H185.926C190.344 0 193.926 3.58172 193.926 8V187.589C193.926 192.007 190.344 195.589 185.926 195.589H8.46289C4.04462 195.589 0.462891 192.007 0.462891 187.589V8Z" />
        </mask>
        <path
          d="M8.46289 1.5H185.926V-1.5H8.46289V1.5ZM192.426 8V187.589H195.426V8H192.426ZM185.926 194.089H8.46289V197.089H185.926V194.089ZM1.96289 187.589V8H-1.03711V187.589H1.96289ZM8.46289 194.089C4.87304 194.089 1.96289 191.179 1.96289 187.589H-1.03711C-1.03711 192.836 3.21619 197.089 8.46289 197.089V194.089ZM192.426 187.589C192.426 191.179 189.516 194.089 185.926 194.089V197.089C191.172 197.089 195.426 192.836 195.426 187.589H192.426ZM185.926 1.5C189.516 1.5 192.426 4.41015 192.426 8H195.426C195.426 2.75329 191.172 -1.5 185.926 -1.5V1.5ZM8.46289 -1.5C3.21619 -1.5 -1.03711 2.7533 -1.03711 8H1.96289C1.96289 4.41015 4.87304 1.5 8.46289 1.5V-1.5Z"
          fill="black"
          mask="url(#path-10-inside-2_2212_19075)"
        />
      </g>
      <defs>
        <clipPath id="clip0_2212_19075">
          <path
            d="M0.462891 8C0.462891 3.58172 4.04461 0 8.46289 0H185.926C190.344 0 193.926 3.58172 193.926 8V188C193.926 192.418 190.344 196 185.926 196H8.46289C4.04462 196 0.462891 192.418 0.462891 188V8Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  gfxMeat: ({ classname, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="195"
      height="196"
      viewBox="0 0 195 196"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_3827_41503)">
        <mask id="path-3-inside-1_3827_41503" fill="white">
          <path d="M0.77832 8.41001C0.77832 3.99173 4.36004 0.410004 8.77832 0.410004H186.242C190.661 0.410004 194.242 3.99173 194.242 8.41V188C194.242 192.418 190.661 196 186.242 196H8.77832C4.36005 196 0.77832 192.418 0.77832 188V8.41001Z" />
        </mask>
        <path
          d="M8.77832 1.91H186.242V-1.09H8.77832V1.91ZM192.742 8.41V188H195.742V8.41H192.742ZM186.242 194.5H8.77832V197.5H186.242V194.5ZM2.27832 188V8.41001H-0.72168V188H2.27832ZM8.77832 194.5C5.18847 194.5 2.27832 191.59 2.27832 188H-0.72168C-0.72168 193.247 3.53162 197.5 8.77832 197.5V194.5ZM192.742 188C192.742 191.59 189.832 194.5 186.242 194.5V197.5C191.489 197.5 195.742 193.247 195.742 188H192.742ZM186.242 1.91C189.832 1.91 192.742 4.82015 192.742 8.41H195.742C195.742 3.1633 191.489 -1.09 186.242 -1.09V1.91ZM8.77832 -1.09C3.53162 -1.09 -0.72168 3.1633 -0.72168 8.41001H2.27832C2.27832 4.82015 5.18847 1.91 8.77832 1.91V-1.09Z"
          fill="black"
          mask="url(#path-3-inside-1_3827_41503)"
        />
        <path
          d="M177.761 5.83833L157.36 -17.3446C153.018 -22.2791 146.139 -24.1264 139.909 -22.0312C135.077 -20.4062 131.282 -16.6167 129.651 -11.7873L127.831 -6.40122C126.303 -1.87686 123.634 2.17717 120.083 5.36964L114.025 10.8144C110.855 13.6644 107.384 16.1614 103.673 18.2615L96.7568 22.1766C87.4254 27.4585 77.4842 31.5817 67.1537 34.4548L51.7278 38.745C41.0534 41.7137 31.2615 47.2349 23.197 54.8322C11.9264 65.4497 4.59833 79.5821 2.41471 94.9116L1.95386 98.1469C-0.965331 118.64 4.42153 139.451 16.9174 155.954L21.2192 161.635C29.1343 172.088 39.3532 180.576 51.0819 186.437C68.4547 195.12 88.2708 197.612 107.252 193.502L109.63 192.987C130.747 188.414 149.586 176.57 162.86 159.523L168.56 152.201C184.663 131.521 193.406 106.059 193.406 79.8488L193.406 47.3002C193.406 32.0369 187.844 17.2967 177.761 5.83833Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M174.9 95.236L177.74 83.3767C180.856 70.3658 180.411 56.7561 176.453 43.9762L174.506 37.6902C173.088 33.1096 171.061 28.74 168.481 24.6983C161.993 14.5368 149.52 9.95524 137.998 13.5007L136.878 13.8453C133.327 14.9378 130.026 16.7174 127.162 19.0828L121.104 24.0858C115.712 28.5388 109.817 32.345 103.54 35.4265L97.9739 38.1588C91.5164 41.3288 84.7677 43.8672 77.8218 45.7386L62.1554 49.9597C53.5468 52.2791 45.5407 56.4305 38.6847 62.1299C29.3407 69.8976 22.9876 80.6719 20.7131 92.6081L20.0566 96.0536C17.002 112.084 20.3735 128.673 29.4434 142.239L34.0404 149.114C39.4617 157.223 46.6299 164.015 55.0189 168.992C69.3118 177.472 86.2988 180.186 102.522 176.583L105.027 176.026C120.123 172.673 133.734 164.536 143.835 152.826L147.687 148.36C160.868 133.078 170.199 114.862 174.9 95.236Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <circle
          cx="73.5"
          cy="149.5"
          r="10.75"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <path
        d="M8.77832 1.07993H186.242C190.291 1.07993 193.572 4.36166 193.572 8.41V188C193.572 192.048 190.291 195.33 186.242 195.33H8.77832C4.72998 195.33 1.44824 192.048 1.44824 188V8.41C1.44824 4.36166 4.72998 1.07993 8.77832 1.07993Z"
        stroke="black"
        strokeWidth="1.33966"
      />
      <defs>
        <clipPath id="clip0_3827_41503">
          <path
            d="M0.77832 8.41001C0.77832 3.99173 4.36004 0.410004 8.77832 0.410004H186.242C190.661 0.410004 194.242 3.99173 194.242 8.41V188C194.242 192.418 190.661 196 186.242 196H8.77832C4.36005 196 0.77832 192.418 0.77832 188V8.41001Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  gfxFWD: ({ classname, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="195"
      height="196"
      viewBox="0 0 195 196"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_2317_16421)">
        <mask id="path-1-inside-1_2317_16421" fill="white">
          <path d="M0.705078 8.41114C0.705078 3.99286 4.2868 0.411133 8.70508 0.411133H186.168C190.586 0.411133 194.168 3.99285 194.168 8.41113V188C194.168 192.418 190.586 196 186.168 196H8.70508C4.2868 196 0.705078 192.418 0.705078 188V8.41114Z" />
        </mask>
        <path
          d="M0.926758 2L97.9268 97.7039L0.926758 194V2Z"
          stroke={getBrandColor()}
          strokeWidth="1.5"
        />
        <path
          d="M96.9268 2L193.927 97.7039L96.9268 194V2Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <path
        d="M8.70508 1.91113H186.168V-1.08887H8.70508V1.91113ZM192.668 8.41113V188H195.668V8.41113H192.668ZM186.168 194.5H8.70508V197.5H186.168V194.5ZM2.20508 188V8.41114H-0.794922V188H2.20508ZM8.70508 194.5C5.11523 194.5 2.20508 191.59 2.20508 188H-0.794922C-0.794922 193.247 3.45838 197.5 8.70508 197.5V194.5ZM192.668 188C192.668 191.59 189.758 194.5 186.168 194.5V197.5C191.415 197.5 195.668 193.247 195.668 188H192.668ZM186.168 1.91113C189.758 1.91113 192.668 4.82128 192.668 8.41113H195.668C195.668 3.16443 191.415 -1.08887 186.168 -1.08887V1.91113ZM8.70508 -1.08887C3.45837 -1.08887 -0.794922 3.16443 -0.794922 8.41114H2.20508C2.20508 4.82128 5.11523 1.91113 8.70508 1.91113V-1.08887Z"
        fill="black"
        mask="url(#path-1-inside-1_2317_16421)"
      />
      <defs>
        <clipPath id="clip0_2317_16421">
          <path
            d="M0.705078 8.41114C0.705078 3.99286 4.2868 0.411133 8.70508 0.411133H186.168C190.586 0.411133 194.168 3.99285 194.168 8.41113V188C194.168 192.418 190.586 196 186.168 196H8.70508C4.2868 196 0.705078 192.418 0.705078 188V8.41114Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  gfxAbstract2: ({ classname, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="194"
      height="196"
      viewBox="0 0 194 196"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_2773_24867)">
        <circle
          cx="176.648"
          cy="176.5"
          r="176.5"
          stroke="black"
          strokeWidth="1.5"
        />
        <circle
          cx="176.648"
          cy="176.5"
          r="140.5"
          stroke="black"
          strokeWidth="1.5"
        />
        <rect
          x="164.898"
          y="81.75"
          width="38.5"
          height="174.5"
          rx="19.25"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <mask id="path-5-inside-1_2773_24867" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M157.482 82.3333H108.148V121C108.148 129.837 115.312 137 124.148 137L124.148 229C124.148 233.418 127.73 237 132.148 237C136.567 237 140.148 233.418 140.148 229V137H141.482C150.318 137 157.482 129.837 157.482 121V82.3333Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M157.482 82.3333H108.148V121C108.148 129.837 115.312 137 124.148 137L124.148 229C124.148 233.418 127.73 237 132.148 237C136.567 237 140.148 233.418 140.148 229V137H141.482C150.318 137 157.482 129.837 157.482 121V82.3333Z"
          fill={getBrandColor()}
        />
        <path
          d="M108.148 82.3333V80.8333H106.648V82.3333H108.148ZM157.482 82.3333H158.982V80.8333H157.482V82.3333ZM124.148 137H125.648V135.5H124.148V137ZM124.148 229H125.648H124.148ZM140.148 137V135.5H138.648V137H140.148ZM108.148 83.8333H157.482V80.8333H108.148V83.8333ZM109.648 121V82.3333H106.648V121H109.648ZM124.148 135.5C116.14 135.5 109.648 129.008 109.648 121H106.648C106.648 130.665 114.483 138.5 124.148 138.5V135.5ZM125.648 229L125.648 137H122.648L122.648 229H125.648ZM132.148 235.5C128.559 235.5 125.648 232.59 125.648 229H122.648C122.648 234.247 126.902 238.5 132.148 238.5V235.5ZM138.648 229C138.648 232.59 135.738 235.5 132.148 235.5V238.5C137.395 238.5 141.648 234.247 141.648 229H138.648ZM138.648 137V229H141.648V137H138.648ZM141.482 135.5H140.148V138.5H141.482V135.5ZM155.982 121C155.982 129.008 149.49 135.5 141.482 135.5V138.5C151.147 138.5 158.982 130.665 158.982 121H155.982ZM155.982 82.3333V121H158.982V82.3333H155.982Z"
          fill="black"
          mask="url(#path-5-inside-1_2773_24867)"
        />
        <mask id="path-7-inside-2_2773_24867" fill="white">
          <path d="M0 8C0 3.58172 3.58172 0 8 0H185.463C189.881 0 193.463 3.58172 193.463 8V187.589C193.463 192.007 189.881 195.589 185.463 195.589H8C3.58173 195.589 0 192.007 0 187.589V8Z" />
        </mask>
        <path
          d="M8 1.5H185.463V-1.5H8V1.5ZM191.963 8V187.589H194.963V8H191.963ZM185.463 194.089H8V197.089H185.463V194.089ZM1.5 187.589V8H-1.5V187.589H1.5ZM8 194.089C4.41015 194.089 1.5 191.179 1.5 187.589H-1.5C-1.5 192.836 2.7533 197.089 8 197.089V194.089ZM191.963 187.589C191.963 191.179 189.053 194.089 185.463 194.089V197.089C190.71 197.089 194.963 192.836 194.963 187.589H191.963ZM185.463 1.5C189.053 1.5 191.963 4.41015 191.963 8H194.963C194.963 2.75329 190.71 -1.5 185.463 -1.5V1.5ZM8 -1.5C2.75329 -1.5 -1.5 2.7533 -1.5 8H1.5C1.5 4.41015 4.41015 1.5 8 1.5V-1.5Z"
          fill="black"
          mask="url(#path-7-inside-2_2773_24867)"
        />
      </g>
      <defs>
        <clipPath id="clip0_2773_24867">
          <path
            d="M0 8C0 3.58172 3.58172 0 8 0H185.463C189.881 0 193.463 3.58172 193.463 8V188C193.463 192.418 189.881 196 185.463 196H8C3.58173 196 0 192.418 0 188V8Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  gfxOffer: ({ classname, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="194"
      height="196"
      viewBox="0 0 194 196"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_3165_43910)">
        <path
          d="M185.109 1.37992C189.113 1.38008 192.359 4.62583 192.359 8.62983L192.355 94.8306C192.355 96.731 191.608 98.5558 190.277 99.9115L98.6973 193.125C95.8736 195.999 91.2477 196.019 88.3987 193.17L3.49405 108.266C0.662851 105.434 0.663361 100.843 3.49474 98.0119L98.0123 3.49986C99.372 2.14024 101.216 1.37571 103.139 1.37577L185.109 1.37992Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <mask id="path-3-inside-1_3165_43910" fill="white">
          <path d="M0.240234 188C0.240234 192.418 3.82196 196 8.24023 196H185.703C190.121 196 193.703 192.418 193.703 188V8.41113C193.703 3.99286 190.121 0.411133 185.703 0.411133H8.24024C3.82196 0.411133 0.240234 3.99286 0.240234 8.41113V188Z" />
        </mask>
        <path
          d="M8.24023 194.5H185.703V197.5H8.24023V194.5ZM192.203 188V8.41113H195.203V188H192.203ZM185.703 1.91113H8.24024V-1.08887H185.703V1.91113ZM1.74023 8.41113V188H-1.25977V8.41113H1.74023ZM8.24024 1.91113C4.65039 1.91113 1.74023 4.82129 1.74023 8.41113H-1.25977C-1.25977 3.16443 2.99353 -1.08887 8.24024 -1.08887V1.91113ZM192.203 8.41113C192.203 4.82129 189.293 1.91113 185.703 1.91113V-1.08887C190.95 -1.08887 195.203 3.16443 195.203 8.41113H192.203ZM185.703 194.5C189.293 194.5 192.203 191.59 192.203 188H195.203C195.203 193.247 190.95 197.5 185.703 197.5V194.5ZM8.24023 197.5C2.99353 197.5 -1.25977 193.247 -1.25977 188H1.74023C1.74023 191.59 4.65038 194.5 8.24023 194.5V197.5Z"
          fill="black"
          mask="url(#path-3-inside-1_3165_43910)"
        />
        <circle
          cx="151.963"
          cy="48.5"
          r="11.75"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_3165_43910">
          <path
            d="M0.462891 188C0.462891 192.418 4.04461 196 8.46289 196H185.463C189.881 196 193.463 192.418 193.463 188V8C193.463 3.58171 189.881 0 185.463 0H8.46289C4.04462 0 0.462891 3.58173 0.462891 8V188Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  gfxScanner: ({ classname, ...props }) => (
    <svg
      width="194"
      height="196"
      viewBox="0 0 194 196"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_5550_66598)">
        <path
          d="M0.462891 8C0.462891 3.58172 4.04461 0 8.46289 0H185.926C190.344 0 193.926 3.58172 193.926 8V188C193.926 192.418 190.344 196 185.926 196H8.46289C4.04462 196 0.462891 192.418 0.462891 188V8Z"
          fill="#FAF9F5"
        />
        <mask id="path-2-inside-1_5550_66598" fill="white">
          <path d="M0.462891 8C0.462891 3.58172 4.04461 0 8.46289 0H185.926C190.344 0 193.926 3.58172 193.926 8V187.589C193.926 192.007 190.344 195.589 185.926 195.589H8.46289C4.04462 195.589 0.462891 192.007 0.462891 187.589V8Z" />
        </mask>
        <path
          d="M8.46289 1.5H185.926V-1.5H8.46289V1.5ZM192.426 8V187.589H195.426V8H192.426ZM185.926 194.089H8.46289V197.089H185.926V194.089ZM1.96289 187.589V8H-1.03711V187.589H1.96289ZM8.46289 194.089C4.87304 194.089 1.96289 191.179 1.96289 187.589H-1.03711C-1.03711 192.836 3.21619 197.089 8.46289 197.089V194.089ZM192.426 187.589C192.426 191.179 189.516 194.089 185.926 194.089V197.089C191.172 197.089 195.426 192.836 195.426 187.589H192.426ZM185.926 1.5C189.516 1.5 192.426 4.41015 192.426 8H195.426C195.426 2.75329 191.172 -1.5 185.926 -1.5V1.5ZM8.46289 -1.5C3.21619 -1.5 -1.03711 2.7533 -1.03711 8H1.96289C1.96289 4.41015 4.87304 1.5 8.46289 1.5V-1.5Z"
          fill="black"
          mask="url(#path-2-inside-1_5550_66598)"
        />
        <mask id="path-4-inside-2_5550_66598" fill="white">
          <path d="M177 44C177 39.5817 173.418 36 169 36H145C140.582 36 137 39.5817 137 44V152C137 156.418 140.582 160 145 160H169C173.418 160 177 156.418 177 152V44Z" />
        </mask>
        <path
          d="M177 44C177 39.5817 173.418 36 169 36H145C140.582 36 137 39.5817 137 44V152C137 156.418 140.582 160 145 160H169C173.418 160 177 156.418 177 152V44Z"
          fill={getBrandColor()}
        />
        <path
          d="M169 37.5H145V34.5H169V37.5ZM138.5 44V152H135.5V44H138.5ZM145 158.5H169V161.5H145V158.5ZM175.5 152V44H178.5V152H175.5ZM169 158.5C172.59 158.5 175.5 155.59 175.5 152H178.5C178.5 157.247 174.247 161.5 169 161.5V158.5ZM138.5 152C138.5 155.59 141.41 158.5 145 158.5V161.5C139.753 161.5 135.5 157.247 135.5 152H138.5ZM145 37.5C141.41 37.5 138.5 40.4101 138.5 44H135.5C135.5 38.7533 139.753 34.5 145 34.5V37.5ZM169 34.5C174.247 34.5 178.5 38.7533 178.5 44H175.5C175.5 40.4101 172.59 37.5 169 37.5V34.5Z"
          fill="black"
          mask="url(#path-4-inside-2_5550_66598)"
        />
        <mask id="path-6-inside-3_5550_66598" fill="white">
          <path d="M113 44C113 39.5817 116.582 36 121 36C125.418 36 129 39.5817 129 44V152C129 156.418 125.418 160 121 160C116.582 160 113 156.418 113 152V44Z" />
        </mask>
        <path
          d="M127.5 44V152H130.5V44H127.5ZM114.5 152V44H111.5V152H114.5ZM121 158.5C117.41 158.5 114.5 155.59 114.5 152H111.5C111.5 157.247 115.753 161.5 121 161.5V158.5ZM127.5 152C127.5 155.59 124.59 158.5 121 158.5V161.5C126.247 161.5 130.5 157.247 130.5 152H127.5ZM121 37.5C124.59 37.5 127.5 40.4101 127.5 44H130.5C130.5 38.7533 126.247 34.5 121 34.5V37.5ZM121 34.5C115.753 34.5 111.5 38.7533 111.5 44H114.5C114.5 40.4101 117.41 37.5 121 37.5V34.5Z"
          fill="black"
          mask="url(#path-6-inside-3_5550_66598)"
        />
        <mask id="path-8-inside-4_5550_66598" fill="white">
          <path d="M89 44C89 39.5817 92.5817 36 97 36C101.418 36 105 39.5817 105 44V152C105 156.418 101.418 160 97 160C92.5817 160 89 156.418 89 152V44Z" />
        </mask>
        <path
          d="M103.5 44V152H106.5V44H103.5ZM90.5 152V44H87.5V152H90.5ZM97 158.5C93.4101 158.5 90.5 155.59 90.5 152H87.5C87.5 157.247 91.7533 161.5 97 161.5V158.5ZM103.5 152C103.5 155.59 100.59 158.5 97 158.5V161.5C102.247 161.5 106.5 157.247 106.5 152H103.5ZM97 37.5C100.59 37.5 103.5 40.4101 103.5 44H106.5C106.5 38.7533 102.247 34.5 97 34.5V37.5ZM97 34.5C91.7533 34.5 87.5 38.7533 87.5 44H90.5C90.5 40.4101 93.4101 37.5 97 37.5V34.5Z"
          fill="black"
          mask="url(#path-8-inside-4_5550_66598)"
        />
        <mask id="path-10-inside-5_5550_66598" fill="white">
          <path d="M41 44C41 39.5817 44.5817 36 49 36H73C77.4183 36 81 39.5817 81 44V152C81 156.418 77.4183 160 73 160H49C44.5817 160 41 156.418 41 152V44Z" />
        </mask>
        <path
          d="M41 44C41 39.5817 44.5817 36 49 36H73C77.4183 36 81 39.5817 81 44V152C81 156.418 77.4183 160 73 160H49C44.5817 160 41 156.418 41 152V44Z"
          fill={getBrandColor()}
        />
        <path
          d="M49 37.5H73V34.5H49V37.5ZM79.5 44V152H82.5V44H79.5ZM73 158.5H49V161.5H73V158.5ZM42.5 152V44H39.5V152H42.5ZM49 158.5C45.4101 158.5 42.5 155.59 42.5 152H39.5C39.5 157.247 43.7533 161.5 49 161.5V158.5ZM79.5 152C79.5 155.59 76.5899 158.5 73 158.5V161.5C78.2467 161.5 82.5 157.247 82.5 152H79.5ZM73 37.5C76.5899 37.5 79.5 40.4101 79.5 44H82.5C82.5 38.7533 78.2467 34.5 73 34.5V37.5ZM49 34.5C43.7533 34.5 39.5 38.7533 39.5 44H42.5C42.5 40.4101 45.4101 37.5 49 37.5V34.5Z"
          fill="black"
          mask="url(#path-10-inside-5_5550_66598)"
        />
        <mask id="path-12-inside-6_5550_66598" fill="white">
          <path d="M16.4629 44C16.4629 39.5817 20.0446 36 24.4629 36C28.8812 36 32.4629 39.5817 32.4629 44V152C32.4629 156.418 28.8812 160 24.4629 160C20.0446 160 16.4629 156.418 16.4629 152V44Z" />
        </mask>
        <path
          d="M30.9629 44V152H33.9629V44H30.9629ZM17.9629 152V44H14.9629V152H17.9629ZM24.4629 158.5C20.873 158.5 17.9629 155.59 17.9629 152H14.9629C14.9629 157.247 19.2162 161.5 24.4629 161.5V158.5ZM30.9629 152C30.9629 155.59 28.0527 158.5 24.4629 158.5V161.5C29.7096 161.5 33.9629 157.247 33.9629 152H30.9629ZM24.4629 37.5C28.0527 37.5 30.9629 40.4101 30.9629 44H33.9629C33.9629 38.7533 29.7096 34.5 24.4629 34.5V37.5ZM24.4629 34.5C19.2162 34.5 14.9629 38.7533 14.9629 44H17.9629C17.9629 40.4101 20.873 37.5 24.4629 37.5V34.5Z"
          fill="black"
          mask="url(#path-12-inside-6_5550_66598)"
        />
      </g>
      <defs>
        <clipPath id="clip0_5550_66598">
          <path
            d="M0.462891 8C0.462891 3.58172 4.04461 0 8.46289 0H185.926C190.344 0 193.926 3.58172 193.926 8V188C193.926 192.418 190.344 196 185.926 196H8.46289C4.04462 196 0.462891 192.418 0.462891 188V8Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  gfxBrands: ({ classname, ...props }) => (
    <svg
      width="195"
      height="196"
      viewBox="0 0 195 196"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_5749_75380)">
        <path
          d="M0.925781 8C0.925781 3.58172 4.5075 0 8.92578 0H186.389C190.807 0 194.389 3.58172 194.389 8V188C194.389 192.418 190.807 196 186.389 196H8.92578C4.50751 196 0.925781 192.418 0.925781 188V8Z"
          fill="#FAF9F5"
        />
        <path
          d="M102.001 149.5L102.001 75.6095C109.766 88.744 165.681 88.744 175 75.6095L175.001 149.5C167.235 164.736 110.802 164.736 102.001 149.5Z"
          fill={getBrandColor()}
        />
        <path
          d="M123.699 11V-10C132 -4.5 144.716 -4.5 153.5 -10V11C145.5 16 132.266 16 123.699 11Z"
          fill={getBrandColor()}
        />
        <path
          d="M127 12.5C127 26.2867 102.002 38.2579 102.001 59.2378C102.001 64.2547 102.001 62.0643 102.001 75.6095M150 12.5C150 25.6873 175 38.2579 175 59.2378C175 64.2547 175 62.0643 175 75.6095M102.001 75.6095C102 96.7941 102.001 137.67 102.001 160.54C102.001 184.198 102.001 202.5 102.001 202.5H175C175 202.5 175 184.198 175 160.54C175 137.67 175 96.7941 175 75.6095M102.001 75.6095L102.001 149.5C110.802 164.736 167.235 164.736 175.001 149.5L175 75.6095M102.001 75.6095C109.766 88.744 165.681 88.744 175 75.6095M123.699 -10V11C132.266 16 145.5 16 153.5 11V-10C144.716 -4.5 132 -4.5 123.699 -10Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M60.9629 86.016C72.5003 86.016 82.9174 87.3789 90.4258 89.5648C94.1848 90.6593 97.1725 91.9474 99.2031 93.3451C101.257 94.759 102.176 96.1701 102.176 97.4828C102.176 98.7956 101.257 100.207 99.2031 101.621C97.1725 103.018 94.1848 104.307 90.4258 105.402C82.9174 107.588 72.5003 108.951 60.9629 108.951C49.4255 108.951 39.0084 107.588 31.5 105.402C27.741 104.307 24.7533 103.018 22.7227 101.621C20.6687 100.207 19.75 98.7956 19.75 97.4828C19.7501 96.1701 20.6686 94.759 22.7227 93.3451C24.7533 91.9474 27.741 90.6593 31.5 89.5648C39.0084 87.3789 49.4255 86.016 60.9629 86.016Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M20.1411 169.5V131C27.907 144.135 92.6231 144.135 101.942 131V169.5C94.1763 184.736 28.9425 184.736 20.1411 169.5Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <path d="M19.8984 96.9518V200" stroke="black" strokeWidth="1.5" />
        <path d="M102.036 96.9518V200" stroke="black" strokeWidth="1.5" />
        <mask id="path-8-inside-1_5749_75380" fill="white">
          <path d="M1.15723 8C1.15723 3.58172 4.73895 0 9.15723 0H186.157C190.576 0 194.157 3.58172 194.157 8V188C194.157 192.418 190.576 196 186.157 196H9.15723C4.73895 196 1.15723 192.418 1.15723 188V8Z" />
        </mask>
        <path
          d="M9.15723 0V1.5H186.157V0V-1.5H9.15723V0ZM194.157 8H192.657V188H194.157H195.657V8H194.157ZM186.157 196V194.5H9.15723V196V197.5H186.157V196ZM1.15723 188H2.65723V8H1.15723H-0.342773V188H1.15723ZM9.15723 196V194.5C5.56738 194.5 2.65723 191.59 2.65723 188H1.15723H-0.342773C-0.342773 193.247 3.91053 197.5 9.15723 197.5V196ZM194.157 188H192.657C192.657 191.59 189.747 194.5 186.157 194.5V196V197.5C191.404 197.5 195.657 193.247 195.657 188H194.157ZM186.157 0V1.5C189.747 1.5 192.657 4.41015 192.657 8H194.157H195.657C195.657 2.75329 191.404 -1.5 186.157 -1.5V0ZM9.15723 0V-1.5C3.91052 -1.5 -0.342773 2.75329 -0.342773 8H1.15723H2.65723C2.65723 4.41015 5.56737 1.5 9.15723 1.5V0Z"
          fill="black"
          mask="url(#path-8-inside-1_5749_75380)"
        />
      </g>
      <defs>
        <clipPath id="clip0_5749_75380">
          <path
            d="M0.925781 8C0.925781 3.58172 4.5075 0 8.92578 0H186.389C190.807 0 194.389 3.58172 194.389 8V188C194.389 192.418 190.807 196 186.389 196H8.92578C4.50751 196 0.925781 192.418 0.925781 188V8Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  gfxSuccess: ({ classname, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="194"
      height="196"
      viewBox="0 0 194 196"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_6218_86946)">
        <path
          d="M96.4258 0.75C149.296 0.75 192.176 44.2794 192.176 98C192.176 151.721 149.296 195.25 96.4258 195.25C43.5554 195.25 0.675781 151.721 0.675781 98C0.675781 44.2794 43.5554 0.75 96.4258 0.75Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M36.0473 105.091L49.6664 85.093C50.8742 83.3195 53.2662 82.8149 55.0874 83.9494L91.2098 106.45C93.0435 107.593 95.4528 107.072 96.6519 105.275L164.458 3.66084C165.663 1.85412 168.09 1.33965 169.925 2.50186L191.099 15.913C192.986 17.1081 193.528 19.6168 192.304 21.4848L107.529 150.831C106.33 152.662 103.881 153.188 102.035 152.012L37.2044 110.716C35.3005 109.503 34.7767 106.956 36.0473 105.091Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_6218_86946">
          <path
            d="M0.388672 8C0.388672 3.58172 3.97039 0 8.38867 0H185.852C190.27 0 193.852 3.58172 193.852 8V188C193.852 192.418 190.27 196 185.852 196H8.38867C3.9704 196 0.388672 192.418 0.388672 188V8Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  gfxBasket: ({ classname, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="194"
      height="196"
      viewBox="0 0 194 196"
      fill="none"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_6498_96772)">
        <path
          d="M5 2L18.4154 34M18.4154 34L59.5 132H194V34H18.4154Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <circle
          cx="70.5"
          cy="169.5"
          r="25.75"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <circle
          cx="192.5"
          cy="169.5"
          r="25.75"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <mask id="path-5-inside-1_6498_96772" fill="white">
          <path d="M0.628906 188C0.628906 192.418 4.21063 196 8.62891 196H186.092C190.51 196 194.092 192.418 194.092 188V8.41113C194.092 3.99286 190.51 0.411133 186.092 0.411133H8.62891C4.21063 0.411133 0.628906 3.99286 0.628906 8.41113V188Z" />
        </mask>
        <path
          d="M8.62891 196V194.5H186.092V196V197.5H8.62891V196ZM194.092 188H192.592V8.41113H194.092H195.592V188H194.092ZM186.092 0.411133V1.91113H8.62891V0.411133V-1.08887H186.092V0.411133ZM0.628906 8.41113H2.12891V188H0.628906H-0.871094V8.41113H0.628906ZM8.62891 0.411133V1.91113C5.03906 1.91113 2.12891 4.82129 2.12891 8.41113H0.628906H-0.871094C-0.871094 3.16443 3.38221 -1.08887 8.62891 -1.08887V0.411133ZM194.092 8.41113H192.592C192.592 4.82129 189.682 1.91113 186.092 1.91113V0.411133V-1.08887C191.339 -1.08887 195.592 3.16443 195.592 8.41113H194.092ZM186.092 196V194.5C189.682 194.5 192.592 191.59 192.592 188H194.092H195.592C195.592 193.247 191.339 197.5 186.092 197.5V196ZM8.62891 196V197.5C3.3822 197.5 -0.871094 193.247 -0.871094 188H0.628906H2.12891C2.12891 191.59 5.03906 194.5 8.62891 194.5V196Z"
          fill="black"
          mask="url(#path-5-inside-1_6498_96772)"
        />
      </g>
      <defs>
        <clipPath id="clip0_6498_96772">
          <path
            d="M0.851562 188C0.851562 192.418 4.43328 196 8.85156 196H185.852C190.27 196 193.852 192.418 193.852 188V8C193.852 3.58171 190.27 0 185.852 0H8.85157C4.43329 0 0.851562 3.58173 0.851562 8V188Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  gfxDelivery: ({ classname, ...props }) => (
    <svg
      width="194"
      height="196"
      viewBox="0 0 194 196"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_6545_29612)">
        <path
          d="M106 1V60.5H142L193.5 127.5V195.5H1.5V1H106Z"
          fill="#FAF9F5"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M136.5 78H106V132.5H178.5L136.5 78Z"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <circle
          cx="137.5"
          cy="192.5"
          r="41.75"
          fill="#FAF9F5"
          stroke="black"
          strokeWidth="1.5"
        />
        <circle
          cx="137.5"
          cy="192.5"
          r="25.75"
          fill={getBrandColor()}
          stroke="black"
          strokeWidth="1.5"
        />
        <mask id="path-6-inside-1_6545_29612" fill="white">
          <path d="M0.628906 188C0.628906 192.418 4.21063 196 8.62891 196H186.092C190.51 196 194.092 192.418 194.092 188V8.41113C194.092 3.99286 190.51 0.411133 186.092 0.411133H8.62891C4.21063 0.411133 0.628906 3.99286 0.628906 8.41113V188Z" />
        </mask>
        <path
          d="M8.62891 196V194.5H186.092V196V197.5H8.62891V196ZM194.092 188H192.592V8.41113H194.092H195.592V188H194.092ZM186.092 0.411133V1.91113H8.62891V0.411133V-1.08887H186.092V0.411133ZM0.628906 8.41113H2.12891V188H0.628906H-0.871094V8.41113H0.628906ZM8.62891 0.411133V1.91113C5.03906 1.91113 2.12891 4.82129 2.12891 8.41113H0.628906H-0.871094C-0.871094 3.16443 3.38221 -1.08887 8.62891 -1.08887V0.411133ZM194.092 8.41113H192.592C192.592 4.82129 189.682 1.91113 186.092 1.91113V0.411133V-1.08887C191.339 -1.08887 195.592 3.16443 195.592 8.41113H194.092ZM186.092 196V194.5C189.682 194.5 192.592 191.59 192.592 188H194.092H195.592C195.592 193.247 191.339 197.5 186.092 197.5V196ZM8.62891 196V197.5C3.3822 197.5 -0.871094 193.247 -0.871094 188H0.628906H2.12891C2.12891 191.59 5.03906 194.5 8.62891 194.5V196Z"
          fill="black"
          mask="url(#path-6-inside-1_6545_29612)"
        />
      </g>
      <defs>
        <clipPath id="clip0_6545_29612">
          <path
            d="M0.851562 188C0.851562 192.418 4.43328 196 8.85156 196H185.852C190.27 196 193.852 192.418 193.852 188V8C193.852 3.58171 190.27 0 185.852 0H8.85157C4.43329 0 0.851562 3.58173 0.851562 8V188Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  award: ({ classname, ...props }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M8.21 13.89L7 23L12 20L17 23L15.79 13.88M19 8C19 11.866 15.866 15 12 15C8.13401 15 5 11.866 5 8C5 4.13401 8.13401 1 12 1C15.866 1 19 4.13401 19 8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  creditCard: ({ classname, ...props }) => (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M0.833008 6.33301H19.1663M2.49967 1.33301H17.4997C18.4201 1.33301 19.1663 2.0792 19.1663 2.99967V12.9997C19.1663 13.9201 18.4201 14.6663 17.4997 14.6663H2.49967C1.5792 14.6663 0.833008 13.9201 0.833008 12.9997V2.99967C0.833008 2.0792 1.5792 1.33301 2.49967 1.33301Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  flag: ({ classname, ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M2.66602 9.99967C2.66602 9.99967 3.33268 9.33301 5.33268 9.33301C7.33268 9.33301 8.66602 10.6663 10.666 10.6663C12.666 10.6663 13.3327 9.99967 13.3327 9.99967V1.99967C13.3327 1.99967 12.666 2.66634 10.666 2.66634C8.66602 2.66634 7.33268 1.33301 5.33268 1.33301C3.33268 1.33301 2.66602 1.99967 2.66602 1.99967V9.99967ZM2.66602 9.99967V14.6663"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  bell: ({ classname, ...props }) => (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M13.73 21.5C13.5542 21.8031 13.3018 22.0547 12.9982 22.2295C12.6946 22.4044 12.3504 22.4965 12 22.4965C11.6496 22.4965 11.3054 22.4044 11.0018 22.2295C10.6982 22.0547 10.4458 21.8031 10.27 21.5M18 8.5C18 6.9087 17.3679 5.38258 16.2426 4.25736C15.1174 3.13214 13.5913 2.5 12 2.5C10.4087 2.5 8.88258 3.13214 7.75736 4.25736C6.63214 5.38258 6 6.9087 6 8.5C6 15.5 3 17.5 3 17.5H21C21 17.5 18 15.5 18 8.5Z"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  padlock: ({ classname, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M4.66667 7.33301V4.66634C4.66667 3.78229 5.01786 2.93444 5.64298 2.30932C6.2681 1.6842 7.11595 1.33301 8 1.33301C8.88406 1.33301 9.7319 1.6842 10.357 2.30932C10.9821 2.93444 11.3333 3.78229 11.3333 4.66634V7.33301M3.33333 7.33301H12.6667C13.403 7.33301 14 7.92996 14 8.66634V13.333C14 14.0694 13.403 14.6663 12.6667 14.6663H3.33333C2.59695 14.6663 2 14.0694 2 13.333V8.66634C2 7.92996 2.59695 7.33301 3.33333 7.33301Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  padlockOpen: ({ classname, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M4.66667 7.33301V4.66634C4.66584 3.83971 4.97219 3.04225 5.52625 2.42879C6.08031 1.81532 6.84255 1.42961 7.665 1.34654C8.48745 1.26346 9.31143 1.48895 9.97698 1.97922C10.64253 2.46949 11 3.4997 11 3.4997M3.33333 7.33301H12.6667C13.403 7.33301 14 7.92996 14 8.66634V13.333C14 14.0694 13.403 14.6663 12.6667 14.6663H3.33333C2.59695 14.6663 2 14.0694 2 13.333V8.66634C2 7.92996 2.59695 7.33301 3.33333 7.33301Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  smile: ({ classname, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_8785_16235)">
        <path
          d="M5.33398 9.33301C5.33398 9.33301 6.33398 10.6663 8.00065 10.6663C9.66732 10.6663 10.6673 9.33301 10.6673 9.33301M6.00065 5.99967H6.00732M10.0007 5.99967H10.0073M14.6673 7.99967C14.6673 11.6816 11.6825 14.6663 8.00065 14.6663C4.31875 14.6663 1.33398 11.6816 1.33398 7.99967C1.33398 4.31778 4.31875 1.33301 8.00065 1.33301C11.6825 1.33301 14.6673 4.31778 14.6673 7.99967Z"
          stroke="#28A745"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8785_16235">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  download: ({ classname, ...props }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13M5 8L10 13M10 13L15 8M10 13V1"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  loader: ({ classname, ...props }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM4.28448 10C4.28448 13.1566 6.8434 15.7155 10 15.7155C13.1566 15.7155 15.7155 13.1566 15.7155 10C15.7155 6.8434 13.1566 4.28448 10 4.28448C6.8434 4.28448 4.28448 6.8434 4.28448 10Z"
        fill="#D1CFC7"
      />
      <path
        d="M8.03102 0.195759C6.3889 0.525547 4.8559 1.26252 3.57275 2.33903C2.2896 3.41554 1.2974 4.7971 0.687216 6.35692C0.0770301 7.91673 -0.131593 9.60482 0.0804946 11.2663C0.292582 12.9277 0.918587 14.5092 1.90105 15.8658L5.37103 13.3526C4.8095 12.5773 4.4517 11.6733 4.33048 10.7237C4.20926 9.77414 4.3285 8.8093 4.67726 7.91779C5.02601 7.02627 5.59311 6.23664 6.32649 5.62135C7.05988 5.00607 7.93606 4.58485 8.87463 4.39636L8.03102 0.195759Z"
        fill={getBrandColor()}
      />
    </svg>
  ),

  searchFilter: ({ classname = '', alt = 'Filter', ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        d="M17.5 16.25L14.7812 13.5312M16.25 10C16.25 12.7614 14.0114 15 11.25 15C8.48858 15 6.25 12.7614 6.25 10C6.25 7.23858 8.48858 5 11.25 5C14.0114 5 16.25 7.23858 16.25 10Z"
        stroke={getBrandColor()}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.6665 5H4.1665M1.6665 10H2.9165M1.6665 15H4.1665"
        stroke={getBrandColor()}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  ribbon: ({ classname, ...props }) => (
    <svg
      width="118"
      height="112"
      viewBox="0 0 118 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M29.2214 48.2087L19.7143 107.621L59 83.9777L98.2857 107.621L88.7786 48.1299M114 1.78893C114 32.2573 89.3757 56.9568 59 56.9568C28.6243 56.9568 4 32.2573 4 1.78893C4 -28.6794 28.6243 -53.3789 59 -53.3789C89.3757 -53.3789 114 -28.6794 114 1.78893Z"
        stroke="white"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  addToList: ({ classname, ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={classname}
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M1 5h10M1 10h6.556M1 15h10M15.5 6.5v7M12 10h7"
      />
    </svg>
  ),

  gfxPlate: ({ classname = '', ...props }) => (
    <svg
      viewBox="0 0 97 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_17532_3139)">
        <circle
          cx="88.3242"
          cy="88.25"
          r="88.25"
          stroke="black"
          strokeWidth="1.5"
        />
        <circle
          cx="88.3242"
          cy="88.25"
          r="70.25"
          stroke="black"
          strokeWidth="1.5"
        />
        <rect
          x="82.8242"
          y="41.25"
          width="18.5"
          height="86.5"
          rx="9.25"
          fill="#FC4C02"
          stroke="black"
          strokeWidth="1.5"
        />
        <mask id="path-5-inside-1_17532_3139" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M78.7412 56.1663C78.7412 61.701 75.0953 66.3853 70.0742 67.9465V114.5C70.074 116.709 68.2832 118.5 66.0742 118.5C63.8652 118.5 62.0744 116.709 62.0742 114.5V67.7151C57.4008 65.9607 54.0742 61.4526 54.0742 56.1663V41.1663H78.7412V56.1663Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.7412 56.1663C78.7412 61.701 75.0953 66.3853 70.0742 67.9465V114.5C70.074 116.709 68.2832 118.5 66.0742 118.5C63.8652 118.5 62.0744 116.709 62.0742 114.5V67.7151C57.4008 65.9607 54.0742 61.4526 54.0742 56.1663V41.1663H78.7412V56.1663Z"
          fill="#FC4C02"
        />
        <path
          d="M70.0742 67.9465L69.6289 66.5142L68.5742 66.8421V67.9465H70.0742ZM70.0742 114.5L71.5742 114.5V114.5H70.0742ZM62.0742 114.5H60.5742V114.5L62.0742 114.5ZM62.0742 67.7151H63.5742V66.676L62.6014 66.3108L62.0742 67.7151ZM54.0742 41.1663V39.6663H52.5742V41.1663H54.0742ZM78.7412 41.1663H80.2412V39.6663H78.7412V41.1663ZM78.7412 56.1663H77.2412C77.2412 61.0258 74.0404 65.1425 69.6289 66.5142L70.0742 67.9465L70.5196 69.3789C76.1502 67.6282 80.2412 62.3763 80.2412 56.1663H78.7412ZM70.0742 67.9465H68.5742V114.5H70.0742H71.5742V67.9465H70.0742ZM70.0742 114.5L68.5742 114.5C68.5741 115.881 67.4547 117 66.0742 117V118.5V120C69.1118 120 71.574 117.538 71.5742 114.5L70.0742 114.5ZM66.0742 118.5V117C64.6937 117 63.5743 115.881 63.5742 114.5L62.0742 114.5L60.5742 114.5C60.5745 117.538 63.0366 120 66.0742 120V118.5ZM62.0742 114.5H63.5742V67.7151H62.0742H60.5742V114.5H62.0742ZM62.0742 67.7151L62.6014 66.3108C58.4937 64.7687 55.5742 60.807 55.5742 56.1663H54.0742H52.5742C52.5742 62.0982 56.3079 67.1526 61.547 69.1194L62.0742 67.7151ZM54.0742 56.1663H55.5742V41.1663H54.0742H52.5742V56.1663H54.0742ZM54.0742 41.1663V42.6663H78.7412V41.1663V39.6663H54.0742V41.1663ZM78.7412 41.1663H77.2412V56.1663H78.7412H80.2412V41.1663H78.7412Z"
          fill="black"
          mask="url(#path-5-inside-1_17532_3139)"
        />
        <mask id="path-7-inside-2_17532_3139" fill="white">
          <path d="M0 8C0 3.58172 3.58172 0 8 0H88.7314C93.1497 0 96.7314 3.58172 96.7314 8V89.7944C96.7314 94.2127 93.1497 97.7944 88.7314 97.7944H8C3.58172 97.7944 0 94.2127 0 89.7944V8Z" />
        </mask>
        <path
          d="M8 0V1.5H88.7314V0V-1.5H8V0ZM96.7314 8H95.2314V89.7944H96.7314H98.2314V8H96.7314ZM88.7314 97.7944V96.2944H8V97.7944V99.2944H88.7314V97.7944ZM0 89.7944H1.5V8H0H-1.5V89.7944H0ZM8 97.7944V96.2944C4.41015 96.2944 1.5 93.3843 1.5 89.7944H0H-1.5C-1.5 95.0411 2.75329 99.2944 8 99.2944V97.7944ZM96.7314 89.7944H95.2314C95.2314 93.3843 92.3213 96.2944 88.7314 96.2944V97.7944V99.2944C93.9781 99.2944 98.2314 95.0411 98.2314 89.7944H96.7314ZM88.7314 0V1.5C92.3213 1.5 95.2314 4.41015 95.2314 8H96.7314H98.2314C98.2314 2.7533 93.9782 -1.5 88.7314 -1.5V0ZM8 0V-1.5C2.75329 -1.5 -1.5 2.7533 -1.5 8H0H1.5C1.5 4.41015 4.41015 1.5 8 1.5V0Z"
          fill="black"
          mask="url(#path-7-inside-2_17532_3139)"
        />
      </g>
      <defs>
        <clipPath id="clip0_17532_3139">
          <path
            d="M0 8C0 3.58172 3.58172 0 8 0H88.7314C93.1497 0 96.7314 3.58172 96.7314 8V90C96.7314 94.4183 93.1497 98 88.7314 98H8C3.58172 98 0 94.4183 0 90V8Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  teamGraphic: ({ classname, ...props }) => (
    <svg
      width="95"
      height="96"
      viewBox="0 0 95 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_11293_32098)">
        <mask id="path-2-inside-1_11293_32098" fill="white">
          <path d="M0 88C0 92.4183 3.58172 96 8 96H79C83.4183 96 87 92.4183 87 88V16.1846C87 11.7663 83.4183 8.18459 79 8.18459H8C3.58172 8.18459 0 11.7663 0 16.1846V88Z" />
        </mask>
        <path
          d="M8 96V94.5H79V96V97.5H8V96ZM87 88H85.5V16.1846H87H88.5V88H87ZM79 8.18459V9.68459H8V8.18459V6.68459H79V8.18459ZM0 16.1846H1.5V88H0H-1.5V16.1846H0ZM8 8.18459V9.68459C4.41015 9.68459 1.5 12.5947 1.5 16.1846H0H-1.5C-1.5 10.9379 2.7533 6.68459 8 6.68459V8.18459ZM87 16.1846H85.5C85.5 12.5947 82.5899 9.68459 79 9.68459V8.18459V6.68459C84.2467 6.68459 88.5 10.9379 88.5 16.1846H87ZM79 96V94.5C82.5899 94.5 85.5 91.5898 85.5 88H87H88.5C88.5 93.2467 84.2467 97.5 79 97.5V96ZM8 96V97.5C2.7533 97.5 -1.5 93.2467 -1.5 88H0H1.5C1.5 91.5899 4.41015 94.5 8 94.5V96Z"
          fill="black"
          mask="url(#path-2-inside-1_11293_32098)"
        />
        <mask id="path-4-inside-2_11293_32098" fill="white">
          <path d="M28.3311 96.4492H88.141V71.5787C88.141 55.0626 74.7521 41.6737 58.236 41.6737C41.72 41.6737 28.3311 55.0626 28.3311 71.5787V96.4492Z" />
        </mask>
        <path
          d="M28.3311 96.4492H88.141V71.5787C88.141 55.0626 74.7521 41.6737 58.236 41.6737C41.72 41.6737 28.3311 55.0626 28.3311 71.5787V96.4492Z"
          fill="#FAF9F5"
        />
        <path
          d="M28.3311 96.4492V97.9492H26.8311V96.4492H28.3311ZM88.141 96.4492H89.641V97.9492H88.141V96.4492ZM28.3311 96.4492V94.9492H88.141V96.4492V97.9492H28.3311V96.4492ZM88.141 96.4492H86.641V71.5787H88.141H89.641V96.4492H88.141ZM58.236 41.6737M28.3311 71.5787H29.8311V96.4492H28.3311H26.8311V71.5787H28.3311ZM58.236 41.6737V43.1737C42.5484 43.1737 29.8311 55.891 29.8311 71.5787H28.3311H26.8311C26.8311 54.2342 40.8915 40.1737 58.236 40.1737V41.6737ZM88.141 71.5787H86.641C86.641 55.891 73.9236 43.1737 58.236 43.1737V41.6737V40.1737C75.5805 40.1737 89.641 54.2342 89.641 71.5787H88.141Z"
          fill="black"
          mask="url(#path-4-inside-2_11293_32098)"
        />
        <path
          d="M79.7461 30.4492C79.7461 42.1841 70.2175 51.6992 58.4609 51.6992C46.7043 51.6992 37.1758 42.1841 37.1758 30.4492C37.1758 18.7143 46.7043 9.19922 58.4609 9.19922C70.2175 9.19926 79.7461 18.7143 79.7461 30.4492Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <mask id="path-7-inside-3_11293_32098" fill="white">
          <path d="M73.7461 46.293C69.784 50.1041 64.3972 52.4492 58.4609 52.4492C52.4148 52.4492 46.9384 50.0167 42.957 46.0801C47.6555 43.2541 52.7933 41.6973 58.1768 41.6973C63.694 41.6973 68.9534 43.3324 73.7461 46.293Z" />
        </mask>
        <path
          d="M73.7461 46.293C69.784 50.1041 64.3972 52.4492 58.4609 52.4492C52.4148 52.4492 46.9384 50.0167 42.957 46.0801C47.6555 43.2541 52.7933 41.6973 58.1768 41.6973C63.694 41.6973 68.9534 43.3324 73.7461 46.293Z"
          fill="white"
        />
        <path
          d="M73.7461 46.293L74.786 47.374L76.1799 46.0332L74.5344 45.0168L73.7461 46.293ZM58.4609 52.4492L58.4609 53.9492L58.461 53.9492L58.4609 52.4492ZM42.957 46.0801L42.1839 44.7947L40.5298 45.7896L41.9024 47.1467L42.957 46.0801ZM58.1768 41.6973L58.1768 40.1973L58.1767 40.1973L58.1768 41.6973ZM73.7461 46.293L72.7062 45.2119C69.0123 48.7651 63.9941 50.9492 58.4609 50.9492L58.4609 52.4492L58.461 53.9492C64.8003 53.9492 70.5556 51.4431 74.786 47.374L73.7461 46.293ZM58.4609 52.4492L58.4609 50.9492C52.8255 50.9492 47.7237 48.6837 44.0117 45.0134L42.957 46.0801L41.9024 47.1467C46.1532 51.3497 52.0042 53.9492 58.4609 53.9492L58.4609 52.4492ZM42.957 46.0801L43.7302 47.3655C48.2191 44.6656 53.0923 43.1973 58.1768 43.1973L58.1768 41.6973L58.1767 40.1973C52.4943 40.1973 47.0919 41.8427 42.1839 44.7947L42.957 46.0801ZM58.1768 41.6973L58.1768 43.1973C63.3871 43.1973 68.3766 44.7392 72.9578 47.5691L73.7461 46.293L74.5344 45.0168C69.5302 41.9256 64.0008 40.1973 58.1768 40.1973L58.1768 41.6973Z"
          fill="black"
          mask="url(#path-7-inside-3_11293_32098)"
        />
        <mask id="path-9-inside-4_11293_32098" fill="white">
          <path d="M-1.79883 96.4492H58.0111V71.5787C58.0111 55.0626 44.6222 41.6737 28.1061 41.6737C11.5901 41.6737 -1.79883 55.0626 -1.79883 71.5787V96.4492Z" />
        </mask>
        <path
          d="M-1.79883 96.4492H58.0111V71.5787C58.0111 55.0626 44.6222 41.6737 28.1061 41.6737C11.5901 41.6737 -1.79883 55.0626 -1.79883 71.5787V96.4492Z"
          fill="#FC4C02"
        />
        <path
          d="M-1.79883 96.4492V97.9492H-3.29883V96.4492H-1.79883ZM58.0111 96.4492H59.5111V97.9492H58.0111V96.4492ZM-1.79883 96.4492V94.9492H58.0111V96.4492V97.9492H-1.79883V96.4492ZM58.0111 96.4492H56.5111V71.5787H58.0111H59.5111V96.4492H58.0111ZM28.1061 41.6737M-1.79883 71.5787H-0.298828V96.4492H-1.79883H-3.29883V71.5787H-1.79883ZM28.1061 41.6737V43.1737C12.4185 43.1737 -0.298828 55.891 -0.298828 71.5787H-1.79883H-3.29883C-3.29883 54.2342 10.7616 40.1737 28.1061 40.1737V41.6737ZM58.0111 71.5787H56.5111C56.5111 55.891 43.7938 43.1737 28.1061 43.1737V41.6737V40.1737C45.4506 40.1737 59.5111 54.2342 59.5111 71.5787H58.0111Z"
          fill="black"
          mask="url(#path-9-inside-4_11293_32098)"
        />
        <path
          d="M49.6162 30.4492C49.6162 42.1841 40.0877 51.6992 28.3311 51.6992C16.5744 51.6992 7.0459 42.1841 7.0459 30.4492C7.0459 18.7143 16.5744 9.19922 28.3311 9.19922C40.0877 9.19926 49.6162 18.7143 49.6162 30.4492Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <mask id="path-12-inside-5_11293_32098" fill="white">
          <path d="M43.6162 46.293C39.6541 50.1041 34.2673 52.4492 28.3311 52.4492C22.2849 52.4492 16.8086 50.0167 12.8271 46.0801C17.5256 43.2541 22.6634 41.6973 28.0469 41.6973C33.5641 41.6973 38.8235 43.3324 43.6162 46.293Z" />
        </mask>
        <path
          d="M43.6162 46.293C39.6541 50.1041 34.2673 52.4492 28.3311 52.4492C22.2849 52.4492 16.8086 50.0167 12.8271 46.0801C17.5256 43.2541 22.6634 41.6973 28.0469 41.6973C33.5641 41.6973 38.8235 43.3324 43.6162 46.293Z"
          fill="white"
        />
        <path
          d="M43.6162 46.293L44.6561 47.374L46.05 46.0332L44.4045 45.0168L43.6162 46.293ZM28.3311 52.4492L28.3311 53.9492L28.3311 53.9492L28.3311 52.4492ZM12.8271 46.0801L12.054 44.7947L10.3999 45.7896L11.7725 47.1467L12.8271 46.0801ZM28.0469 41.6973L28.0469 40.1973L28.0469 40.1973L28.0469 41.6973ZM43.6162 46.293L42.5763 45.2119C38.8824 48.7651 33.8642 50.9492 28.331 50.9492L28.3311 52.4492L28.3311 53.9492C34.6704 53.9492 40.4258 51.4431 44.6561 47.374L43.6162 46.293ZM28.3311 52.4492L28.3311 50.9492C22.6956 50.9492 17.5938 48.6837 13.8818 45.0134L12.8271 46.0801L11.7725 47.1467C16.0233 51.3497 21.8743 53.9492 28.3311 53.9492L28.3311 52.4492ZM12.8271 46.0801L13.6003 47.3655C18.0892 44.6656 22.9624 43.1973 28.0469 43.1973L28.0469 41.6973L28.0469 40.1973C22.3644 40.1973 16.962 41.8427 12.054 44.7947L12.8271 46.0801ZM28.0469 41.6973L28.0469 43.1973C33.2572 43.1973 38.2467 44.7392 42.8279 47.5691L43.6162 46.293L44.4045 45.0168C39.4003 41.9256 33.8709 40.1973 28.0469 40.1973L28.0469 41.6973Z"
          fill="black"
          mask="url(#path-12-inside-5_11293_32098)"
        />
        <mask id="path-14-inside-6_11293_32098" fill="white">
          <path d="M0 88C0 92.4183 3.58172 96 8 96H79C83.4183 96 87 92.4183 87 88V16.1846C87 11.7663 83.4183 8.18459 79 8.18459H8C3.58172 8.18459 0 11.7663 0 16.1846V88Z" />
        </mask>
        <path
          d="M8 96V94.5H79V96V97.5H8V96ZM87 88H85.5V16.1846H87H88.5V88H87ZM79 8.18459V9.68459H8V8.18459V6.68459H79V8.18459ZM0 16.1846H1.5V88H0H-1.5V16.1846H0ZM8 8.18459V9.68459C4.41015 9.68459 1.5 12.5947 1.5 16.1846H0H-1.5C-1.5 10.9379 2.7533 6.68459 8 6.68459V8.18459ZM87 16.1846H85.5C85.5 12.5947 82.5899 9.68459 79 9.68459V8.18459V6.68459C84.2467 6.68459 88.5 10.9379 88.5 16.1846H87ZM79 96V94.5C82.5899 94.5 85.5 91.5898 85.5 88H87H88.5C88.5 93.2467 84.2467 97.5 79 97.5V96ZM8 96V97.5C2.7533 97.5 -1.5 93.2467 -1.5 88H0H1.5C1.5 91.5899 4.41015 94.5 8 94.5V96Z"
          fill="black"
          mask="url(#path-14-inside-6_11293_32098)"
        />
      </g>
      <defs>
        <clipPath id="clip0_11293_32098">
          <path
            d="M0 88C0 92.4183 3.58172 96 8 96H79C83.4183 96 87 92.4183 87 88V16C87 11.5817 83.4183 8 79 8H8C3.58172 8 0 11.5817 0 16V88Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  new: () => (
    <svg
      width="123"
      height="123"
      viewBox="0 0 123 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18825_36986)">
        <path
          d="M0 114.667C0 119.085 3.58172 122.667 8 122.667H114.667C119.085 122.667 122.667 119.085 122.667 114.667V8C122.667 3.58172 119.085 0 114.667 0H8C3.58172 0 0 3.58172 0 8V114.667Z"
          fill="#FAF9F5"
        />
        <path
          d="M82.6929 80.7687L90.5728 36.8656H96.0955L99.665 40.6127L91.2126 85.1457H85.0501L82.6929 80.7687ZM82.4235 36.8656L89.0574 81.1003L86.4308 85.1457H79.2917L71.0077 36.8656H82.4235ZM102.022 80.8681L108.623 36.8656H119.971L111.687 85.1457H104.582L102.022 80.8681ZM100.305 36.8656L108.454 81.0339L105.929 85.1457H99.766L91.0779 40.5463L94.8158 36.8656H100.305Z"
          fill="#FC4C02"
        />
        <path
          d="M69.929 76.1927V85.1457H48.4781V76.1927H69.929ZM52.4854 36.8656V85.1457H40.9686V36.8656H52.4854ZM67.134 56.0318V64.6864H48.4781V56.0318H67.134ZM70.0301 36.8656V45.8518H48.4781V36.8656H70.0301Z"
          fill="#FC4C02"
        />
        <path
          d="M38.439 36.8656V85.1457H26.9558L14.6645 55.1033V85.1457H3.14771V36.8656H14.6645L26.9558 66.908V36.8656H38.439Z"
          fill="#FC4C02"
        />
        <path
          d="M82.9453 36.2701L83.0221 36.7785L86.1864 57.8789L90.0655 36.2701H100.81L104.831 58.0657L108.1 36.2701H120.687L112.198 85.7416H99.2658L95.4411 66.1077L91.715 85.7416H78.7803L70.2919 36.2701H82.9453ZM71.0079 36.8658L79.2919 85.1458H91.2128L95.4334 62.9058L99.7662 85.1458H111.687L119.971 36.8658H108.623L104.892 61.7312L100.305 36.8658H90.573L86.1332 61.6009L82.4237 36.8658H71.0079Z"
          fill="#FC4C02"
        />
        <path
          d="M40.9681 36.8658V85.1458H69.9285V76.1928H52.4849V64.6865H67.1335V56.0319H52.4849V45.852H70.0295V36.8658H40.9681ZM70.6345 46.4477H53.0899V55.4362H67.7384V65.2822H53.0899V75.5971H70.5335V85.7416H40.3632V36.2701H70.6345V46.4477Z"
          fill="#FC4C02"
        />
        <path
          d="M26.9554 36.8658V66.9082L14.6641 36.8658H3.14732V85.1458H14.6641V55.1034L26.9554 85.1458H38.4386V36.8658H26.9554ZM39.0435 85.7416H26.5472L15.2691 58.175V85.7416H2.54236V36.2701H15.0729L26.3505 63.8348V36.2701H39.0435V85.7416Z"
          fill="#FC4C02"
        />
      </g>
      <defs>
        <clipPath id="clip0_18825_36986">
          <path
            d="M0 114.667C0 119.085 3.58172 122.667 8 122.667H114.667C119.085 122.667 122.667 119.085 122.667 114.667V8C122.667 3.58172 119.085 0 114.667 0H8C3.58172 0 0 3.58172 0 8V114.667Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  clearance: () => (
    <svg
      width="123"
      height="123"
      viewBox="0 0 123 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18825_37000)">
        <path
          d="M0 114.667C0 119.085 3.58172 122.667 8 122.667H114.667C119.085 122.667 122.667 119.085 122.667 114.667V8C122.667 3.58172 119.085 0 114.667 0H8C3.58172 0 0 3.58172 0 8V114.667Z"
          fill="#FAF9F5"
        />
        <path
          d="M56.762 101.288C58.3459 102.847 60.9177 102.836 62.4876 101.262L101.289 62.3726C102.03 61.6304 102.445 60.6317 102.445 59.5913L102.447 23.9029C102.447 21.7108 100.642 19.9333 98.4163 19.9331L63.9944 19.9322C62.9256 19.9322 61.9006 20.3501 61.1448 21.0943L21.0823 60.5406C19.5082 62.0905 19.5084 64.6038 21.0823 66.1538L56.762 101.288ZM84.7493 45.5015C81.7802 45.5015 79.3736 43.1311 79.3733 40.2076C79.3733 37.2838 81.7801 34.9126 84.7493 34.9126C87.7185 34.9126 90.1253 37.2838 90.1253 40.2076C90.125 43.1311 87.7183 45.5015 84.7493 45.5015Z"
          fill="#FC4C02"
        />
      </g>
      <defs>
        <clipPath id="clip0_18825_37000">
          <path
            d="M0 114.667C0 119.085 3.58172 122.667 8 122.667H114.667C119.085 122.667 122.667 119.085 122.667 114.667V8C122.667 3.58172 119.085 0 114.667 0H8C3.58172 0 0 3.58172 0 8V114.667Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  shopByBrand: () => (
    <svg
      width="123"
      height="123"
      viewBox="0 0 123 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18825_37008)">
        <path
          d="M0 114.667C0 119.085 3.58172 122.667 8 122.667H114.667C119.085 122.667 122.667 119.085 122.667 114.667V8C122.667 3.58172 119.085 0 114.667 0H8C3.58172 0 0 3.58172 0 8V114.667Z"
          fill="#FAF9F5"
        />
        <path
          d="M106.746 31.4273L109.869 41.8197L113.008 31.4273H119.137L112.791 46.7693V55.3693H106.98V46.7693L100.617 31.4273H106.746Z"
          fill="#FC4C02"
        />
        <path
          d="M93.5683 45.1907H88.5251L88.4917 41.4086H92.5664C93.2455 41.4086 93.7799 41.3099 94.1695 41.1126C94.5592 40.9043 94.8375 40.6029 95.0045 40.2082C95.1826 39.8136 95.2717 39.3203 95.2717 38.7283C95.2717 38.0486 95.1826 37.5005 95.0045 37.0839C94.8263 36.6673 94.5425 36.3659 94.1528 36.1795C93.7743 35.9822 93.2789 35.8835 92.6666 35.8835H90.6626V55.3693H84.9515V31.4273H92.6666C93.9691 31.4273 95.1325 31.5643 96.1567 31.8384C97.181 32.1015 98.0493 32.5071 98.7618 33.0552C99.4855 33.6033 100.037 34.294 100.415 35.1271C100.794 35.9493 100.983 36.9195 100.983 38.0377C100.983 39.0133 100.799 39.9287 100.432 40.7838C100.076 41.6388 99.4576 42.3349 98.5781 42.8721C97.6986 43.3983 96.4907 43.6724 94.9544 43.6943L93.5683 45.1907ZM93.3679 55.3693H87.1057L89.0762 50.9295H93.3679C93.9468 50.9295 94.3977 50.8089 94.7206 50.5677C95.0434 50.3156 95.2717 49.9867 95.4053 49.5811C95.5389 49.1646 95.6056 48.7041 95.6056 48.1999C95.6056 47.586 95.5389 47.0543 95.4053 46.6048C95.2828 46.1554 95.0768 45.81 94.7874 45.5689C94.4979 45.3167 94.0916 45.1907 93.5683 45.1907H89.2766L89.31 41.4086H94.2697L95.639 42.9214C97.0975 42.8557 98.2386 43.0804 99.0624 43.5956C99.8862 44.1109 100.465 44.7905 100.799 45.6346C101.133 46.4787 101.3 47.3612 101.3 48.2821C101.3 49.8497 101.005 51.1597 100.415 52.2121C99.8361 53.2645 98.9566 54.0538 97.7766 54.58C96.5965 55.1062 95.1269 55.3693 93.3679 55.3693Z"
          fill="#FC4C02"
        />
        <path
          d="M68.6172 47.2461H63.7577V42.7899H68.6172C69.1849 42.7899 69.6414 42.6529 69.9865 42.3788C70.3428 42.1047 70.5988 41.7265 70.7547 41.2442C70.9217 40.7509 71.0052 40.1973 71.0052 39.5834C71.0052 38.9256 70.9217 38.3172 70.7547 37.7581C70.5988 37.199 70.3428 36.7496 69.9865 36.4097C69.6414 36.0589 69.1849 35.8835 68.6172 35.8835H65.8451V55.3693H60.1339V31.4273H68.6172C70.2982 31.4273 71.7455 31.7781 72.959 32.4797C74.1836 33.1813 75.1243 34.146 75.7812 35.3738C76.4492 36.5906 76.7831 37.9828 76.7831 39.5505C76.7831 41.0962 76.4492 42.4446 75.7812 43.5956C75.1243 44.7467 74.1836 45.6456 72.959 46.2924C71.7455 46.9282 70.2982 47.2461 68.6172 47.2461Z"
          fill="#FC4C02"
        />
        <path
          d="M58.5292 41.6059V45.2236C58.5292 46.9447 58.3121 48.4575 57.878 49.762C57.4438 51.0665 56.8259 52.1628 56.0243 53.0508C55.2228 53.9277 54.2709 54.591 53.1687 55.0404C52.0777 55.4789 50.8642 55.6982 49.5283 55.6982C48.1812 55.6982 46.9566 55.4789 45.8544 55.0404C44.7523 54.591 43.8004 53.9277 42.9989 53.0508C42.1973 52.1628 41.5794 51.0665 41.1452 49.762C40.711 48.4575 40.494 46.9447 40.494 45.2236V41.6059C40.494 39.8848 40.711 38.3665 41.1452 37.051C41.5794 35.7356 42.1917 34.6393 42.9822 33.7623C43.7837 32.8853 44.7356 32.2221 45.8377 31.7726C46.9399 31.3232 48.1645 31.0984 49.5116 31.0984C50.8475 31.0984 52.0666 31.3232 53.1687 31.7726C54.282 32.2221 55.2339 32.8853 56.0243 33.7623C56.8148 34.6393 57.4271 35.7356 57.8613 37.051C58.3066 38.3665 58.5292 39.8848 58.5292 41.6059ZM52.7346 45.2236V41.5731C52.7346 40.4987 52.6678 39.5834 52.5342 38.827C52.4006 38.0706 52.2002 37.4567 51.933 36.9853C51.6658 36.5139 51.3318 36.1686 50.931 35.9493C50.5303 35.7301 50.0571 35.6204 49.5116 35.6204C48.9438 35.6204 48.4595 35.7301 48.0588 35.9493C47.658 36.1686 47.324 36.5139 47.0568 36.9853C46.8007 37.4567 46.6115 38.0706 46.489 38.827C46.3666 39.5834 46.3053 40.4987 46.3053 41.5731V45.2236C46.3053 46.2869 46.3666 47.1968 46.489 47.9532C46.6115 48.6987 46.8007 49.3126 47.0568 49.7949C47.324 50.2773 47.6635 50.6335 48.0755 50.8637C48.4874 51.083 48.9716 51.1926 49.5283 51.1926C50.0627 51.1926 50.5303 51.083 50.931 50.8637C51.343 50.6335 51.6769 50.2773 51.933 49.7949C52.2002 49.3126 52.4006 48.6987 52.5342 47.9532C52.6678 47.1968 52.7346 46.2869 52.7346 45.2236Z"
          fill="#FC4C02"
        />
        <path
          d="M35.0822 40.9317V45.3715H25.2296V40.9317H35.0822ZM27.1 31.4273V55.3693H21.3888V31.4273H27.1ZM38.9398 31.4273V55.3693H33.2286V31.4273H38.9398Z"
          fill="#FC4C02"
        />
        <path
          d="M14.1223 49.0056C14.1223 48.6329 14.0833 48.2985 14.0054 48.0025C13.9386 47.6956 13.7994 47.4106 13.5879 47.1475C13.3875 46.8844 13.0814 46.6213 12.6694 46.3582C12.2575 46.0841 11.7064 45.7991 11.0162 45.5031C10.1478 45.1523 9.29617 44.7577 8.4612 44.3192C7.62624 43.8697 6.87477 43.349 6.20679 42.757C5.54995 42.1541 5.02114 41.4525 4.62036 40.6522C4.21957 39.841 4.01918 38.8982 4.01918 37.8239C4.01918 36.7934 4.21957 35.8671 4.62036 35.0449C5.03227 34.2118 5.59448 33.5047 6.30699 32.9237C7.03063 32.3317 7.88229 31.8823 8.86199 31.5753C9.84168 31.2574 10.9104 31.0984 12.0683 31.0984C13.6046 31.0984 14.9572 31.4054 16.1262 32.0193C17.3063 32.6222 18.2247 33.4828 18.8816 34.6009C19.5496 35.7081 19.8835 37.0182 19.8835 38.531H14.1891C14.1891 37.928 14.1111 37.3964 13.9553 36.9359C13.7994 36.4755 13.5545 36.1138 13.2205 35.8507C12.8977 35.5876 12.469 35.456 11.9347 35.456C11.4559 35.456 11.0496 35.5656 10.7156 35.7849C10.3928 36.0041 10.1478 36.3001 9.98084 36.6728C9.81385 37.0346 9.73035 37.4347 9.73035 37.8732C9.73035 38.235 9.81385 38.5639 9.98084 38.8599C10.1478 39.1449 10.3761 39.4135 10.6655 39.6656C10.9661 39.9177 11.3112 40.1589 11.7009 40.3891C12.1017 40.6193 12.5303 40.8441 12.9867 41.0633C14.0889 41.4689 15.063 41.9239 15.9091 42.4281C16.7663 42.9214 17.4844 43.486 18.0633 44.1218C18.6422 44.7467 19.0764 45.4593 19.3659 46.2595C19.6665 47.0598 19.8167 47.9642 19.8167 48.9727C19.8167 50.047 19.6386 51.0008 19.2824 51.8339C18.9372 52.6671 18.4307 53.3741 17.7627 53.9552C17.0948 54.5252 16.2876 54.9582 15.3413 55.2542C14.4062 55.5502 13.3485 55.6982 12.1685 55.6982C11.0886 55.6982 10.0254 55.5447 8.97888 55.2378C7.94352 54.9199 7.00279 54.4375 6.1567 53.7907C5.32173 53.133 4.65376 52.2943 4.15278 51.2748C3.6518 50.2444 3.40131 49.0221 3.40131 47.6079H9.14588C9.14588 48.3095 9.20154 48.9015 9.31287 49.3838C9.4242 49.8662 9.59676 50.2553 9.83055 50.5513C10.0755 50.8363 10.3872 51.0446 10.7657 51.1762C11.1442 51.2968 11.6118 51.3571 12.1685 51.3571C12.6806 51.3571 13.0758 51.2529 13.3541 51.0446C13.6436 50.8254 13.844 50.5404 13.9553 50.1896C14.0666 49.8278 14.1223 49.4331 14.1223 49.0056Z"
          fill="#FC4C02"
        />
        <path
          d="M107.193 30.8366L109.869 39.7416L112.56 30.8366H120.028L113.39 46.8856V55.9602H106.379V46.8851L99.7236 30.8366H107.193ZM100.617 31.4274L106.979 46.7697V55.3694H112.79V46.7697L119.136 31.4274H113.007L109.868 41.8198L106.745 31.4274H100.617Z"
          fill="#FC4C02"
        />
        <path
          d="M84.3516 30.8366H92.6667V31.4274H84.9516V55.3694H93.368L93.6944 55.3665C95.2017 55.3377 96.4875 55.1075 97.5516 54.6759L97.7766 54.5801C98.8828 54.0869 99.7247 53.3623 100.303 52.4067L100.415 52.2122C100.968 51.2257 101.262 50.0126 101.296 48.5733L101.3 48.2825C101.3 47.3616 101.133 46.4789 100.799 45.6348C100.465 44.7907 99.886 44.111 99.0622 43.5957C98.7612 43.4075 98.4178 43.2587 98.0321 43.148C98.2262 43.0653 98.4086 42.9737 98.5782 42.8722C99.4575 42.3351 100.075 41.6391 100.432 40.7842C100.753 40.0359 100.934 39.2413 100.974 38.4007L100.983 38.0378C100.983 36.9198 100.794 35.9496 100.415 35.1275C100.037 34.2944 99.4852 33.6037 98.7616 33.0556C98.1382 32.576 97.3954 32.2052 96.5333 31.9438L96.1565 31.8388C95.2603 31.599 94.2576 31.4637 93.1483 31.4338L92.6667 31.4274V30.8366C94.0107 30.8366 95.2286 30.9777 96.3141 31.2682H96.3136C97.3995 31.5478 98.3417 31.9842 99.1267 32.5871H99.1272C99.9302 33.1953 100.543 33.9635 100.961 34.8835C101.382 35.7983 101.583 36.8551 101.583 38.0378L101.581 38.2339C101.557 39.2123 101.359 40.1404 100.984 41.0138C100.64 41.8359 100.086 42.521 99.3411 43.0719L99.3839 43.0972C100.308 43.6755 100.975 44.4515 101.358 45.4201C101.719 46.3337 101.9 47.2895 101.9 48.2825L101.896 48.5865C101.86 50.0941 101.551 51.4042 100.942 52.4932C100.296 53.6667 99.315 54.5428 98.0239 55.1184C96.7436 55.6893 95.1834 55.9602 93.368 55.9602H84.3516V30.8366ZM95.0057 48.2C95.0057 47.6977 94.9572 47.2727 94.8692 46.9185L94.8294 46.7708L94.8258 46.7581C94.7396 46.4414 94.6122 46.2259 94.4643 46.079L94.3999 46.0202L94.3946 46.0156L94.3899 46.0115C94.2621 45.9002 94.0573 45.8079 93.7208 45.7865L93.5684 45.7819H91.2627V50.3388H93.368V50.9296H90.6627V45.1911H93.5684C94.0915 45.1911 94.4978 45.3169 94.7872 45.569C95.0766 45.8102 95.2829 46.1558 95.4053 46.6052C95.5389 47.0546 95.6057 47.5862 95.6057 48.2L95.6022 48.3869C95.5876 48.8186 95.5222 49.2167 95.4053 49.5812L95.3503 49.7295C95.2127 50.0677 95.0029 50.3472 94.7204 50.5679C94.4379 50.7789 94.0574 50.8975 93.579 50.9239L93.368 50.9296V50.3388C93.8684 50.3388 94.1729 50.2335 94.3553 50.0982C94.5754 49.9239 94.7348 49.6986 94.8329 49.4035C94.9454 49.0526 95.0057 48.653 95.0057 48.2ZM94.6676 38.4976C94.6522 38.0525 94.5912 37.704 94.4995 37.4389L94.4514 37.3131C94.3418 37.0568 94.1863 36.8797 93.9815 36.7592L93.8907 36.7113L93.8813 36.7067L93.8719 36.7015C93.6419 36.5816 93.3154 36.498 92.8665 36.4788L92.6667 36.4748H91.2627V40.8182H92.5665C93.1945 40.8182 93.6198 40.7246 93.8907 40.5886C94.1583 40.4436 94.3383 40.2456 94.4503 39.981L94.4561 39.9683C94.59 39.6717 94.6717 39.2665 94.6717 38.7284L94.6676 38.4976Z"
          fill="#FC4C02"
        />
        <path
          d="M59.5334 30.8366H68.6166V31.4274H60.1334V55.3694H65.8446V47.2462H68.6166C70.2977 47.2462 71.745 46.9283 72.9585 46.2925C74.1831 45.6457 75.1241 44.7468 75.781 43.5957C76.4072 42.5166 76.7397 41.2639 76.7788 39.8379L76.7829 39.5506C76.7829 37.983 76.4489 36.5907 75.781 35.3739C75.1241 34.1461 74.1831 33.1814 72.9585 32.4798C71.745 31.7782 70.2977 31.4274 68.6166 31.4274V30.8366C70.3826 30.8366 71.9381 31.2058 73.2596 31.9692H73.2602C74.5797 32.7251 75.5988 33.7692 76.3083 35.0929C77.0297 36.407 77.3829 37.8981 77.3829 39.5506L77.3782 39.8541C77.3368 41.3625 76.9842 42.713 76.3019 43.8888L76.3013 43.8883C75.5865 45.1393 74.5621 46.1157 73.2421 46.8129L73.2403 46.8141C71.9228 47.5044 70.3743 47.8371 68.6166 47.8371H66.4446V55.9602H59.5334V30.8366ZM70.4049 39.5835C70.4049 39.0511 70.3454 38.5623 70.2309 38.1145L70.1788 37.9247L70.177 37.9201L70.1758 37.9149C70.0596 37.4981 69.8853 37.1775 69.6655 36.934L69.5688 36.8342L69.5618 36.8279L69.5553 36.8209C69.3668 36.6294 69.1195 36.5079 68.7719 36.4805L68.6166 36.4748H66.4446V42.1995H68.6166V42.7903H65.8446V35.8839H68.6166C69.1844 35.8839 69.6409 36.0593 69.986 36.4101C70.3422 36.75 70.5983 37.1995 70.7542 37.7585C70.9211 38.3175 71.0049 38.9258 71.0049 39.5835L71.0008 39.8108C70.9826 40.3348 70.9003 40.8129 70.7542 41.2446C70.5983 41.7268 70.3422 42.1049 69.986 42.3789C69.684 42.6188 69.2966 42.7534 68.8241 42.7834L68.6166 42.7903V42.1995C69.0864 42.1995 69.3977 42.087 69.6092 41.9191L69.6127 41.9162L69.6169 41.9133C69.8652 41.7222 70.0579 41.4501 70.1823 41.0651L70.1846 41.0576H70.1852C70.3285 40.6343 70.4049 40.145 70.4049 39.5835Z"
          fill="#FC4C02"
        />
        <path
          d="M58.529 41.6062C58.529 39.8852 58.3063 38.3665 57.861 37.051C57.454 35.8177 56.8902 34.777 56.17 33.9291L56.0241 33.7623C55.2831 32.9401 54.3999 32.3059 53.3751 31.8595L53.1682 31.7729C52.135 31.3516 50.9991 31.1277 49.7604 31.1013L49.5114 31.0984C48.1643 31.0984 46.9397 31.3235 45.8375 31.7729L45.6324 31.8595C44.6168 32.3059 43.7331 32.9401 42.9816 33.7623C42.1912 34.6393 41.5789 35.7356 41.1447 37.051C40.7105 38.3665 40.4937 39.8851 40.4937 41.6062V45.2238L40.4961 45.5441C40.5215 47.1331 40.7377 48.5394 41.1447 49.7623C41.5789 51.0667 42.1971 52.1631 42.9986 53.051C43.8001 53.9279 44.7519 54.591 45.8539 55.0404C46.9561 55.4789 48.1808 55.6982 49.5278 55.6982C50.8637 55.6982 52.0772 55.4789 53.1682 55.0404C54.2015 54.6191 55.1027 54.0097 55.8718 53.2126L56.0241 53.051C56.7756 52.2185 57.3657 51.2027 57.7942 50.0041L57.8775 49.7623C58.2845 48.5394 58.5006 47.1331 58.5261 45.5441L58.529 45.2238V41.6062ZM52.1341 41.5733C52.1341 40.5207 52.0683 39.6407 51.9425 38.9279C51.816 38.2118 51.6322 37.6676 51.4087 37.2732C51.2131 36.9282 50.9895 36.6881 50.7454 36.5289L50.6393 36.466C50.3432 36.304 49.9742 36.2116 49.5114 36.2116C49.0216 36.2116 48.6428 36.3059 48.35 36.466C48.066 36.6214 47.8064 36.876 47.5836 37.2668C47.3702 37.6608 47.1967 38.2046 47.0809 38.9199C46.9649 39.636 46.9051 40.5188 46.9051 41.5733V45.2238L46.908 45.607C46.9211 46.4829 46.9795 47.2323 47.0809 47.8589C47.1963 48.5615 47.3699 49.1079 47.586 49.5165C47.8074 49.9145 48.0708 50.1798 48.3659 50.3462C48.6741 50.509 49.0547 50.6018 49.5278 50.6018V51.1926C48.9713 51.1926 48.4871 51.0829 48.0752 50.8637C47.6634 50.6336 47.3235 50.2775 47.0563 49.7952C46.8003 49.3129 46.611 48.6988 46.4885 47.9535C46.3814 47.2916 46.3214 46.5119 46.308 45.615L46.3051 45.2238V41.5733C46.3051 40.499 46.366 39.5834 46.4885 38.827C46.611 38.0706 46.8002 37.4567 47.0563 36.9853C47.2901 36.5728 47.5751 36.2567 47.9112 36.0373L48.0582 35.9496C48.459 35.7304 48.9436 35.6207 49.5114 35.6207L49.7124 35.6254C50.1739 35.6493 50.5798 35.7578 50.9305 35.9496C51.3313 36.1688 51.6653 36.5139 51.9325 36.9853C52.1997 37.4567 52.4001 38.0706 52.5337 38.827C52.6673 39.5834 52.7341 40.499 52.7341 41.5733V45.2238L52.7311 45.615C52.7165 46.5119 52.6506 47.2916 52.5337 47.9535C52.4001 48.6988 52.1996 49.3129 51.9325 49.7952C51.6765 50.2774 51.3424 50.6336 50.9305 50.8637C50.5298 51.083 50.0621 51.1926 49.5278 51.1926V50.6018C49.9747 50.6018 50.3371 50.5109 50.634 50.3497C50.9298 50.1844 51.1893 49.9199 51.401 49.5211L51.4057 49.5119C51.6323 49.1029 51.8162 48.5557 51.9425 47.852C52.0684 47.139 52.134 46.265 52.1341 45.2238V41.5733ZM59.129 45.2238L59.1261 45.5527C59.0999 47.1882 58.8771 48.655 58.4476 49.9458C57.9917 51.3154 57.3364 52.4862 56.4724 53.4434L56.47 53.4463C55.6089 54.3884 54.583 55.103 53.3979 55.5863L53.395 55.5874C52.223 56.0584 50.9311 56.289 49.5278 56.289C48.2022 56.289 46.9748 56.0864 45.8522 55.6734L45.6295 55.588L45.6242 55.5863C44.5132 55.1331 43.5422 54.4766 42.7156 53.6199L42.5527 53.4463L42.5498 53.4434C41.6858 52.4862 41.0304 51.3154 40.5746 49.9458C40.1164 48.5691 39.8938 46.9921 39.8937 45.2238V41.6062C39.8937 39.8376 40.1163 38.255 40.574 36.8681C41.0292 35.4891 41.6786 34.3177 42.5328 33.37L42.5357 33.3671C43.3969 32.4249 44.4227 31.7098 45.6078 31.2265C46.7916 30.7438 48.0957 30.5076 49.5114 30.5076C50.9166 30.5076 52.2148 30.7441 53.3979 31.2265H53.3973C54.519 31.6796 55.4918 32.3369 56.3106 33.1957L56.4729 33.37C57.3271 34.3177 57.9766 35.4891 58.4318 36.8681H58.4312C58.9002 38.2555 59.129 39.838 59.129 41.6062V45.2238Z"
          fill="#FC4C02"
        />
        <path
          d="M27.0988 31.4274H21.3877V55.3694H27.0988V45.3717H33.2278V55.3694H38.9389V31.4274H33.2278V40.9319H27.0988V31.4274ZM39.539 55.9602H32.6278V45.9625H27.6988V55.9602H20.7877V30.8366H27.6988V40.341H32.6278V30.8366H39.539V55.9602Z"
          fill="#FC4C02"
        />
        <path
          d="M13.523 49.0059C13.523 48.7561 13.5031 48.5341 13.4668 48.3383L13.4252 48.1508L13.4217 48.1387L13.4193 48.1266C13.3789 47.9409 13.2997 47.762 13.1744 47.5883L13.1181 47.5144L13.1129 47.5081L13.1082 47.5017C12.9829 47.3373 12.7806 47.1493 12.4789 46.9432L12.3435 46.8538L12.3388 46.8509L12.3342 46.8474C11.9639 46.6011 11.449 46.3329 10.7773 46.0449V46.0443C10.0051 45.732 9.24574 45.3864 8.49976 45.0063L8.17925 44.8407L8.17397 44.8379C7.40966 44.4264 6.70915 43.956 6.07396 43.4266L5.80618 43.1964L5.79798 43.1894C5.17627 42.6188 4.66078 41.9654 4.25168 41.2324L4.08293 40.9133L4.08117 40.9104C3.63385 40.0049 3.41968 38.9709 3.41965 37.8242C3.41965 36.7168 3.63556 35.7011 4.08 34.7893L4.08117 34.7864C4.5297 33.8792 5.14483 33.1049 5.92396 32.4693L6.07337 32.3505C6.82665 31.7657 7.69612 31.3215 8.67495 31.0142L8.87183 30.9525C9.86366 30.6541 10.9306 30.5076 12.0687 30.5076C13.6877 30.5076 15.1406 30.8314 16.4094 31.4977H16.4088C17.6842 32.1506 18.6846 33.087 19.3983 34.2995C20.1302 35.5128 20.484 36.9308 20.484 38.531V39.1218H13.5898V38.531C13.5898 37.9768 13.5177 37.5102 13.3865 37.1226C13.2772 36.7997 13.1221 36.5605 12.9306 36.3841L12.8463 36.3119L12.8422 36.3091L12.8387 36.3056C12.6502 36.152 12.3691 36.0471 11.9351 36.0471C11.5517 36.0471 11.2669 36.1338 11.0492 36.2768C10.8266 36.4299 10.654 36.6362 10.5306 36.9114L10.5277 36.9172C10.3997 37.1945 10.3308 37.5103 10.3308 37.8732C10.3308 38.138 10.3903 38.3643 10.5013 38.5644C10.6307 38.7853 10.8137 39.0045 11.0603 39.2199C11.3312 39.4466 11.647 39.6677 12.0101 39.8822C12.3892 40.0998 12.7958 40.313 13.2301 40.5221C14.344 40.9339 15.3391 41.3984 16.2119 41.9178C17.1152 42.4376 17.8845 43.0397 18.5106 43.7272H18.51C19.1397 44.4078 19.6135 45.1849 19.9291 46.0547C20.2584 46.9313 20.4172 47.907 20.4172 48.973L20.4084 49.3948C20.3669 50.3678 20.1788 51.2595 19.8354 52.0627C19.4564 52.9752 18.898 53.7563 18.1608 54.3977L18.1561 54.4017C17.4198 55.0301 16.5388 55.4986 15.5252 55.8159L15.5258 55.8165C14.5207 56.1346 13.3992 56.289 12.1689 56.289C11.0304 56.289 9.90938 56.1268 8.80796 55.8038L8.80093 55.802C7.76685 55.4845 6.81864 55.0119 5.9597 54.385L5.78919 54.2575L5.78568 54.2546L5.78216 54.2523C4.92907 53.5803 4.24122 52.7379 3.71613 51.735L3.61301 51.5325L3.61242 51.5301C3.06463 50.4034 2.80206 49.0898 2.80206 47.6079V47.0171H9.74664V47.6079L9.74898 47.8548C9.76063 48.4166 9.81244 48.8804 9.8984 49.2528C9.99426 49.6682 10.1337 49.967 10.2951 50.176C10.4645 50.3709 10.6803 50.5179 10.9572 50.6156C11.2568 50.7101 11.6555 50.7662 12.1689 50.7662V51.3571C11.682 51.357 11.2633 51.3109 10.9127 51.2186L10.7662 51.1765C10.3877 51.0449 10.0759 50.8366 9.83101 50.5516C9.62646 50.2926 9.46897 49.962 9.35816 49.5604L9.31363 49.3838C9.2023 48.9015 9.14664 48.3095 9.14664 47.6079H3.40207C3.40207 49.022 3.65226 50.2447 4.15324 51.2751C4.6542 52.2945 5.32228 53.133 6.15716 53.7907C7.00326 54.4375 7.94428 54.9199 8.97964 55.2378C10.026 55.5447 11.0891 55.6982 12.1689 55.6982C13.3489 55.6982 14.4067 55.5504 15.3418 55.2545C16.229 54.977 16.9938 54.5786 17.6363 54.0602L17.7635 53.9552C18.4313 53.3742 18.9377 52.6672 19.2828 51.8342C19.5946 51.1052 19.77 50.2836 19.809 49.37L19.8172 48.973C19.8172 48.0906 19.7022 47.2877 19.4721 46.5647L19.3666 46.2595C19.1134 45.5593 18.7493 44.926 18.2744 44.3601L18.0641 44.1218C17.4852 43.486 16.7668 42.9217 15.9096 42.4284C15.0635 41.9242 14.0896 41.4689 12.9875 41.0633C12.6451 40.8989 12.3182 40.7314 12.0072 40.5608L11.7013 40.3894C11.3117 40.1592 10.9665 39.918 10.666 39.6659C10.3766 39.4138 10.1486 39.1448 9.9816 38.8599C9.81461 38.5639 9.73082 38.235 9.73082 37.8732C9.73082 37.4348 9.81466 37.0348 9.9816 36.6731C10.1277 36.347 10.3332 36.0792 10.5986 35.8706L10.7164 35.7852C11.0503 35.5659 11.4565 35.4563 11.9351 35.4563L12.1308 35.4621C12.5752 35.4909 12.9388 35.6208 13.2213 35.8509C13.5551 36.114 13.8002 36.4759 13.956 36.9362C14.1118 37.3966 14.1898 37.9282 14.1898 38.531H19.884C19.884 37.0182 19.55 35.7084 18.8821 34.6012C18.2663 33.5529 17.4206 32.7307 16.3449 32.1353L16.127 32.0193C14.958 31.4054 13.6051 31.0984 12.0687 31.0984C10.9109 31.0984 9.84212 31.2577 8.86245 31.5756L8.50093 31.6973C7.67182 31.9971 6.94086 32.4061 6.30775 32.924C5.59526 33.505 5.03274 34.2118 4.62082 35.0449C4.22005 35.8671 4.01965 36.7937 4.01965 37.8242L4.02199 38.0238C4.04548 39.0156 4.24509 39.892 4.62082 40.6525C5.0216 41.4527 5.55077 42.1544 6.20755 42.7573C6.87544 43.3492 7.62684 43.8698 8.46167 44.3192C9.29664 44.7577 10.1486 45.1523 11.017 45.5031C11.7071 45.799 12.258 46.0841 12.6699 46.3582C13.0818 46.6213 13.3883 46.8844 13.5887 47.1475C13.8001 47.4105 13.9391 47.6956 14.0058 48.0025C14.0838 48.2985 14.123 48.6332 14.123 49.0059L14.1201 49.1646C14.1079 49.5314 14.0534 49.8733 13.956 50.1898C13.8447 50.5405 13.6443 50.8257 13.3549 51.0449C13.0765 51.2532 12.681 51.3571 12.1689 51.3571V50.7662C12.6085 50.7662 12.8563 50.6754 12.9916 50.5741C13.1794 50.431 13.308 50.2496 13.383 50.0133C13.4742 49.7151 13.523 49.3807 13.523 49.0059Z"
          fill="#FC4C02"
        />
        <path
          d="M106.984 91.4093H101.352L101.394 85.8012H106.984C108.039 85.8012 108.896 85.5727 109.557 85.1157C110.232 84.6588 110.732 83.9041 111.055 82.8517C111.378 81.7854 111.54 80.3661 111.54 78.5936V73.9617C111.54 72.6324 111.449 71.5107 111.266 70.5968C111.097 69.6829 110.83 68.949 110.464 68.3951C110.099 67.8412 109.614 67.4396 109.009 67.1904C108.404 66.9273 107.687 66.7957 106.857 66.7957H101.246V61.1668H106.857C108.657 61.1668 110.289 61.4576 111.751 62.0392C113.228 62.6069 114.5 63.4516 115.569 64.5732C116.638 65.681 117.461 67.0242 118.037 68.6028C118.614 70.1814 118.902 71.9815 118.902 74.0033V78.5936C118.902 80.6015 118.614 82.4016 118.037 83.9941C117.461 85.5727 116.638 86.9159 115.569 88.0237C114.514 89.1314 113.256 89.9761 111.793 90.5577C110.345 91.1255 108.742 91.4093 106.984 91.4093ZM105.571 61.1668V91.4093H98.3565V61.1668H105.571Z"
          fill="#FC4C02"
        />
        <path
          d="M95.9078 61.1668V91.4093H88.7148L81.0155 72.5908V91.4093H73.8014V61.1668H81.0155L88.7148 79.9853V61.1668H95.9078Z"
          fill="#FC4C02"
        />
        <path
          d="M60.9751 67.5227L55.2586 91.4093H47.4961L56.9672 61.1668H61.8188L60.9751 67.5227ZM65.447 91.4093L59.7305 67.5227L58.7813 61.1668H63.7173L73.2095 91.4093H65.447ZM65.679 80.1307V85.7596H52.3688V80.1307H65.679Z"
          fill="#FC4C02"
        />
        <path
          d="M26.6111 61.1668H37.1158C39.169 61.1668 40.9479 61.513 42.4526 62.2053C43.9573 62.8977 45.1104 63.9224 45.912 65.2794C46.7276 66.6365 47.1354 68.312 47.1354 70.306C47.1354 72.0369 46.9104 73.484 46.4604 74.6472C46.0245 75.8103 45.4057 76.7727 44.6042 77.5343C43.8026 78.2821 42.8604 78.8983 41.7776 79.3829L39.4362 80.733H31.1885L31.1463 75.1041H36.9471C37.608 75.1041 38.1565 74.9379 38.5924 74.6056C39.0284 74.2733 39.3518 73.8025 39.5627 73.1932C39.7877 72.5701 39.9002 71.8292 39.9002 70.9707C39.9002 70.0983 39.7948 69.3506 39.5838 68.7274C39.3729 68.1043 39.0635 67.6266 38.6557 67.2942C38.2619 66.9619 37.7487 66.7957 37.1158 66.7957H33.8252V91.4093H26.6111V61.1668ZM40.2166 91.4093L34.7744 78.0328L42.4104 77.9913L47.9581 91.0978V91.4093H40.2166Z"
          fill="#FC4C02"
        />
        <path
          d="M14.6494 78.5521H8.27905L8.23686 73.7748H13.3838C14.2416 73.7748 14.9166 73.6501 15.4088 73.4009C15.901 73.1378 16.2525 72.757 16.4635 72.2585C16.6885 71.76 16.801 71.1369 16.801 70.3891C16.801 69.5306 16.6885 68.8382 16.4635 68.312C16.2385 67.7858 15.8799 67.405 15.3877 67.1696C14.9096 66.9204 14.2838 66.7957 13.5103 66.7957H10.9791V91.4093H3.76495V61.1668H13.5103C15.1557 61.1668 16.6252 61.3399 17.919 61.6861C19.2127 62.0184 20.3096 62.5308 21.2096 63.2231C22.1237 63.9155 22.8198 64.7879 23.2979 65.8403C23.776 66.8788 24.0151 68.1043 24.0151 69.5167C24.0151 70.7491 23.7831 71.9054 23.319 72.9855C22.869 74.0656 22.0885 74.9449 20.9776 75.6234C19.8666 76.2881 18.3408 76.6342 16.4002 76.6619L14.6494 78.5521ZM14.3963 91.4093H6.48607L8.97514 85.8012H14.3963C15.1275 85.8012 15.6971 85.6488 16.1049 85.3442C16.5127 85.0257 16.801 84.6103 16.9697 84.0979C17.1385 83.5717 17.2229 82.9902 17.2229 82.3532C17.2229 81.5777 17.1385 80.9061 16.9697 80.3384C16.815 79.7707 16.5549 79.3345 16.1893 79.0298C15.8236 78.7113 15.3103 78.5521 14.6494 78.5521H9.22827L9.27046 73.7748H15.5353L17.265 75.6857C19.1072 75.6026 20.5487 75.8865 21.5893 76.5373C22.6299 77.1881 23.3612 78.0467 23.7831 79.1129C24.2049 80.1792 24.4159 81.2939 24.4159 82.457C24.4159 84.4372 24.0432 86.092 23.2979 87.4213C22.5666 88.7506 21.4557 89.7476 19.9651 90.4123C18.4744 91.077 16.6182 91.4093 14.3963 91.4093Z"
          fill="#FC4C02"
        />
        <path
          d="M97.757 60.5759H106.858V61.1667H98.357V91.4092H106.984L107.312 91.4057C108.833 91.3747 110.236 91.1266 111.52 90.6609L111.794 90.5576C113.256 89.976 114.515 89.1313 115.57 88.0235C116.638 86.9158 117.461 85.5725 118.038 83.994C118.578 82.501 118.865 80.8255 118.899 78.9674L118.902 78.5935V74.0031C118.902 72.1079 118.649 70.4074 118.142 68.9015L118.038 68.6027C117.497 67.1228 116.74 65.8498 115.767 64.7837L115.57 64.5731C114.501 63.4515 113.228 62.6068 111.752 62.0391C110.38 61.4938 108.861 61.2042 107.193 61.1701L106.858 61.1667V60.5759C108.721 60.5759 110.428 60.8768 111.969 61.4886H111.97C113.528 62.0879 114.876 62.9819 116.007 64.1687H116.007C117.137 65.3409 118 66.7556 118.602 68.4025C119.206 70.0568 119.502 71.9268 119.502 74.0031V78.5935L119.499 78.9784C119.464 80.8896 119.168 82.6299 118.602 84.1924L118.602 84.1942C118 85.8407 117.137 87.2547 116.007 88.4268L116.007 88.4274C114.892 89.5992 113.56 90.4922 112.018 91.1051L112.015 91.1063C110.488 91.705 108.808 92 106.984 92H97.757V60.5759ZM110.941 73.9616C110.941 72.819 110.872 71.8487 110.738 71.045L110.678 70.7109L110.677 70.7069L110.676 70.7023C110.516 69.8365 110.27 69.1842 109.962 68.7169C109.698 68.3173 109.365 68.0203 108.957 67.8168L108.777 67.7355L108.767 67.7309C108.319 67.5362 107.78 67.4185 107.139 67.3922L106.858 67.3864H106.171V85.2102H106.984V85.801H105.571V66.7956H106.858C107.687 66.7956 108.405 66.9272 109.009 67.1903C109.614 67.4395 110.099 67.8411 110.465 68.395C110.83 68.9489 111.098 69.6828 111.266 70.5967C111.449 71.5106 111.541 72.6323 111.541 73.9616V78.5935L111.533 79.2415C111.498 80.7152 111.338 81.9186 111.055 82.8516C110.732 83.9039 110.233 84.6586 109.558 85.1156C108.938 85.544 108.145 85.7714 107.179 85.7982L106.984 85.801V85.2102C107.893 85.2102 108.588 85.0258 109.111 84.699L109.218 84.6286C109.746 84.2711 110.183 83.6504 110.481 82.6802C110.781 81.6916 110.941 80.337 110.941 78.5935V73.9616Z"
          fill="#FC4C02"
        />
        <path
          d="M88.7152 61.1667V79.9852L81.016 61.1667H73.8018V91.4092H81.016V72.5907L88.7152 91.4092H95.9082V61.1667H88.7152ZM96.5082 92H88.3098L81.616 75.6383V92H73.2018V91.4092H73.2095L73.2018 91.3844V60.5759H81.4208L81.5726 60.9457L88.1152 76.937V60.5759H96.5082V92Z"
          fill="#FC4C02"
        />
        <path
          d="M64.1597 60.5759L73.7826 91.235L73.8019 91.2961V91.4092H73.8371L74.0228 92H64.9718L63.6195 86.3503H57.0862L55.7339 92H46.6834L46.868 91.4092H55.2587L56.611 85.7595H64.0947L65.447 91.4092H73.2096L63.7173 61.1667H56.9673L47.7487 90.602L47.3877 89.7493L56.5243 60.5759H64.1597ZM62.7476 80.1306H57.9581L60.3528 70.1224L62.7476 80.1306ZM58.7157 79.5397H61.99L60.3528 72.6992L58.7157 79.5397Z"
          fill="#FC4C02"
        />
        <path
          d="M26.0112 60.5759H37.116V61.1667H26.6112V91.4092H33.8253V80.7329H35.8732L40.2168 91.4092H48.5583V92H39.8107L35.4677 81.3237H34.4253V92H26.0112V60.5759ZM47.1356 70.3059C47.1356 68.3119 46.7278 66.6364 45.9121 65.2793C45.1106 63.9223 43.9574 62.8976 42.4527 62.2052C40.9481 61.5129 39.1691 61.1667 37.116 61.1667V60.5759C39.1042 60.5759 40.8714 60.8903 42.4035 61.5365L42.707 61.6698C44.3161 62.4102 45.5627 63.5146 46.4284 64.9781C47.3115 66.4474 47.7356 68.2336 47.7356 70.3059C47.7356 72.0799 47.5055 73.6014 47.0231 74.8513C46.56 76.087 45.8955 77.1284 45.0209 77.9594L45.0168 77.9629C44.5634 78.3859 44.0685 78.7675 43.5338 79.1093L48.0245 89.7198L47.7485 90.602L42.782 78.8699C43.4535 78.4843 44.0617 78.0404 44.6043 77.5342C45.4059 76.7726 46.0246 75.8102 46.4606 74.647C46.9106 73.4839 47.1356 72.0368 47.1356 70.3059ZM39.3004 70.9706C39.3004 70.2456 39.2233 69.6335 39.0801 69.1254L39.015 68.9142C38.8535 68.437 38.6374 68.091 38.384 67.8474L38.2732 67.7493L38.2691 67.7459L38.2656 67.7424C38.0032 67.5209 37.6384 67.3864 37.116 67.3864H34.4253V74.5132H36.9472V75.104H33.8253V66.7956H37.116C37.7488 66.7956 38.2621 66.9618 38.6558 67.2941C39.0637 67.6264 39.373 68.1042 39.584 68.7273C39.7949 69.3504 39.9004 70.0982 39.9004 70.9706C39.9004 71.8291 39.7879 72.5699 39.5629 73.1931C39.3519 73.8023 39.0285 74.2732 38.5926 74.6055C38.1566 74.9378 37.6082 75.104 36.9472 75.104V74.5132C37.5025 74.5132 37.9141 74.3753 38.2252 74.1381C38.552 73.889 38.8149 73.523 38.9951 73.0027L38.9974 72.9952C39.1938 72.4513 39.3004 71.7807 39.3004 70.9706Z"
          fill="#FC4C02"
        />
        <path
          d="M3.16449 60.5759H13.5099V61.1667H3.76449V91.4092H14.3958C16.6176 91.4092 18.474 91.0768 19.9646 90.4122C21.4552 89.7475 22.5662 88.7505 23.2974 87.4212C24.0428 86.0918 24.4154 84.4371 24.4154 82.4569C24.4154 81.2937 24.2045 80.179 23.7826 79.1128C23.3607 78.0466 22.6294 77.188 21.5888 76.5372C21.2089 76.2996 20.7755 76.111 20.2886 75.9712C20.5334 75.8668 20.7631 75.7513 20.9771 75.6233C22.088 74.9448 22.8685 74.0654 23.3185 72.9854C23.7826 71.9053 24.0146 70.749 24.0146 69.5166C24.0146 68.1042 23.7756 66.8787 23.2974 65.8401C22.8193 64.7878 22.1232 63.9154 21.2091 63.223C20.3091 62.5307 19.2122 62.0183 17.9185 61.6859C16.6248 61.3398 15.1551 61.1667 13.5099 61.1667V60.5759C15.1942 60.5759 16.7161 60.7527 18.0697 61.1142C19.4275 61.463 20.6009 62.0063 21.5748 62.7545C22.5681 63.5069 23.3261 64.457 23.8441 65.5961C24.3649 66.7273 24.6146 68.0396 24.6146 69.5166C24.6146 70.8217 24.3686 72.0544 23.8734 73.2092C23.4223 74.292 22.6747 75.1847 21.6545 75.8893C21.6642 75.8946 21.6741 75.8995 21.6838 75.9048L21.9105 76.0387C23.0519 76.7526 23.8704 77.7074 24.3416 78.8982C24.791 80.0339 25.0154 81.2216 25.0154 82.4569C25.0154 84.5054 24.6302 86.2636 23.8248 87.7022C23.0269 89.1526 21.814 90.2364 20.2125 90.9505C18.6215 91.6599 16.6742 92 14.3958 92H3.16449V60.5759ZM16.6224 82.3531C16.6224 81.7094 16.561 81.1596 16.446 80.6972L16.3933 80.5044L16.3915 80.4981L16.3898 80.4912C16.2752 80.071 16.1032 79.7729 15.8935 79.5646L15.8015 79.4809L15.7962 79.4763L15.7915 79.4722C15.5693 79.2787 15.2157 79.1428 14.6489 79.1428H11.5786V85.2102H14.3958V85.801H10.9786V78.552H14.6489C15.3098 78.552 15.8232 78.7113 16.1888 79.0297C16.5544 79.3343 16.8146 79.7706 16.9693 80.3383C17.138 80.906 17.2224 81.5776 17.2224 82.3531C17.2224 82.99 17.138 83.5716 16.9693 84.0978C16.8005 84.6102 16.5122 85.0256 16.1044 85.3441C15.6966 85.6487 15.127 85.801 14.3958 85.801V85.2102C15.0488 85.2102 15.4721 85.0731 15.7394 84.8744C16.0456 84.6329 16.2655 84.3196 16.3986 83.9155C16.5453 83.456 16.6224 82.9369 16.6224 82.3531ZM16.2005 70.389C16.2005 69.5733 16.0923 68.9675 15.9099 68.5409C15.7592 68.1887 15.5416 67.939 15.253 67.769L15.1253 67.7009L15.1066 67.6916C14.7441 67.5027 14.2248 67.3864 13.5099 67.3864H11.5786V73.1838H13.3833C14.1904 73.1838 14.7567 73.0648 15.13 72.8769C15.5002 72.677 15.7534 72.3995 15.9093 72.031L15.9122 72.0247L15.9146 72.0183C16.0953 71.6179 16.2005 71.0829 16.2005 70.389ZM16.8005 70.389C16.8005 71.1367 16.688 71.7599 16.463 72.2584C16.2521 72.7568 15.9005 73.1377 15.4083 73.4008C14.9161 73.65 14.2411 73.7747 13.3833 73.7747H10.9786V66.7956H13.5099C14.2833 66.7956 14.9091 66.9203 15.3872 67.1695C15.8794 67.4049 16.238 67.7857 16.463 68.3119C16.688 68.8381 16.8005 69.5304 16.8005 70.389Z"
          fill="#FC4C02"
        />
      </g>
      <defs>
        <clipPath id="clip0_18825_37008">
          <path
            d="M0 114.667C0 119.085 3.58172 122.667 8 122.667H114.667C119.085 122.667 122.667 119.085 122.667 114.667V8C122.667 3.58172 119.085 0 114.667 0H8C3.58172 0 0 3.58172 0 8V114.667Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  mousePointer: ({ classname, ...props }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m13 13 6 6M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3Z"
      />
    </svg>
  ),

  paperclip: ({ classname = '', ...props }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 14.1589 14.9404"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <path
        d="M13.5589 7.04148L7.43222 13.1681C6.68166 13.9187 5.66368 14.3404 4.60222 14.3404C3.54077 14.3404 2.52279 13.9187 1.77222 13.1681C1.02166 12.4176 0.6 11.3996 0.6 10.3381C0.6 9.27669 1.02166 8.25871 1.77222 7.50815L7.89889 1.38148C8.39927 0.881108 9.07792 0.6 9.78556 0.6C10.4932 0.6 11.1718 0.881108 11.6722 1.38148C12.1726 1.88186 12.4537 2.56051 12.4537 3.26815C12.4537 3.97579 12.1726 4.65444 11.6722 5.15482L5.53889 11.2815C5.2887 11.5317 4.94938 11.6722 4.59556 11.6722C4.24174 11.6722 3.90241 11.5317 3.65222 11.2815C3.40204 11.0313 3.26148 10.692 3.26148 10.3381C3.26148 9.98433 3.40204 9.645 3.65222 9.39482L9.31222 3.74148"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  lightbulb: ({ classname = '', ...props }) => (
    <svg
      width="57"
      height="58"
      viewBox="0 0 57 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classname}
      {...props}
    >
      <g clipPath="url(#clip0_16430_15201)">
        <mask id="path-2-inside-1_16430_15201" fill="white">
          <path d="M57.0664 50C57.0664 54.4183 53.4847 58 49.0664 58L7.9297 58C3.51142 58 -0.0703011 54.4183 -0.0703011 50L-0.0703011 8.12167C-0.0703011 3.70339 3.51142 0.121662 7.9297 0.121662L49.0664 0.121662C53.4847 0.121662 57.0664 3.70338 57.0664 8.12166L57.0664 50Z" />
        </mask>
        <path
          d="M49.0664 58V56.5L7.9297 56.5V58V59.5L49.0664 59.5V58ZM-0.0703011 50H1.4297L1.4297 8.12167H-0.0703011H-1.5703L-1.5703 50H-0.0703011ZM7.9297 0.121662V1.62166L49.0664 1.62166V0.121662V-1.37834L7.9297 -1.37834V0.121662ZM57.0664 8.12166H55.5664L55.5664 50H57.0664H58.5664L58.5664 8.12166H57.0664ZM49.0664 0.121662V1.62166C52.6563 1.62166 55.5664 4.53181 55.5664 8.12166H57.0664H58.5664C58.5664 2.87496 54.3131 -1.37834 49.0664 -1.37834V0.121662ZM-0.0703011 8.12167H1.4297C1.4297 4.53181 4.33985 1.62166 7.9297 1.62166V0.121662V-1.37834C2.68299 -1.37834 -1.5703 2.87497 -1.5703 8.12167H-0.0703011ZM7.9297 58V56.5C4.33985 56.5 1.4297 53.5899 1.4297 50H-0.0703011H-1.5703C-1.5703 55.2467 2.68299 59.5 7.9297 59.5V58ZM49.0664 58V59.5C54.3131 59.5 58.5664 55.2467 58.5664 50H57.0664H55.5664C55.5664 53.5898 52.6563 56.5 49.0664 56.5V58Z"
          fill="black"
          mask="url(#path-2-inside-1_16430_15201)"
        />
        <path
          d="M28.7514 6.37988C40.2252 6.37988 45.1426 14.5176 45.1426 21.8416C45.1426 27.538 41.8643 30.7931 38.5861 34.0483C36.1274 36.4896 35.3079 38.9309 35.3079 42.186H22.1949C22.1949 38.9309 21.3753 36.4896 18.9167 34.0483C15.6384 30.7931 12.3602 27.538 12.3602 21.8416C12.3602 14.5176 17.2776 6.37988 28.7514 6.37988Z"
          fill="#0072CE"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.0625 45.4414H34.0301C34.9476 45.4414 35.6914 46.1922 35.6914 47.1183V48.7951C35.6914 49.7213 34.9476 50.472 34.0301 50.472H24.0625C23.145 50.472 22.4013 49.7213 22.4013 48.7951V47.1183C22.4013 46.1922 23.145 45.4414 24.0625 45.4414Z"
          fill="#FAF9F5"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.6914 53.1353H22.4013"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.6367 0.75C13.3231 0.75 0.886719 13.3856 0.886719 29C0.886719 44.6144 13.3231 57.25 28.6367 57.25C43.9504 57.25 56.3867 44.6144 56.3867 29C56.3867 13.3856 43.9504 0.75 28.6367 0.75Z"
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_16430_15201">
          <path
            d="M57 50C57 54.4183 53.4183 58 49 58L8 58C3.58172 58 0 54.4183 0 50L0 8C0 3.58172 3.58172 0 8 0L49 0C53.4183 0 57 3.58172 57 8L57 50Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),
};

// Use the generated letter icons (all 27 letters as inline SVG with theme support)
Object.assign(IconsUnsorted, LetterIconsGenerated);

// Build a sorted map so keys are alphabetical
const Icons = Object.keys(IconsUnsorted)
  .sort((a, b) => a.localeCompare(b))
  .reduce((acc, key) => {
    acc[key] = IconsUnsorted[key];
    return acc;
  }, {});

export default Icons;
